import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  AWSDate: any
  AWSDateTime: any
}

export type AdminDersDetay = {
  readonly __typename?: 'AdminDersDetay'
  readonly adet?: Maybe<Scalars['Int']>
  readonly alt_kategori?: Maybe<Scalars['String']>
  readonly barcode?: Maybe<Scalars['String']>
  readonly ders_isim: Scalars['String']
  readonly etiket_fiyati?: Maybe<Scalars['Float']>
  readonly kategori?: Maybe<Scalars['String']>
  readonly ogretmen_adi?: Maybe<Scalars['String']>
  readonly ogretmen_id: Scalars['Int']
  readonly olusturma_tarihi?: Maybe<Scalars['String']>
  readonly resim?: Maybe<Scalars['String']>
  readonly resim_url?: Maybe<Scalars['String']>
  readonly sinif_adi?: Maybe<Scalars['String']>
  readonly sinif_ders_aktif?: Maybe<Scalars['Boolean']>
  readonly sinif_ders_id: Scalars['Int']
  readonly sinif_id: Scalars['Int']
  readonly sinif_not?: Maybe<Scalars['String']>
  readonly urun_isim?: Maybe<Scalars['String']>
  readonly yayinevi?: Maybe<Scalars['String']>
}

export type AdminSinifDetay = {
  readonly __typename?: 'AdminSinifDetay'
  readonly aktif: Scalars['Boolean']
  readonly dersler: ReadonlyArray<Maybe<AdminDersDetay>>
  readonly kategori_isim?: Maybe<Scalars['String']>
  readonly mevcut?: Maybe<Scalars['Int']>
  readonly sinif_id: Scalars['Int']
  readonly sinif_isim: Scalars['String']
  readonly toplam_adet?: Maybe<Scalars['Int']>
  readonly toplam_fiyat?: Maybe<Scalars['Float']>
}

export type Adres = {
  readonly __typename?: 'Adres'
  readonly adres?: Maybe<Scalars['String']>
  readonly baslik?: Maybe<Scalars['String']>
  readonly firma?: Maybe<Scalars['String']>
  readonly gsm?: Maybe<Scalars['String']>
  readonly id: Scalars['Int']
  readonly il?: Maybe<Il>
  readonly ilce?: Maybe<Ilce>
  readonly isim?: Maybe<Scalars['String']>
  readonly kurumsal_adres_mi?: Maybe<Scalars['Boolean']>
  readonly mahalle?: Maybe<Mahalle>
  readonly posta_kodu?: Maybe<Scalars['String']>
  readonly vergi_dairesi?: Maybe<Scalars['String']>
  readonly vergi_no?: Maybe<Scalars['String']>
}

export type AdresInput = {
  readonly adres: Scalars['String']
  readonly adres_tipi?: InputMaybe<Scalars['String']>
  readonly baslik: Scalars['String']
  readonly faks: Scalars['String']
  readonly firma?: InputMaybe<Scalars['String']>
  readonly gsm: Scalars['String']
  readonly il_id: Scalars['Int']
  readonly ilce_id: Scalars['Int']
  readonly isim: Scalars['String']
  readonly kurumsal_adres_mi?: InputMaybe<Scalars['Boolean']>
  readonly mahalle_id?: InputMaybe<Scalars['Int']>
  readonly posta_kodu: Scalars['String']
  readonly tel: Scalars['String']
  readonly vergi_dairesi?: InputMaybe<Scalars['String']>
  readonly vergi_no?: InputMaybe<Scalars['String']>
}

export type CaprazUrun = {
  readonly __typename?: 'CaprazUrun'
  readonly indirimli_birim_fiyat?: Maybe<Scalars['String']>
  readonly indirimsiz_birim_fiyat?: Maybe<Scalars['String']>
  readonly urun?: Maybe<Urun>
}

export type CaprazUrunFiltre = {
  readonly kategori?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>
  readonly marka?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>
  readonly max_fiyat?: InputMaybe<Scalars['Float']>
  readonly min_fiyat?: InputMaybe<Scalars['Float']>
  readonly sayfa?: InputMaybe<Scalars['Int']>
  readonly urunId?: InputMaybe<Scalars['Int']>
}

export type CaprazUrunResponse = {
  readonly __typename?: 'CaprazUrunResponse'
  readonly capraz_urunler?: Maybe<ReadonlyArray<Maybe<CaprazUrun>>>
  readonly urun_sayisi: Scalars['Int']
}

export type CiroResponse = {
  readonly __typename?: 'CiroResponse'
  readonly iptalKdv?: Maybe<Scalars['Float']>
  readonly iptalKdvDahil?: Maybe<Scalars['Float']>
  readonly iptalKdvHaric?: Maybe<Scalars['Float']>
  readonly iptalSiparisSayisi?: Maybe<Scalars['Int']>
  readonly tamamlananKdv?: Maybe<Scalars['Float']>
  readonly tamamlananKdvDahil?: Maybe<Scalars['Float']>
  readonly tamamlananKdvHaric?: Maybe<Scalars['Float']>
  readonly tamamlananSiparisSayisi?: Maybe<Scalars['Int']>
  readonly toplamKdv?: Maybe<Scalars['Float']>
  readonly toplamKdvDahil?: Maybe<Scalars['Float']>
  readonly toplamKdvHaric?: Maybe<Scalars['Float']>
  readonly toplamSiparisSayisi?: Maybe<Scalars['Int']>
  readonly uyeKategorileri?: Maybe<ReadonlyArray<Maybe<UyeKategori>>>
}

export type DefaultResponse = {
  readonly __typename?: 'DefaultResponse'
  readonly createdCount?: Maybe<Scalars['Int']>
  readonly dersler?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>
  readonly email?: Maybe<Scalars['String']>
  readonly errors?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
  readonly kampus_yetkilisi_id?: Maybe<Scalars['Int']>
  readonly message: Scalars['String']
  readonly okul_slug?: Maybe<Scalars['String']>
  readonly sifre?: Maybe<Scalars['String']>
  readonly silinemeyenler?: Maybe<ReadonlyArray<Maybe<SilinemeyenBilgi>>>
  readonly silinenler?: Maybe<ReadonlyArray<Maybe<SilinenBilgi>>>
  readonly sinifler?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>
  readonly success: Scalars['Boolean']
  readonly updatedCount?: Maybe<Scalars['Int']>
  readonly yetkililer?: Maybe<ReadonlyArray<Maybe<YetkiliKampusBilgisi>>>
}

export type Ders = {
  readonly __typename?: 'Ders'
  readonly ders_sira?: Maybe<Scalars['String']>
  readonly id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
  readonly renk?: Maybe<Scalars['String']>
  readonly urun_secili_gelsin?: Maybe<Scalars['Boolean']>
}

export type DersDetay = {
  readonly __typename?: 'DersDetay'
  readonly ders_adi?: Maybe<Scalars['String']>
  readonly ders_aktif?: Maybe<Scalars['Boolean']>
  readonly ders_id: Scalars['Int']
  readonly ders_rengi?: Maybe<Scalars['String']>
  readonly ders_sirasi?: Maybe<Scalars['Int']>
  readonly ogretmen?: Maybe<OgretmenDetay>
  readonly sinif_ders_id?: Maybe<Scalars['Int']>
  readonly sinif_not?: Maybe<Scalars['String']>
}

export type DersOnayInput = {
  readonly sinifdersi_ids: ReadonlyArray<Scalars['Int']>
}

export type DersOnaylaInput = {
  readonly sinifdersi_id: Scalars['Int']
  readonly sube_id: Scalars['Int']
}

export type EklenenDersDetay = {
  readonly __typename?: 'EklenenDersDetay'
  readonly adet?: Maybe<Scalars['Int']>
  readonly barcode?: Maybe<Scalars['String']>
  readonly ders_adi?: Maybe<Scalars['String']>
  readonly ders_aktif?: Maybe<Scalars['Boolean']>
  readonly ders_id: Scalars['Int']
  readonly ders_rengi?: Maybe<Scalars['String']>
  readonly ders_sirasi?: Maybe<Scalars['Int']>
  readonly ders_urunu_id?: Maybe<Scalars['Int']>
  readonly etiket_fiyati?: Maybe<Scalars['Int']>
  readonly kdv_orani?: Maybe<Scalars['Int']>
  readonly ogretmen?: Maybe<OgretmenDetay>
  readonly resim?: Maybe<Scalars['String']>
  readonly resim_url?: Maybe<Scalars['String']>
  readonly sinif_ders_id?: Maybe<Scalars['Int']>
  readonly sinif_not?: Maybe<Scalars['String']>
  readonly urun_adi?: Maybe<Scalars['String']>
  readonly urun_id?: Maybe<Scalars['Int']>
}

export type EklenenSinif = {
  readonly __typename?: 'EklenenSinif'
  readonly eklenensinif: ReadonlyArray<Maybe<EklenenSinifDetay>>
  readonly ogretmen?: Maybe<Scalars['String']>
}

export type EklenenSinifDetay = {
  readonly __typename?: 'EklenenSinifDetay'
  readonly dersler?: Maybe<ReadonlyArray<Maybe<EklenenDersDetay>>>
  readonly id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
  readonly mevcut?: Maybe<Scalars['Int']>
  readonly sinif_ders_id: Scalars['Int']
  readonly sinif_gonderim?: Maybe<Scalars['Boolean']>
}

export type ExportJob = {
  readonly __typename?: 'ExportJob'
  readonly createdAt: Scalars['AWSDateTime']
  readonly id: Scalars['ID']
  readonly resultUrl?: Maybe<Scalars['String']>
  readonly status: Scalars['String']
  readonly updatedAt: Scalars['AWSDateTime']
}

export type ExportParams = {
  readonly dateFrom?: InputMaybe<Scalars['AWSDate']>
  readonly dateTo?: InputMaybe<Scalars['AWSDate']>
  readonly slug?: InputMaybe<Scalars['String']>
  readonly userId?: InputMaybe<Scalars['ID']>
}

export type Fatura = {
  readonly __typename?: 'Fatura'
  readonly belge_kodu?: Maybe<Scalars['String']>
  readonly durum?: Maybe<Scalars['String']>
  readonly gonderi_tarihi?: Maybe<Scalars['String']>
  readonly id: Scalars['Int']
  readonly kargo_takip_no?: Maybe<Scalars['String']>
  readonly kargo_teslim_tarihi?: Maybe<Scalars['String']>
  readonly kargoya_verilme_tarihi?: Maybe<Scalars['String']>
  readonly satirlar?: Maybe<ReadonlyArray<Maybe<UrunOzet>>>
}

export type FavoriEkleInput = {
  readonly urun_id: Scalars['Int']
}

export type FavoriEkleResponse = {
  readonly __typename?: 'FavoriEkleResponse'
  readonly message: Scalars['String']
  readonly success: Scalars['Boolean']
}

export type Favoriler = {
  readonly __typename?: 'Favoriler'
  readonly favori_id?: Maybe<Scalars['Int']>
  readonly urun?: Maybe<UrunOkul>
}

export type GenelBilgiler = {
  readonly __typename?: 'GenelBilgiler'
  readonly bilgilendirme_maili_gonderildi?: Maybe<Scalars['Boolean']>
  readonly durum?: Maybe<Scalars['String']>
  readonly durum_aciklama?: Maybe<Scalars['String']>
  readonly iade_talebi?: Maybe<Scalars['String']>
  readonly iptal_tarihi?: Maybe<Scalars['String']>
  readonly order_id?: Maybe<Scalars['String']>
  readonly sepet?: Maybe<Scalars['String']>
  readonly siparis_notu?: Maybe<Scalars['String']>
  readonly tarih?: Maybe<Scalars['String']>
  readonly trans_id?: Maybe<Scalars['String']>
  readonly user?: Maybe<Scalars['String']>
}

export type IadeResponse = {
  readonly __typename?: 'IadeResponse'
  readonly kargo_takip_no: Scalars['String']
}

export type IadeSatiriInput = {
  readonly adet: Scalars['Int']
  readonly id: Scalars['Int']
}

export type IcerikSayfasi = {
  readonly __typename?: 'IcerikSayfasi'
  readonly baslik?: Maybe<Scalars['String']>
  readonly id: Scalars['Int']
  readonly metin?: Maybe<Scalars['String']>
  readonly slug?: Maybe<Scalars['String']>
}

export type Il = {
  readonly __typename?: 'Il'
  readonly id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
}

export type Ilce = {
  readonly __typename?: 'Ilce'
  readonly id: Scalars['Int']
  readonly il_id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
}

export type KampusDetay = {
  readonly __typename?: 'KampusDetay'
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
  readonly okul_id?: Maybe<Scalars['Int']>
  readonly okul_isim?: Maybe<Scalars['String']>
}

export type KampusEkleInput = {
  readonly isim: Scalars['String']
  readonly kampus_id?: InputMaybe<Scalars['Int']>
  readonly okul_id?: InputMaybe<Scalars['Int']>
}

export type KampusYetkiliDetay = {
  readonly __typename?: 'KampusYetkiliDetay'
  readonly ciro_yetkisi?: Maybe<Scalars['Boolean']>
  readonly email?: Maybe<Scalars['String']>
  readonly gsm?: Maybe<Scalars['String']>
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
  readonly kampus?: Maybe<ReadonlyArray<Maybe<KampusDetay>>>
  readonly sifre?: Maybe<Scalars['String']>
  readonly sifre_onay?: Maybe<Scalars['String']>
  readonly soyisim?: Maybe<Scalars['String']>
}

export type KampusYetkiliEkleInput = {
  readonly ciro_yetkisi?: InputMaybe<Scalars['Boolean']>
  readonly email: Scalars['String']
  readonly gsm?: InputMaybe<Scalars['String']>
  readonly isim?: InputMaybe<Scalars['String']>
  readonly kampus_yetkilisi_id?: InputMaybe<Scalars['Int']>
  readonly sifre?: InputMaybe<Scalars['String']>
  readonly sifre_onay?: InputMaybe<Scalars['String']>
  readonly soyisim?: InputMaybe<Scalars['String']>
  readonly sube_ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['Int']>>>
}

export type KargoFirm = {
  readonly __typename?: 'KargoFirm'
  readonly id: Scalars['Int']
  readonly isim: Scalars['String']
}

export type KategoriHiy = {
  readonly __typename?: 'KategoriHiy'
  readonly alt_kategoriler?: Maybe<ReadonlyArray<Maybe<KategoriHiy>>>
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
  readonly sube_id?: Maybe<Scalars['Int']>
}

export type KategoriHiyerarsisiResponse = {
  readonly __typename?: 'KategoriHiyerarsisiResponse'
  readonly kategori_hiyerarsisi?: Maybe<ReadonlyArray<Maybe<KategoriHiy>>>
  readonly yetkili_subeler: ReadonlyArray<Maybe<SubeHiy>>
}

export type KategoriMarkalarResponse = {
  readonly __typename?: 'KategoriMarkalarResponse'
  readonly kategori?: Maybe<UrunKategorisi>
  readonly markalar?: Maybe<ReadonlyArray<Maybe<Marka>>>
}

export type Kullanici = {
  readonly __typename?: 'Kullanici'
  readonly ogretmen_id: Scalars['ID']
  readonly uye_id: Scalars['ID']
  readonly yeni_eklenenler: ReadonlyArray<Maybe<ReadonlyArray<Maybe<Scalars['Int']>>>>
}

export type KullaniciEkleInput = {
  readonly ders_ids: ReadonlyArray<Scalars['Int']>
  readonly email: Scalars['String']
  readonly gsm: Scalars['String']
  readonly id?: InputMaybe<Scalars['Int']>
  readonly isim: Scalars['String']
  readonly kampus?: InputMaybe<Scalars['Int']>
  readonly sifre?: InputMaybe<Scalars['String']>
  readonly sifre_onay?: InputMaybe<Scalars['String']>
  readonly sinif_ids: ReadonlyArray<Scalars['Int']>
  readonly soyisim: Scalars['String']
}

export type LoginSession = {
  readonly __typename?: 'LoginSession'
  readonly errorMessage?: Maybe<Scalars['String']>
  readonly expire_at?: Maybe<Scalars['Int']>
  readonly token?: Maybe<Scalars['String']>
  readonly user_id?: Maybe<Scalars['Int']>
}

export type Mahalle = {
  readonly __typename?: 'Mahalle'
  readonly id: Scalars['Int']
  readonly ilce_id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
}

export type Marka = {
  readonly __typename?: 'Marka'
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
}

export type Mutation = {
  readonly __typename?: 'Mutation'
  readonly adresDuzenle?: Maybe<Adres>
  readonly adresEkle?: Maybe<Adres>
  readonly adresSil?: Maybe<Scalars['Boolean']>
  readonly dersListesiOnayDurumuGuncelle: DefaultResponse
  readonly dersListesiniOnayaGonder: DefaultResponse
  readonly favoriEkle: FavoriEkleResponse
  readonly iadeTalebiOlustur?: Maybe<IadeResponse>
  readonly kampusEkle: DefaultResponse
  readonly kampusSil: DefaultResponse
  readonly kampusYetkilisiEkle: DefaultResponse
  readonly kampusYetkilisiSil: DefaultResponse
  readonly login?: Maybe<LoginSession>
  readonly ogretmenEkle: DefaultResponse
  readonly ogretmenSil: DefaultResponse
  readonly profilGuncelle?: Maybe<Profil>
  readonly refreshToken?: Maybe<LoginSession>
  readonly sepetPaketDuzenle?: Maybe<Sepet>
  readonly sepetPaketDuzenleTest?: Maybe<Sepet>
  readonly sepetPaketEkle?: Maybe<Sepet>
  readonly sepetPaketEkleTest?: Maybe<Sepet>
  readonly sepetPaketSil?: Maybe<Sepet>
  readonly sepetPaketSilTest?: Maybe<Sepet>
  readonly sepetSatiriSil: DefaultResponse
  readonly sepetUrunDuzenle?: Maybe<Sepet>
  readonly sepetUrunDuzenleTest?: Maybe<Sepet>
  readonly sepetUrunEkle?: Maybe<Scalars['Boolean']>
  readonly sepetUrunSil?: Maybe<Sepet>
  readonly sepetUrunSilTest?: Maybe<Sepet>
  readonly sepetiBosalt?: Maybe<Sepet>
  readonly sepetiBosaltTest?: Maybe<Sepet>
  readonly sifreDegistir?: Maybe<Scalars['Boolean']>
  readonly sifreSifirla?: Maybe<Scalars['Boolean']>
  readonly sinifDersUrunuAdetGuncelleme: DefaultResponse
  readonly sinifDersUrunuNotGuncelleme: DefaultResponse
  readonly sinifDersUrunuSilme: DefaultResponse
  readonly sinifDersiEkle: DefaultResponse
  readonly sinifDersiSil: DefaultResponse
  readonly sinifDersiTopluEkle: DefaultResponse
  readonly sinifEkle: DefaultResponse
  readonly sinifListesiSil: DefaultResponse
  readonly sinifListesiTopluEkle: DefaultResponse
  readonly sinifSecimSifre: SinifSecimSifreResponse
  readonly sinifSil: DefaultResponse
  readonly sinifSubeEkle: DefaultResponse
  readonly sinifSubeSil: DefaultResponse
  readonly sinifSubeTopluEkle: DefaultResponse
  readonly sinifSubeTopluGuncelle: DefaultResponse
  readonly sinifTopluEkle: DefaultResponse
  readonly sinifTopluGuncelle: DefaultResponse
  readonly sinifUrunuSil: DefaultResponse
  readonly sinifaUrunEkle?: Maybe<SinifaUrunEkleResponse>
  readonly startExport: ExportJob
  readonly uyeMailGuncelle: DefaultResponse
  readonly yeniUye?: Maybe<LoginSession>
}

export type MutationAdresDuzenleArgs = {
  id: Scalars['Int']
  input: AdresInput
}

export type MutationAdresEkleArgs = {
  input: AdresInput
}

export type MutationAdresSilArgs = {
  id: Scalars['Int']
}

export type MutationDersListesiOnayDurumuGuncelleArgs = {
  input: DersOnayInput
}

export type MutationDersListesiniOnayaGonderArgs = {
  input: DersOnaylaInput
}

export type MutationFavoriEkleArgs = {
  input: FavoriEkleInput
}

export type MutationIadeTalebiOlusturArgs = {
  okul_slug: Scalars['String']
  satirlar?: InputMaybe<ReadonlyArray<InputMaybe<IadeSatiriInput>>>
  siparis_id: Scalars['Int']
}

export type MutationKampusEkleArgs = {
  input: KampusEkleInput
}

export type MutationKampusSilArgs = {
  id: ReadonlyArray<Scalars['Int']>
}

export type MutationKampusYetkilisiEkleArgs = {
  input: KampusYetkiliEkleInput
}

export type MutationKampusYetkilisiSilArgs = {
  id: ReadonlyArray<Scalars['Int']>
}

export type MutationLoginArgs = {
  email: Scalars['String']
  password: Scalars['String']
}

export type MutationOgretmenEkleArgs = {
  input: KullaniciEkleInput
}

export type MutationOgretmenSilArgs = {
  id: ReadonlyArray<Scalars['Int']>
}

export type MutationProfilGuncelleArgs = {
  input: ProfilInput
}

export type MutationSepetPaketDuzenleArgs = {
  okul_slug: Scalars['String']
  sinif_id: Scalars['Int']
  urunler?: InputMaybe<ReadonlyArray<InputMaybe<SepetUrunuInput>>>
}

export type MutationSepetPaketDuzenleTestArgs = {
  okul_slug: Scalars['String']
  sinif_id: Scalars['Int']
  urunler?: InputMaybe<ReadonlyArray<InputMaybe<SepetUrunuInput>>>
}

export type MutationSepetPaketEkleArgs = {
  okul_slug: Scalars['String']
  sinif_id: Scalars['Int']
  urunler?: InputMaybe<ReadonlyArray<InputMaybe<SepetUrunuInput>>>
}

export type MutationSepetPaketEkleTestArgs = {
  okul_slug: Scalars['String']
  sinif_id: Scalars['Int']
  urunler?: InputMaybe<ReadonlyArray<InputMaybe<SepetUrunuInput>>>
}

export type MutationSepetPaketSilArgs = {
  okul_slug: Scalars['String']
  sinif_id: Scalars['Int']
}

export type MutationSepetPaketSilTestArgs = {
  okul_slug: Scalars['String']
  sinif_id: Scalars['Int']
}

export type MutationSepetSatiriSilArgs = {
  id: Scalars['Int']
}

export type MutationSepetUrunDuzenleArgs = {
  okul_slug: Scalars['String']
  urun?: InputMaybe<SepetUrunuInput>
}

export type MutationSepetUrunDuzenleTestArgs = {
  okul_slug: Scalars['String']
  urun?: InputMaybe<SepetUrunuInput>
}

export type MutationSepetUrunEkleArgs = {
  okul_slug: Scalars['String']
  urun?: InputMaybe<SepetUrunuInput>
}

export type MutationSepetUrunSilArgs = {
  okul_slug: Scalars['String']
  urun_id: Scalars['Int']
}

export type MutationSepetUrunSilTestArgs = {
  okul_slug: Scalars['String']
  urun_id: Scalars['Int']
}

export type MutationSepetiBosaltArgs = {
  okul_slug: Scalars['String']
}

export type MutationSepetiBosaltTestArgs = {
  okul_slug: Scalars['String']
}

export type MutationSifreDegistirArgs = {
  new_password: Scalars['String']
}

export type MutationSinifDersUrunuAdetGuncellemeArgs = {
  input: SinifDersUrunuAdetGuncellemeInput
}

export type MutationSinifDersUrunuNotGuncellemeArgs = {
  input: SinifDersUrunuNotGuncellemeInput
}

export type MutationSinifDersUrunuSilmeArgs = {
  input: SinifDersUrunuSilmeInput
}

export type MutationSinifDersiEkleArgs = {
  input: SinifDersiEkleInput
}

export type MutationSinifDersiSilArgs = {
  id: ReadonlyArray<Scalars['Int']>
}

export type MutationSinifDersiTopluEkleArgs = {
  input: ReadonlyArray<SinifDersiEkleInput>
}

export type MutationSinifEkleArgs = {
  input: SinifEkleInput
}

export type MutationSinifListesiSilArgs = {
  id: ReadonlyArray<Scalars['Int']>
}

export type MutationSinifListesiTopluEkleArgs = {
  input: ReadonlyArray<SinifListesiEkleInput>
}

export type MutationSinifSecimSifreArgs = {
  okul_id: Scalars['Int']
  password: Scalars['String']
  sinif_id: Scalars['Int']
}

export type MutationSinifSilArgs = {
  id: ReadonlyArray<Scalars['Int']>
}

export type MutationSinifSubeEkleArgs = {
  input: SinifSubeEkleInput
}

export type MutationSinifSubeSilArgs = {
  id: ReadonlyArray<Scalars['Int']>
}

export type MutationSinifSubeTopluEkleArgs = {
  input: ReadonlyArray<SinifSubeCreateInput>
}

export type MutationSinifSubeTopluGuncelleArgs = {
  input: ReadonlyArray<SinifSubeUpdateInput>
}

export type MutationSinifTopluEkleArgs = {
  input: ReadonlyArray<SinifCreateInput>
}

export type MutationSinifTopluGuncelleArgs = {
  input: ReadonlyArray<SinifUpdateInput>
}

export type MutationSinifUrunuSilArgs = {
  id: ReadonlyArray<Scalars['Int']>
}

export type MutationSinifaUrunEkleArgs = {
  input: SinifaUrunEkleInput
}

export type MutationStartExportArgs = {
  params?: InputMaybe<ExportParams>
}

export type MutationUyeMailGuncelleArgs = {
  email: Scalars['String']
}

export type MutationYeniUyeArgs = {
  input: YeniUyeInput
}

export type OdemeBilgiler = {
  readonly __typename?: 'OdemeBilgiler'
  readonly havale_yapilacak_hesap?: Maybe<Scalars['String']>
  readonly kapida_odeme_hizmet_bedeli?: Maybe<Scalars['Float']>
  readonly kargo_takip_no_listesi?: Maybe<Scalars['String']>
  readonly kargo_ucreti?: Maybe<Scalars['String']>
  readonly kredi_karti_pos?: Maybe<Scalars['String']>
  readonly kredi_karti_vade_secenegi?: Maybe<Scalars['String']>
  readonly odeme_tipi?: Maybe<Scalars['String']>
  readonly odeme_tipi_aciklama?: Maybe<Scalars['String']>
  readonly toplam_tutar?: Maybe<Scalars['Float']>
  readonly vade_ucreti?: Maybe<Scalars['String']>
}

export type OgretmenBilgileri = {
  readonly __typename?: 'OgretmenBilgileri'
  readonly dersler?: Maybe<Scalars['String']>
  readonly email?: Maybe<Scalars['String']>
  readonly gsm?: Maybe<Scalars['String']>
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
  readonly kampus?: Maybe<Scalars['String']>
  readonly siniflar?: Maybe<Scalars['String']>
  readonly soyisim?: Maybe<Scalars['String']>
}

export type OgretmenDetay = {
  readonly __typename?: 'OgretmenDetay'
  readonly ogretmen_id: Scalars['Int']
}

export type Okul = {
  readonly __typename?: 'Okul'
  readonly active?: Maybe<Scalars['Boolean']>
  readonly alan_resimleri?: Maybe<ReadonlyArray<Maybe<OkulAlanResmi>>>
  readonly alan_resimlerini_goster?: Maybe<Scalars['Boolean']>
  readonly banner?: Maybe<Scalars['String']>
  readonly bannerlar?: Maybe<ReadonlyArray<Maybe<OkulBanner>>>
  readonly bannerlari_goster?: Maybe<Scalars['Boolean']>
  readonly capraz_urun_satis_popupi_varmi?: Maybe<Scalars['Boolean']>
  readonly capraz_urun_satisi_varmi?: Maybe<Scalars['Boolean']>
  readonly cari_ad?: Maybe<Scalars['String']>
  readonly email?: Maybe<Scalars['String']>
  readonly genel_uyari?: Maybe<Scalars['String']>
  readonly id: Scalars['Int']
  readonly indirim?: Maybe<Scalars['Float']>
  readonly indirimli_fiyat_gosterimi?: Maybe<Scalars['Boolean']>
  readonly isim: Scalars['String']
  readonly kapida_odeme_tutari?: Maybe<Scalars['Float']>
  readonly kapida_odeme_varmi?: Maybe<Scalars['Boolean']>
  readonly kargo_tutar_kosulu?: Maybe<Scalars['Float']>
  readonly kargo_tutari?: Maybe<Scalars['Float']>
  readonly kitap_varmi?: Maybe<Scalars['Boolean']>
  readonly kiyafet_varmi?: Maybe<Scalars['Boolean']>
  readonly logo: Scalars['String']
  readonly odeme_varmi?: Maybe<Scalars['Boolean']>
  readonly ogrenci_girisi_varmi?: Maybe<Scalars['Boolean']>
  readonly okul_acilis_tarih?: Maybe<Scalars['String']>
  readonly okul_adres?: Maybe<Scalars['String']>
  readonly okul_cagri_merkezi_ses_kaydi_aydinlatma_metni?: Maybe<Scalars['String']>
  readonly okul_gizlilik_ve_cerez_politikasi?: Maybe<Scalars['String']>
  readonly okul_kategorileri?: Maybe<Scalars['String']>
  readonly okul_kisisel_verilerin_korunmasi_kanunu?: Maybe<Scalars['String']>
  readonly okul_kvkk_basvuru_formu?: Maybe<Scalars['String']>
  readonly okul_musteri_aydinlatma_metni?: Maybe<Scalars['String']>
  readonly okul_musteri_onay_aydinlatma_metni?: Maybe<Scalars['String']>
  readonly okul_satis_sozlezmesi?: Maybe<Scalars['String']>
  readonly okul_tedarikci_aydinlatma_metni?: Maybe<Scalars['String']>
  readonly okulyonetimUrunler?: Maybe<OkulYonetimUrunResponse>
  readonly okulyonetimUrunlerSuggests?: Maybe<OkulYonetimUrunSuggestResponse>
  readonly renk1?: Maybe<Scalars['String']>
  readonly renk2?: Maybe<Scalars['String']>
  readonly sezon?: Maybe<Scalars['String']>
  readonly sinif?: Maybe<Sinif>
  readonly sinif_secim_liste?: Maybe<ReadonlyArray<Maybe<SinifSecimSatiri>>>
  readonly slug: Scalars['String']
  readonly stok_bitince_satisa_kapat?: Maybe<Scalars['Boolean']>
  readonly tab_gosterim?: Maybe<Scalars['Boolean']>
  readonly tekstil_toplu_satis?: Maybe<Scalars['Boolean']>
  readonly urunler?: Maybe<CaprazUrunResponse>
  readonly urunler_secili_gelsin?: Maybe<Scalars['Boolean']>
  readonly uyari?: Maybe<Scalars['String']>
  readonly yabanci_dil_indirimi_varmi?: Maybe<Scalars['Boolean']>
  readonly yetkili_ad?: Maybe<Scalars['String']>
  readonly yetkili_numara?: Maybe<Scalars['String']>
  readonly yetkili_soyad?: Maybe<Scalars['String']>
}

export type OkulOkulyonetimUrunlerArgs = {
  filtre?: InputMaybe<OkulYonetimUrunFiltre>
}

export type OkulOkulyonetimUrunlerSuggestsArgs = {
  filtre?: InputMaybe<OkulYonetimUrunSuggestsFiltre>
}

export type OkulSinifArgs = {
  sinif_id: Scalars['Int']
}

export type OkulSinif_Secim_ListeArgs = {
  ust_kategori_id?: InputMaybe<Scalars['Int']>
}

export type OkulUrunlerArgs = {
  filtre?: InputMaybe<CaprazUrunFiltre>
}

export type OkulAlanResmi = {
  readonly __typename?: 'OkulAlanResmi'
  readonly alan: Scalars['Int']
  readonly id: Scalars['Int']
  readonly link?: Maybe<Scalars['String']>
  readonly resim: Scalars['String']
  readonly resim_mobil?: Maybe<Scalars['String']>
}

export type OkulBanner = {
  readonly __typename?: 'OkulBanner'
  readonly id: Scalars['Int']
  readonly link?: Maybe<Scalars['String']>
  readonly resim: Scalars['String']
  readonly resim_mobil?: Maybe<Scalars['String']>
  readonly sira?: Maybe<Scalars['Int']>
}

export type OkulKampusYetkilileriResponse = {
  readonly __typename?: 'OkulKampusYetkilileriResponse'
  readonly yetkil_kampusler: ReadonlyArray<Maybe<OkulYetkiliKampusler>>
}

export type OkulKampusler = {
  readonly __typename?: 'OkulKampusler'
  readonly id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
  readonly okul?: Maybe<Scalars['String']>
  readonly onay?: Maybe<Scalars['Boolean']>
}

export type OkulKampuslerResponse = {
  readonly __typename?: 'OkulKampuslerResponse'
  readonly kampusler: ReadonlyArray<Maybe<OkulKampusler>>
  readonly toplamKampus: Scalars['Int']
}

export type OkulOgretmenDetayResponse = {
  readonly __typename?: 'OkulOgretmenDetayResponse'
  readonly ogretmen_bilgileri?: Maybe<OgretmenBilgileri>
}

export type OkulOgretmenler = {
  readonly __typename?: 'OkulOgretmenler'
  readonly cep_telefonu?: Maybe<Scalars['String']>
  readonly dersler: ReadonlyArray<Scalars['String']>
  readonly email?: Maybe<Scalars['String']>
  readonly id: Scalars['Int']
  readonly ogretmen?: Maybe<Scalars['String']>
  readonly okul?: Maybe<Scalars['String']>
  readonly siniflar: ReadonlyArray<Scalars['String']>
  readonly sube?: Maybe<Scalars['String']>
}

export type OkulOgretmenleriResponse = {
  readonly __typename?: 'OkulOgretmenleriResponse'
  readonly ogretmenler: ReadonlyArray<Maybe<OkulOgretmenler>>
}

export type OkulSepetDetayResponse = {
  readonly __typename?: 'OkulSepetDetayResponse'
  readonly sepet_bilgileri?: Maybe<SepetBilgileri>
  readonly sepet_satirlari?: Maybe<ReadonlyArray<Maybe<OkulSepetSatiri>>>
}

export type OkulSepetSatiri = {
  readonly __typename?: 'OkulSepetSatiri'
  readonly adet?: Maybe<Scalars['Int']>
  readonly id?: Maybe<Scalars['Int']>
  readonly ogrenci_cinsiyet?: Maybe<Scalars['String']>
  readonly ogrenci_ismi?: Maybe<Scalars['String']>
  readonly sepet_id?: Maybe<Scalars['Int']>
  readonly sinif_id?: Maybe<Scalars['Int']>
  readonly sinif_ismi?: Maybe<Scalars['String']>
  readonly tc_kimlik_no?: Maybe<Scalars['String']>
  readonly urun?: Maybe<Scalars['String']>
}

export type OkulSepetler = {
  readonly __typename?: 'OkulSepetler'
  readonly baslangic_tarih?: Maybe<Scalars['String']>
  readonly degisim?: Maybe<Scalars['Boolean']>
  readonly id: Scalars['Int']
  readonly okul?: Maybe<Scalars['String']>
  readonly sinif?: Maybe<Scalars['String']>
  readonly tarih?: Maybe<Scalars['String']>
  readonly uye?: Maybe<Scalars['String']>
}

export type OkulSepetleriResponse = {
  readonly __typename?: 'OkulSepetleriResponse'
  readonly sepetler: ReadonlyArray<Maybe<OkulSepetler>>
  readonly toplamSepet: Scalars['Int']
  readonly uyeKategorileri?: Maybe<ReadonlyArray<Maybe<UyeKategori>>>
}

export type OkulSinifDersiResponse = {
  readonly __typename?: 'OkulSinifDersiResponse'
  readonly dersler: ReadonlyArray<Maybe<KargoFirm>>
  readonly ogretmenler: ReadonlyArray<Maybe<KargoFirm>>
  readonly sinif_dersleri: ReadonlyArray<Maybe<OkulSinifDersler>>
  readonly siniflar: ReadonlyArray<Maybe<KargoFirm>>
}

export type OkulSinifDersler = {
  readonly __typename?: 'OkulSinifDersler'
  readonly ders?: Maybe<Scalars['String']>
  readonly ders_id?: Maybe<Scalars['Int']>
  readonly id: Scalars['Int']
  readonly ogretmen?: Maybe<Scalars['String']>
  readonly ogretmen_adi?: Maybe<Scalars['String']>
  readonly ogretmen_id?: Maybe<Scalars['Int']>
  readonly ogretmen_mail?: Maybe<Scalars['String']>
  readonly ogretmen_soyadi?: Maybe<Scalars['String']>
  readonly sinif?: Maybe<Scalars['String']>
  readonly sinif_id?: Maybe<Scalars['Int']>
}

export type OkulSinifSubeler = {
  readonly __typename?: 'OkulSinifSubeler'
  readonly id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
  readonly kampus?: Maybe<Scalars['String']>
  readonly kampus_id?: Maybe<Scalars['Int']>
  readonly ust_sinif_subesi?: Maybe<Scalars['String']>
  readonly ust_sinif_subesi_id?: Maybe<Scalars['Int']>
}

export type OkulSinifSubeleriResponse = {
  readonly __typename?: 'OkulSinifSubeleriResponse'
  readonly sinif_subeleri: ReadonlyArray<Maybe<OkulSinifSubeler>>
}

export type OkulSinifUrunler = {
  readonly __typename?: 'OkulSinifUrunler'
  readonly adet?: Maybe<Scalars['Int']>
  readonly barkod?: Maybe<Scalars['String']>
  readonly ders?: Maybe<Scalars['String']>
  readonly ders_id?: Maybe<Scalars['Int']>
  readonly id: Scalars['Int']
  readonly mevcut?: Maybe<Scalars['Int']>
  readonly ogretmen_adi?: Maybe<Scalars['String']>
  readonly ogretmen_id?: Maybe<Scalars['Int']>
  readonly ogretmen_mail?: Maybe<Scalars['String']>
  readonly ogretmen_soyadi?: Maybe<Scalars['String']>
  readonly olusturma_tarihi?: Maybe<Scalars['String']>
  readonly sinif?: Maybe<Scalars['String']>
  readonly sinif_id?: Maybe<Scalars['Int']>
  readonly sinif_not?: Maybe<Scalars['String']>
  readonly sinifdersi_id?: Maybe<Scalars['Int']>
  readonly urun?: Maybe<Scalars['String']>
  readonly urun_id?: Maybe<Scalars['Int']>
  readonly urun_stok_id?: Maybe<Scalars['String']>
}

export type OkulSinifUrunleriResponse = {
  readonly __typename?: 'OkulSinifUrunleriResponse'
  readonly dersler: ReadonlyArray<Maybe<KargoFirm>>
  readonly kampusler: ReadonlyArray<Maybe<KargoFirm>>
  readonly ogretmenler: ReadonlyArray<Maybe<KargoFirm>>
  readonly sinif_urunleri: ReadonlyArray<Maybe<OkulSinifUrunler>>
  readonly siniflar: ReadonlyArray<Maybe<KargoFirm>>
}

export type OkulSinifiResponse = {
  readonly __typename?: 'OkulSinifiResponse'
  readonly sinif_kategorileri: ReadonlyArray<Maybe<KargoFirm>>
  readonly siniflar: ReadonlyArray<Maybe<OkulSiniflar>>
}

export type OkulSiniflar = {
  readonly __typename?: 'OkulSiniflar'
  readonly aktif?: Maybe<Scalars['Boolean']>
  readonly id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
  readonly kampus?: Maybe<Scalars['String']>
  readonly kampus_id?: Maybe<Scalars['Int']>
  readonly kategori_id?: Maybe<Scalars['Int']>
  readonly mevcut?: Maybe<Scalars['Int']>
  readonly sinif_sube?: Maybe<Scalars['String']>
}

export type OkulSiparis = {
  readonly __typename?: 'OkulSiparis'
  readonly adet_sayisi?: Maybe<Scalars['Int']>
  readonly email?: Maybe<Scalars['String']>
  readonly fatura_adresi?: Maybe<Scalars['String']>
  readonly id: Scalars['Int']
  readonly kargo_firmasi?: Maybe<Scalars['String']>
  readonly kargo_notu?: Maybe<Scalars['String']>
  readonly kargo_tipi?: Maybe<Scalars['String']>
  readonly kargo_tipi_aciklama?: Maybe<Scalars['String']>
  readonly musteri_ismi?: Maybe<Scalars['String']>
  readonly odeme_tipi?: Maybe<Scalars['String']>
  readonly odeme_tipi_aciklama?: Maybe<Scalars['String']>
  readonly ogrenci_ismi?: Maybe<Scalars['String']>
  readonly satir_sayisi?: Maybe<Scalars['Int']>
  readonly sinif_ismi?: Maybe<Scalars['String']>
  readonly siparis_durumu?: Maybe<Scalars['String']>
  readonly siparis_durumu_aciklama?: Maybe<Scalars['String']>
  readonly tarih?: Maybe<Scalars['String']>
  readonly teslimat_adresi?: Maybe<Scalars['String']>
  readonly toplam_tutar?: Maybe<Scalars['Float']>
}

export type OkulSiparisDetayResponse = {
  readonly __typename?: 'OkulSiparisDetayResponse'
  readonly siparis_bilgileri?: Maybe<SiparisBilgileri>
  readonly siparis_faturalari?: Maybe<ReadonlyArray<Maybe<SiparisFaturasi>>>
  readonly siparis_satirlari?: Maybe<ReadonlyArray<Maybe<OkulSiparisSatiri>>>
}

export type OkulSiparisResponse = {
  readonly __typename?: 'OkulSiparisResponse'
  readonly kargo_firmalari: ReadonlyArray<Maybe<KargoFirm>>
  readonly odeme_tipleri: ReadonlyArray<Maybe<TempValues>>
  readonly siparis_durumlari: ReadonlyArray<Maybe<TempValues>>
  readonly siparisler: ReadonlyArray<Maybe<OkulSiparis>>
  readonly toplamSiparis: Scalars['Int']
  readonly uyeKategorileri?: Maybe<ReadonlyArray<Maybe<UyeKategori>>>
}

export type OkulSiparisSatiri = {
  readonly __typename?: 'OkulSiparisSatiri'
  readonly adet?: Maybe<Scalars['String']>
  readonly banka?: Maybe<Scalars['String']>
  readonly banka_id?: Maybe<Scalars['Int']>
  readonly barkod?: Maybe<Scalars['String']>
  readonly birim_fiyat?: Maybe<Scalars['Float']>
  readonly durum?: Maybe<Scalars['String']>
  readonly durum_aciklama?: Maybe<Scalars['String']>
  readonly email?: Maybe<Scalars['String']>
  readonly id?: Maybe<Scalars['Int']>
  readonly kalan_adet?: Maybe<Scalars['String']>
  readonly kdv_dahil?: Maybe<Scalars['Float']>
  readonly kdv_haric_fiyat?: Maybe<Scalars['Float']>
  readonly kdv_tutari?: Maybe<Scalars['Float']>
  readonly kimlik_no?: Maybe<Scalars['String']>
  readonly odeme_tipi?: Maybe<Scalars['String']>
  readonly odeme_tipi_aciklama?: Maybe<Scalars['String']>
  readonly ogrenci_cinsiyet?: Maybe<Scalars['String']>
  readonly ogrenci_ismi?: Maybe<Scalars['String']>
  readonly sinif_ismi?: Maybe<Scalars['String']>
  readonly siparis_id?: Maybe<Scalars['Int']>
  readonly sira?: Maybe<Scalars['Int']>
  readonly tarih?: Maybe<Scalars['String']>
  readonly urun?: Maybe<Scalars['String']>
  readonly uye?: Maybe<Scalars['String']>
}

export type OkulSiparisSatiriDetayResponse = {
  readonly __typename?: 'OkulSiparisSatiriDetayResponse'
  readonly siparis_satiri?: Maybe<OkulSiparisSatiri>
}

export type OkulSiparisSatiriResponse = {
  readonly __typename?: 'OkulSiparisSatiriResponse'
  readonly kargo_firmalari: ReadonlyArray<Maybe<KargoFirm>>
  readonly odeme_tipleri: ReadonlyArray<Maybe<TempValues>>
  readonly siparis_durumlari: ReadonlyArray<Maybe<TempValues>>
  readonly siparis_satirlari: ReadonlyArray<Maybe<OkulSiparisSatiri>>
  readonly toplam_siparis_satiri_sayisi: Scalars['Int']
  readonly uyeKategorileri?: Maybe<ReadonlyArray<Maybe<UyeKategori>>>
}

export type OkulYetkiliKampusler = {
  readonly __typename?: 'OkulYetkiliKampusler'
  readonly id: Scalars['Int']
  readonly sube_isimler?: Maybe<Scalars['String']>
  readonly uye?: Maybe<Scalars['String']>
}

export type OkulYonetimAltKategori = {
  readonly __typename?: 'OkulYonetimAltKategori'
  readonly alt_kategori_count: Scalars['Int']
  readonly alt_kategori_slug?: Maybe<Scalars['String']>
  readonly isim: Scalars['String']
  readonly sub_alt_kategoriler?: Maybe<ReadonlyArray<Maybe<OkulYonetimSubAltKategori>>>
}

export type OkulYonetimDers = {
  readonly __typename?: 'OkulYonetimDers'
  readonly ders_count: Scalars['Int']
  readonly ders_slug?: Maybe<Scalars['String']>
  readonly isim: Scalars['String']
}

export type OkulYonetimKategori = {
  readonly __typename?: 'OkulYonetimKategori'
  readonly alt_kategoriler?: Maybe<ReadonlyArray<Maybe<OkulYonetimAltKategori>>>
  readonly isim?: Maybe<Scalars['String']>
  readonly kategori_count: Scalars['Int']
  readonly kategori_slug?: Maybe<Scalars['String']>
}

export type OkulYonetimSinif = {
  readonly __typename?: 'OkulYonetimSinif'
  readonly isim: Scalars['String']
  readonly sinif_count: Scalars['Int']
  readonly sinif_slug?: Maybe<Scalars['String']>
}

export type OkulYonetimSubAltKategori = {
  readonly __typename?: 'OkulYonetimSubAltKategori'
  readonly isim: Scalars['String']
  readonly sub_alt_kategori_count: Scalars['Int']
  readonly sub_alt_kategori_slug?: Maybe<Scalars['String']>
}

export type OkulYonetimUrunFiltre = {
  readonly alt_kategori_slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>
  readonly arama?: InputMaybe<Scalars['String']>
  readonly ders_slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>
  readonly kategori_slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>
  readonly orderBy?: InputMaybe<Scalars['Int']>
  readonly sayfa?: InputMaybe<Scalars['Int']>
  readonly sinif_slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>
  readonly sub_alt_kategori_slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>
  readonly tip_slug?: InputMaybe<Scalars['String']>
  readonly urunId?: InputMaybe<Scalars['Int']>
  readonly yayinevi_slug?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>
  readonly yeni_mufredat?: InputMaybe<Scalars['Boolean']>
}

export type OkulYonetimUrunResponse = {
  readonly __typename?: 'OkulYonetimUrunResponse'
  readonly dersler?: Maybe<ReadonlyArray<Maybe<OkulYonetimDers>>>
  readonly kategoriler?: Maybe<ReadonlyArray<Maybe<OkulYonetimKategori>>>
  readonly okulyonetim_urunler?: Maybe<ReadonlyArray<Maybe<OkulyonetimUrun>>>
  readonly siniflar?: Maybe<ReadonlyArray<Maybe<OkulYonetimSinif>>>
  readonly toplam_urun_sayisi?: Maybe<Scalars['Int']>
  readonly yayinevleri?: Maybe<ReadonlyArray<Maybe<OkulYonetimYayinevi>>>
}

export type OkulYonetimUrunSuggestResponse = {
  readonly __typename?: 'OkulYonetimUrunSuggestResponse'
  readonly kategoriler?: Maybe<ReadonlyArray<Maybe<OkulYonetimKategori>>>
  readonly okulyonetim_urunler?: Maybe<ReadonlyArray<Maybe<OkulyonetimUrun>>>
  readonly siniflar?: Maybe<ReadonlyArray<Maybe<OkulYonetimSinif>>>
  readonly yayinevleri?: Maybe<ReadonlyArray<Maybe<OkulYonetimYayinevi>>>
}

export type OkulYonetimUrunSuggestsFiltre = {
  readonly arama?: InputMaybe<Scalars['String']>
}

export type OkulYonetimYayinevi = {
  readonly __typename?: 'OkulYonetimYayinevi'
  readonly isSelected?: Maybe<Scalars['Boolean']>
  readonly isim: Scalars['String']
  readonly yayinevi_count: Scalars['Int']
  readonly yayinevi_slug?: Maybe<Scalars['String']>
}

export type OkulyonetimUrun = {
  readonly __typename?: 'OkulyonetimUrun'
  readonly urun?: Maybe<UrunOkul>
}

export type Profil = {
  readonly __typename?: 'Profil'
  readonly adresler?: Maybe<ReadonlyArray<Maybe<Adres>>>
  readonly cep_telefonu?: Maybe<Scalars['String']>
  readonly ciro_yetkisi?: Maybe<Scalars['Boolean']>
  readonly email?: Maybe<Scalars['String']>
  readonly favori_urunler?: Maybe<ReadonlyArray<Maybe<Favoriler>>>
  readonly id: Scalars['Int']
  readonly is_cirosip?: Maybe<Scalars['Boolean']>
  readonly is_ogretmen?: Maybe<Scalars['Boolean']>
  readonly is_yetkili?: Maybe<Scalars['Boolean']>
  readonly isim?: Maybe<Scalars['String']>
  readonly okul_id?: Maybe<ReadonlyArray<Maybe<Scalars['Int']>>>
  readonly soyisim?: Maybe<Scalars['String']>
  readonly subeler?: Maybe<ReadonlyArray<Maybe<Sube>>>
  readonly tc?: Maybe<Scalars['String']>
}

export type ProfilInput = {
  readonly cep_telefonu?: InputMaybe<Scalars['String']>
  readonly email?: InputMaybe<Scalars['String']>
  readonly isim?: InputMaybe<Scalars['String']>
  readonly soyisim?: InputMaybe<Scalars['String']>
  readonly tc?: InputMaybe<Scalars['String']>
}

export type Query = {
  readonly __typename?: 'Query'
  readonly adminSiniflar?: Maybe<AdminSiniflarResponse>
  readonly dersler: ReadonlyArray<Maybe<Ders>>
  readonly eklenenSinifDersleri?: Maybe<EklenenSinif>
  readonly getExportJob: ExportJob
  readonly il?: Maybe<Il>
  readonly ilce?: Maybe<Ilce>
  readonly ilceler: ReadonlyArray<Maybe<Ilce>>
  readonly iller: ReadonlyArray<Maybe<Il>>
  readonly kampusDetay?: Maybe<KampusDetay>
  readonly kampusYetkilisiDetay?: Maybe<KampusYetkiliDetay>
  readonly kategoriHiyerarsisi?: Maybe<KategoriHiyerarsisiResponse>
  readonly listMyExports: ReadonlyArray<ExportJob>
  readonly mahalle?: Maybe<Mahalle>
  readonly mahalleler: ReadonlyArray<Maybe<Mahalle>>
  readonly menuUrunKategorileri?: Maybe<ReadonlyArray<Maybe<UrunKategorisi>>>
  readonly okul?: Maybe<Okul>
  readonly okulCiro?: Maybe<CiroResponse>
  readonly okulKampusYetkilileri?: Maybe<OkulKampusYetkilileriResponse>
  readonly okulKampusleri?: Maybe<OkulKampuslerResponse>
  readonly okulOgretmenDetay?: Maybe<OkulOgretmenDetayResponse>
  readonly okulOgretmenleri?: Maybe<OkulOgretmenleriResponse>
  readonly okulSepetDetay?: Maybe<OkulSepetDetayResponse>
  readonly okulSepetleri?: Maybe<OkulSepetleriResponse>
  readonly okulSinifDersleri?: Maybe<OkulSinifDersiResponse>
  readonly okulSinifSubeleri?: Maybe<OkulSinifSubeleriResponse>
  readonly okulSinifUrunleri?: Maybe<OkulSinifUrunleriResponse>
  readonly okulSiniflari?: Maybe<OkulSinifiResponse>
  readonly okulSiparisDetay?: Maybe<OkulSiparisDetayResponse>
  readonly okulSiparisSatiriDetay?: Maybe<OkulSiparisSatiriDetayResponse>
  readonly okulSiparisSatirlari?: Maybe<OkulSiparisSatiriResponse>
  readonly okulSiparisleri?: Maybe<OkulSiparisResponse>
  readonly profil?: Maybe<Profil>
  readonly sepet?: Maybe<Sepet>
  readonly sepetTest?: Maybe<Sepet>
  readonly sinifDersiDetay?: Maybe<SinifDersiDetayResponse>
  readonly sinifDetay?: Maybe<SinifDetayResponse>
  readonly sinifSubeDetay?: Maybe<SinifSubeDetayResponse>
  readonly siniflar: ReadonlyArray<Maybe<SinifDetay>>
  readonly siparisDetay: Siparis
  readonly siparislerim: ReadonlyArray<Maybe<SiparisOzet>>
  readonly toplamlar?: Maybe<Toplam>
  readonly urunKategorileri?: Maybe<ReadonlyArray<Maybe<UrunKategorisi>>>
  readonly urunKategorisi?: Maybe<KategoriMarkalarResponse>
  readonly uyeAra?: Maybe<ReadonlyArray<Maybe<Kullanici>>>
  readonly uyeBildirimMailleri: ReadonlyArray<UyeBildirimleriDetay>
}

export type QueryAdminSiniflarArgs = {
  sinif_kategorisi_id: Scalars['Int']
}

export type QueryEklenenSinifDersleriArgs = {
  sube_id: Scalars['Int']
}

export type QueryGetExportJobArgs = {
  id: Scalars['ID']
}

export type QueryIlArgs = {
  id: Scalars['Int']
}

export type QueryIlceArgs = {
  id: Scalars['Int']
}

export type QueryIlcelerArgs = {
  il_id: Scalars['Int']
}

export type QueryKampusDetayArgs = {
  id?: InputMaybe<Scalars['Int']>
}

export type QueryKampusYetkilisiDetayArgs = {
  id?: InputMaybe<Scalars['Int']>
}

export type QueryListMyExportsArgs = {
  limit?: InputMaybe<Scalars['Int']>
}

export type QueryMahalleArgs = {
  id: Scalars['Int']
}

export type QueryMahallelerArgs = {
  ilce_id: Scalars['Int']
}

export type QueryOkulArgs = {
  slug: Scalars['String']
}

export type QueryOkulCiroArgs = {
  bas_tarih?: InputMaybe<Scalars['String']>
  bit_tarih?: InputMaybe<Scalars['String']>
  kategori_secimi?: InputMaybe<Scalars['Int']>
  sube_id: Scalars['Int']
}

export type QueryOkulKampusYetkilileriArgs = {
  arama?: InputMaybe<Scalars['String']>
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulKampusleriArgs = {
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulOgretmenDetayArgs = {
  ogretmen_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulOgretmenleriArgs = {
  arama?: InputMaybe<Scalars['String']>
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulSepetDetayArgs = {
  sepet_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulSepetleriArgs = {
  arama?: InputMaybe<Scalars['String']>
  bas_tarih?: InputMaybe<Scalars['String']>
  bit_tarih?: InputMaybe<Scalars['String']>
  kategori_secimi?: InputMaybe<Scalars['Int']>
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulSinifDersleriArgs = {
  arama?: InputMaybe<Scalars['String']>
  ders_id?: InputMaybe<Scalars['String']>
  ogretmen_id?: InputMaybe<Scalars['String']>
  sinif_id?: InputMaybe<Scalars['String']>
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulSinifSubeleriArgs = {
  arama?: InputMaybe<Scalars['String']>
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulSinifUrunleriArgs = {
  arama?: InputMaybe<Scalars['String']>
  ders_ids?: InputMaybe<Scalars['String']>
  ogretmen_ids?: InputMaybe<Scalars['String']>
  sinif_ids?: InputMaybe<Scalars['String']>
  sinif_sube_id?: InputMaybe<Scalars['String']>
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulSiniflariArgs = {
  arama?: InputMaybe<Scalars['String']>
  kampus_id?: InputMaybe<Scalars['Int']>
  sinif_sube_id?: InputMaybe<Scalars['String']>
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulSiparisDetayArgs = {
  siparis_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulSiparisSatiriDetayArgs = {
  siparis_satiri_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulSiparisSatirlariArgs = {
  arama?: InputMaybe<Scalars['String']>
  bas_tarih?: InputMaybe<Scalars['String']>
  bit_tarih?: InputMaybe<Scalars['String']>
  kargo_firmasi?: InputMaybe<Scalars['String']>
  kategori?: InputMaybe<Scalars['Int']>
  odeme_tipi?: InputMaybe<Scalars['String']>
  siparis_durumu?: InputMaybe<Scalars['String']>
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QueryOkulSiparisleriArgs = {
  arama?: InputMaybe<Scalars['String']>
  bas_tarih?: InputMaybe<Scalars['String']>
  bit_tarih?: InputMaybe<Scalars['String']>
  kargo_firmasi?: InputMaybe<Scalars['String']>
  kategori_secimi?: InputMaybe<Scalars['Int']>
  odeme_tipi?: InputMaybe<Scalars['String']>
  siparis_durumu?: InputMaybe<Scalars['String']>
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QuerySepetArgs = {
  okul_slug: Scalars['String']
}

export type QuerySepetTestArgs = {
  okul_slug: Scalars['String']
}

export type QuerySinifDersiDetayArgs = {
  id?: InputMaybe<Scalars['Int']>
}

export type QuerySinifDetayArgs = {
  id?: InputMaybe<Scalars['Int']>
}

export type QuerySinifSubeDetayArgs = {
  id?: InputMaybe<Scalars['Int']>
}

export type QuerySiniflarArgs = {
  sube_id: Scalars['Int']
}

export type QuerySiparisDetayArgs = {
  siparis_id: Scalars['Int']
}

export type QuerySiparislerimArgs = {
  page?: InputMaybe<Scalars['Int']>
}

export type QueryToplamlarArgs = {
  sube_id?: InputMaybe<Scalars['Int']>
}

export type QueryUrunKategorileriArgs = {
  ust_kategori_id?: InputMaybe<Scalars['Int']>
}

export type QueryUrunKategorisiArgs = {
  id: Scalars['Int']
}

export type QueryUyeAraArgs = {
  q: Scalars['String']
}

export type QueryUyeBildirimMailleriArgs = {
  email: Scalars['String']
}

export type Sepet = {
  readonly __typename?: 'Sepet'
  readonly id: Scalars['Int']
  readonly ogretmen_indirimi_tutari?: Maybe<Scalars['String']>
  readonly ogretmen_indirimi_uygulandi?: Maybe<Scalars['Boolean']>
  readonly okul_slug: Scalars['String']
  readonly sinif?: Maybe<SepetSinifi>
  readonly urunler?: Maybe<ReadonlyArray<Maybe<SepetSatiri>>>
}

export type SepetBilgileri = {
  readonly __typename?: 'SepetBilgileri'
  readonly banka_3d_onay_tarihi?: Maybe<Scalars['String']>
  readonly banka_odeme_tarihi?: Maybe<Scalars['String']>
  readonly degisim?: Maybe<Scalars['Boolean']>
  readonly kullanici?: Maybe<Scalars['String']>
  readonly order_id?: Maybe<Scalars['String']>
  readonly sinif_ismi?: Maybe<Scalars['String']>
  readonly tarih?: Maybe<Scalars['String']>
  readonly trans_id?: Maybe<Scalars['String']>
  readonly vade_ucreti?: Maybe<Scalars['String']>
}

export type SepetSatiri = {
  readonly __typename?: 'SepetSatiri'
  readonly adet: Scalars['Int']
  readonly id: Scalars['Int']
  readonly indirim: Scalars['String']
  readonly indirimli_birim_fiyat: Scalars['String']
  readonly indirimli_fiyat: Scalars['String']
  readonly indirimsiz_birim_fiyat: Scalars['String']
  readonly indirimsiz_fiyat: Scalars['String']
  readonly max_adet?: Maybe<Scalars['Int']>
  readonly ogrenci_ismi?: Maybe<Scalars['String']>
  readonly readonly: Scalars['Boolean']
  readonly sinif_id?: Maybe<Scalars['Int']>
  readonly stok: Scalars['Int']
  readonly urun?: Maybe<Urun>
}

export type SepetSinifi = {
  readonly __typename?: 'SepetSinifi'
  readonly aktif?: Maybe<Scalars['Boolean']>
  readonly ders_kirilimi?: Maybe<Scalars['Boolean']>
  readonly id?: Maybe<Scalars['Int']>
  readonly indirim?: Maybe<Scalars['Float']>
  readonly isim?: Maybe<Scalars['String']>
  readonly kampus_adi?: Maybe<Scalars['String']>
  readonly kapali_uyarisi?: Maybe<Scalars['String']>
}

export type SepetUrunuInput = {
  readonly adet: Scalars['Int']
  readonly ogrenci_ismi?: InputMaybe<Scalars['String']>
  readonly urun_id: Scalars['Int']
}

export type SilinemeyenBilgi = {
  readonly __typename?: 'SilinemeyenBilgi'
  readonly id?: Maybe<Scalars['Int']>
  readonly ilgili_kayitlar?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>
  readonly isim?: Maybe<Scalars['String']>
  readonly neden?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>
}

export type SilinenBilgi = {
  readonly __typename?: 'SilinenBilgi'
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
}

export type Sinif = {
  readonly __typename?: 'Sinif'
  readonly aktif?: Maybe<Scalars['Boolean']>
  readonly ders_kirilimi?: Maybe<Scalars['Boolean']>
  readonly duyuru_popup?: Maybe<Scalars['String']>
  readonly id: Scalars['Int']
  readonly indirim?: Maybe<Scalars['Float']>
  readonly isim?: Maybe<Scalars['String']>
  readonly kampus_adi?: Maybe<Scalars['String']>
  readonly kapali_uyarisi?: Maybe<Scalars['String']>
  readonly kategori?: Maybe<SinifKategorisi>
  readonly kategori_id?: Maybe<Scalars['Int']>
  readonly liste_resmi?: Maybe<Scalars['String']>
  readonly paket_resmi?: Maybe<Scalars['String']>
  readonly sepet_icinde_degistirme_varmi?: Maybe<Scalars['Boolean']>
  readonly sifre_varmi?: Maybe<Scalars['Boolean']>
  readonly sinif_seviyesi?: Maybe<Scalars['Int']>
  readonly sinif_urunleri?: Maybe<ReadonlyArray<Maybe<SinifUrunu>>>
  readonly sinif_urunleri_test?: Maybe<ReadonlyArray<Maybe<SinifUrunuKampanya>>>
  readonly sira?: Maybe<Scalars['Int']>
  readonly urunler_secili_gelsin?: Maybe<Scalars['Boolean']>
  readonly uyari?: Maybe<Scalars['String']>
  readonly uye_indirim_var: Scalars['Boolean']
}

export type SinifCreateInput = {
  readonly aktif?: InputMaybe<Scalars['Boolean']>
  readonly isim: Scalars['String']
  readonly mevcut?: InputMaybe<Scalars['Int']>
  readonly sinif_kategorisi_id?: InputMaybe<Scalars['Int']>
  readonly sube_id: Scalars['Int']
}

export type SinifDersUrunuAdetGuncellemeInput = {
  readonly adet: Scalars['Int']
  readonly sinifdersi_id: Scalars['Int']
  readonly urun_id: Scalars['Int']
}

export type SinifDersUrunuNotGuncellemeInput = {
  readonly ders_notu: Scalars['String']
  readonly sinifdersi_id: Scalars['Int']
  readonly urun_id: Scalars['Int']
}

export type SinifDersUrunuSilmeInput = {
  readonly sinifdersi_id: Scalars['Int']
  readonly urun_id: Scalars['Int']
}

export type SinifDetay = {
  readonly __typename?: 'SinifDetay'
  readonly dersler?: Maybe<ReadonlyArray<Maybe<DersDetay>>>
  readonly id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
  readonly mevcut?: Maybe<Scalars['Int']>
  readonly sinif_aktif?: Maybe<Scalars['Boolean']>
}

export type SinifDetayResponse = {
  readonly __typename?: 'SinifDetayResponse'
  readonly aktif?: Maybe<Scalars['Boolean']>
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
  readonly mevcut?: Maybe<Scalars['Int']>
  readonly sinifkategorisi_id?: Maybe<Scalars['Int']>
  readonly sinifkategorisi_isim?: Maybe<Scalars['String']>
  readonly sube_id?: Maybe<Scalars['Int']>
  readonly sube_isim?: Maybe<Scalars['String']>
}

export type SinifKategorisi = {
  readonly __typename?: 'SinifKategorisi'
  readonly id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
  readonly liste_resmi?: Maybe<Scalars['String']>
  readonly sira?: Maybe<Scalars['Int']>
  readonly son_dal?: Maybe<Scalars['Boolean']>
  readonly ust_kategori_id?: Maybe<Scalars['Int']>
}

export type SinifSecimSatiri = {
  readonly __typename?: 'SinifSecimSatiri'
  readonly isim?: Maybe<Scalars['String']>
  readonly kategori_id?: Maybe<Scalars['Int']>
  readonly sifre_var?: Maybe<Scalars['Boolean']>
  readonly sinif_id?: Maybe<Scalars['Int']>
}

export type SinifSecimSifre = {
  readonly __typename?: 'SinifSecimSifre'
  readonly sifre?: Maybe<Scalars['String']>
  readonly sinif_id?: Maybe<Scalars['Int']>
}

export type SinifSecimSifreResponse = {
  readonly __typename?: 'SinifSecimSifreResponse'
  readonly isim?: Maybe<Scalars['String']>
  readonly kategori_id?: Maybe<Scalars['Int']>
  readonly message: Scalars['String']
  readonly sinif_id?: Maybe<Scalars['Int']>
  readonly statusCode: Scalars['Int']
}

export type SinifSubeCreateInput = {
  readonly isim: Scalars['String']
  readonly sube_id: Scalars['Int']
  readonly ust_kategori_id?: InputMaybe<Scalars['Int']>
}

export type SinifSubeDetayResponse = {
  readonly __typename?: 'SinifSubeDetayResponse'
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
  readonly sube_id?: Maybe<Scalars['Int']>
  readonly sube_isim?: Maybe<Scalars['String']>
  readonly ust_kategori?: Maybe<Scalars['Int']>
}

export type SinifSubeUpdateInput = {
  readonly id: Scalars['Int']
  readonly isim?: InputMaybe<Scalars['String']>
  readonly sube_id?: InputMaybe<Scalars['Int']>
  readonly ust_kategori_id?: InputMaybe<Scalars['Int']>
}

export type SinifUpdateInput = {
  readonly aktif?: InputMaybe<Scalars['Boolean']>
  readonly id: Scalars['Int']
  readonly isim?: InputMaybe<Scalars['String']>
  readonly mevcut?: InputMaybe<Scalars['Int']>
  readonly sinif_kategorisi_id?: InputMaybe<Scalars['Int']>
  readonly sube_id?: InputMaybe<Scalars['Int']>
}

export type SinifUrunu = {
  readonly __typename?: 'SinifUrunu'
  readonly adet?: Maybe<Scalars['Int']>
  readonly ders?: Maybe<Ders>
  readonly indirimli_birim_fiyat?: Maybe<Scalars['String']>
  readonly indirimsiz_birim_fiyat?: Maybe<Scalars['String']>
  readonly max_adet?: Maybe<Scalars['Int']>
  readonly min_adet?: Maybe<Scalars['Int']>
  readonly position?: Maybe<Scalars['Int']>
  readonly satirda_uye_indirimi_var: Scalars['Boolean']
  readonly sinif_id: Scalars['Int']
  readonly sinif_liste_notu?: Maybe<Scalars['String']>
  readonly stok?: Maybe<Scalars['Int']>
  readonly urun?: Maybe<Urun>
  readonly urun_id: Scalars['Int']
  readonly zorunluluk_grubu?: Maybe<Scalars['Int']>
}

export type SinifUrunuKampanya = {
  readonly __typename?: 'SinifUrunuKampanya'
  readonly adet?: Maybe<Scalars['Int']>
  readonly ders?: Maybe<Ders>
  readonly indirimli_birim_fiyat?: Maybe<Scalars['String']>
  readonly indirimsiz_birim_fiyat?: Maybe<Scalars['String']>
  readonly max_adet?: Maybe<Scalars['Int']>
  readonly min_adet?: Maybe<Scalars['Int']>
  readonly position?: Maybe<Scalars['Int']>
  readonly satin_alinan_adet?: Maybe<Scalars['Int']>
  readonly satin_alindi_mi?: Maybe<Scalars['Boolean']>
  readonly sinif_id: Scalars['Int']
  readonly sinif_liste_notu?: Maybe<Scalars['String']>
  readonly stok?: Maybe<Scalars['Int']>
  readonly urun?: Maybe<Urun>
  readonly urun_id: Scalars['Int']
  readonly zorunluluk_grubu?: Maybe<Scalars['Int']>
}

export type SinifaUrunEkleInput = {
  readonly adet: Scalars['Int']
  readonly dersler: ReadonlyArray<Scalars['Int']>
  readonly urun_id: Scalars['Int']
}

export type SinifaUrunEkleResponse = {
  readonly __typename?: 'SinifaUrunEkleResponse'
  readonly adet?: Maybe<Scalars['Int']>
  readonly dersler?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>
  readonly message?: Maybe<Scalars['String']>
  readonly success: Scalars['Boolean']
  readonly urun_id?: Maybe<Scalars['Int']>
}

export type Siparis = {
  readonly __typename?: 'Siparis'
  readonly durum: Scalars['String']
  readonly fatura_adresi: UyeAdresi
  readonly faturalar?: Maybe<ReadonlyArray<Maybe<Fatura>>>
  readonly id: Scalars['Int']
  readonly kargo_ucreti?: Maybe<Scalars['String']>
  readonly kredi_karti_pos?: Maybe<Scalars['String']>
  readonly kredi_karti_vade_secenegi?: Maybe<Scalars['Int']>
  readonly odeme_tipi: Scalars['String']
  readonly satin_alinmayan_urunler?: Maybe<ReadonlyArray<Maybe<UrunOzet>>>
  readonly satirlar: ReadonlyArray<Maybe<SiparisSatiri>>
  readonly sinif_id?: Maybe<Scalars['Int']>
  readonly tarih: Scalars['String']
  readonly teslimat_adresi: UyeAdresi
  readonly toplam_tutar: Scalars['String']
}

export type SiparisBilgileri = {
  readonly __typename?: 'SiparisBilgileri'
  readonly GenelBilgiler?: Maybe<GenelBilgiler>
  readonly OdemeBilgileri?: Maybe<OdemeBilgiler>
  readonly TeslimatBilgileri?: Maybe<TeslimatBilgiler>
}

export type SiparisFaturasi = {
  readonly __typename?: 'SiparisFaturasi'
  readonly fatura_kodu?: Maybe<Scalars['String']>
  readonly faturalanma_tarihi?: Maybe<Scalars['String']>
  readonly kargo_maili_gonderildi?: Maybe<Scalars['String']>
  readonly kargo_takip_no?: Maybe<Scalars['String']>
  readonly kargo_teslim_tarihi?: Maybe<Scalars['String']>
  readonly kargo_url?: Maybe<Scalars['String']>
  readonly kargoya_verilme_tarihi?: Maybe<Scalars['String']>
}

export type SiparisOzet = {
  readonly __typename?: 'SiparisOzet'
  readonly durum: Scalars['String']
  readonly id: Scalars['Int']
  readonly tarih: Scalars['String']
  readonly toplam_tutar: Scalars['String']
}

export type SiparisSatiri = {
  readonly __typename?: 'SiparisSatiri'
  readonly adet?: Maybe<Scalars['Int']>
  readonly birim_fiyat?: Maybe<Scalars['String']>
  readonly durum?: Maybe<Scalars['String']>
  readonly id?: Maybe<Scalars['Int']>
  readonly kalan_adet?: Maybe<Scalars['Int']>
  readonly kargo_takip_no?: Maybe<Scalars['String']>
  readonly min_adet?: Maybe<Scalars['Int']>
  readonly urun: Urun
}

export type Sube = {
  readonly __typename?: 'Sube'
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
  readonly okul_id?: Maybe<Scalars['Int']>
}

export type SubeHiy = {
  readonly __typename?: 'SubeHiy'
  readonly id: Scalars['Int']
  readonly isim: Scalars['String']
}

export type TempValues = {
  readonly __typename?: 'TempValues'
  readonly key: Scalars['String']
  readonly value: Scalars['String']
}

export type TeslimatBilgiler = {
  readonly __typename?: 'TeslimatBilgiler'
  readonly fatura_adresi?: Maybe<Scalars['String']>
  readonly kargo_firmasi?: Maybe<Scalars['String']>
  readonly kargo_tipi?: Maybe<Scalars['String']>
  readonly kargo_tipi_aciklama?: Maybe<Scalars['String']>
  readonly teslimat_adresi?: Maybe<Scalars['String']>
}

export type Toplam = {
  readonly __typename?: 'Toplam'
  readonly toplam_favori_urun?: Maybe<Scalars['Int']>
  readonly toplam_sinif?: Maybe<Scalars['Int']>
  readonly toplam_sinif_urunu?: Maybe<Scalars['Int']>
}

export type Urun = {
  readonly __typename?: 'Urun'
  readonly aciklamalar?: Maybe<Scalars['String']>
  readonly aktif?: Maybe<Scalars['Boolean']>
  readonly bilgiler?: Maybe<ReadonlyArray<Maybe<UrunBilgi>>>
  readonly dinamik_koli?: Maybe<Scalars['Boolean']>
  readonly dinamik_koli_siparis_aktarma?: Maybe<Scalars['Boolean']>
  readonly grup?: Maybe<UrunGrubu>
  readonly id: Scalars['Int']
  readonly isim: Scalars['String']
  readonly kargodan_muaf?: Maybe<Scalars['Boolean']>
  readonly kategori?: Maybe<UrunKategorisi>
  readonly kdv_yuzde: Scalars['Int']
  readonly kisa_aciklama?: Maybe<Scalars['String']>
  readonly kitap_kaplama?: Maybe<Scalars['Int']>
  readonly marka?: Maybe<Marka>
  readonly okul_indirimi?: Maybe<Scalars['Boolean']>
  readonly resim?: Maybe<Scalars['String']>
  readonly resimler?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>
  readonly sinif_seviyesi?: Maybe<Scalars['Int']>
  readonly sira?: Maybe<Scalars['Int']>
  readonly urun_kademeleri?: Maybe<Scalars['String']>
  readonly yazar?: Maybe<Scalars['String']>
}

export type UrunBilgi = {
  readonly __typename?: 'UrunBilgi'
  readonly deger?: Maybe<Scalars['String']>
  readonly isim?: Maybe<Scalars['String']>
  readonly tip?: Maybe<Scalars['Int']>
}

export type UrunGrubu = {
  readonly __typename?: 'UrunGrubu'
  readonly id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
  readonly resimler?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>
  readonly sira?: Maybe<Scalars['Int']>
}

export type UrunKategorisi = {
  readonly __typename?: 'UrunKategorisi'
  readonly id: Scalars['Int']
  readonly isim?: Maybe<Scalars['String']>
  readonly resim?: Maybe<Scalars['String']>
  readonly ust_kategori_id?: Maybe<Scalars['Int']>
}

export type UrunOkul = {
  readonly __typename?: 'UrunOkul'
  readonly aciklama?: Maybe<Scalars['String']>
  readonly aktif?: Maybe<Scalars['Boolean']>
  readonly alt_kategori?: Maybe<Scalars['String']>
  readonly alt_kategori_slug?: Maybe<Scalars['String']>
  readonly barkod?: Maybe<Scalars['String']>
  readonly ders?: Maybe<Scalars['String']>
  readonly ders_slug?: Maybe<Scalars['String']>
  readonly durum?: Maybe<Scalars['String']>
  readonly etiket_fiyati?: Maybe<Scalars['Float']>
  readonly id: Scalars['Int']
  readonly is_favori?: Maybe<Scalars['Boolean']>
  readonly isim: Scalars['String']
  readonly kategori?: Maybe<Scalars['String']>
  readonly kategori_slug?: Maybe<Scalars['String']>
  readonly kdv_orani?: Maybe<Scalars['Int']>
  readonly mufredat?: Maybe<Scalars['Boolean']>
  readonly oneri?: Maybe<Scalars['Boolean']>
  readonly pdf?: Maybe<Scalars['String']>
  readonly pdf_url?: Maybe<Scalars['String']>
  readonly resim?: Maybe<Scalars['String']>
  readonly resim_url?: Maybe<Scalars['String']>
  readonly sinif?: Maybe<Scalars['String']>
  readonly sinif_slug?: Maybe<Scalars['String']>
  readonly stokkod?: Maybe<Scalars['String']>
  readonly sub_alt_kategori?: Maybe<Scalars['String']>
  readonly sub_alt_kategori_slug?: Maybe<Scalars['String']>
  readonly tip?: Maybe<Scalars['String']>
  readonly tip_slug?: Maybe<Scalars['String']>
  readonly yayinevi?: Maybe<Scalars['String']>
  readonly yayinevi_slug?: Maybe<Scalars['String']>
  readonly yazar?: Maybe<Scalars['String']>
  readonly yazar_slug?: Maybe<Scalars['String']>
}

export type UrunOzet = {
  readonly __typename?: 'UrunOzet'
  readonly ders_ismi?: Maybe<Scalars['String']>
  readonly resim?: Maybe<Scalars['String']>
  readonly resimler?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>
  readonly urun_adet?: Maybe<Scalars['String']>
  readonly urun_birim_fiyat?: Maybe<Scalars['String']>
  readonly urun_id?: Maybe<Scalars['String']>
  readonly urun_ismi?: Maybe<Scalars['String']>
}

export type UyeAdresi = {
  readonly __typename?: 'UyeAdresi'
  readonly adres?: Maybe<Scalars['String']>
  readonly adres_tipi?: Maybe<Scalars['String']>
  readonly baslik?: Maybe<Scalars['String']>
  readonly firma?: Maybe<Scalars['String']>
  readonly gsm?: Maybe<Scalars['String']>
  readonly il?: Maybe<Scalars['String']>
  readonly ilce?: Maybe<Scalars['String']>
  readonly isim?: Maybe<Scalars['String']>
  readonly posta_kodu?: Maybe<Scalars['String']>
  readonly tel?: Maybe<Scalars['String']>
  readonly tip?: Maybe<Scalars['String']>
  readonly vergi_dairesi?: Maybe<Scalars['String']>
  readonly vergi_no?: Maybe<Scalars['String']>
}

export type UyeBildirimleriDetay = {
  readonly __typename?: 'UyeBildirimleriDetay'
  readonly aciklama?: Maybe<Scalars['String']>
  readonly tarih?: Maybe<Scalars['String']>
}

export type UyeKategori = {
  readonly __typename?: 'UyeKategori'
  readonly id?: Maybe<Scalars['Int']>
  readonly isim?: Maybe<Scalars['String']>
}

export type UyelikIndirimi = {
  readonly __typename?: 'UyelikIndirimi'
  readonly id: Scalars['Int']
  readonly indirim?: Maybe<Scalars['Float']>
  readonly urun_kategori_id?: Maybe<Scalars['Int']>
}

export type YeniUyeInput = {
  readonly cep_telefonu?: InputMaybe<Scalars['String']>
  readonly email: Scalars['String']
  readonly isim: Scalars['String']
  readonly sifre: Scalars['String']
  readonly soyisim: Scalars['String']
}

export type YetkiliKampusBilgisi = {
  readonly __typename?: 'YetkiliKampusBilgisi'
  readonly kampus: Scalars['String']
  readonly yetkililer: ReadonlyArray<Scalars['String']>
}

export type AdminSiniflarResponse = {
  readonly __typename?: 'adminSiniflarResponse'
  readonly admin_sinif_dersler: ReadonlyArray<Maybe<AdminSinifDetay>>
}

export type SinifDersiDetayResponse = {
  readonly __typename?: 'sinifDersiDetayResponse'
  readonly ders?: Maybe<Scalars['Int']>
  readonly id?: Maybe<Scalars['Int']>
  readonly ogretmen?: Maybe<Scalars['Int']>
  readonly sinif?: Maybe<Scalars['Int']>
  readonly sinif_not?: Maybe<Scalars['String']>
}

export type SinifDersiEkleInput = {
  readonly ders_id?: InputMaybe<Scalars['Int']>
  readonly id?: InputMaybe<Scalars['Int']>
  readonly ogretmen_id?: InputMaybe<Scalars['Int']>
  readonly sinif_id?: InputMaybe<Scalars['Int']>
  readonly sinif_not?: InputMaybe<Scalars['String']>
}

export type SinifEkleInput = {
  readonly aktif?: InputMaybe<Scalars['Boolean']>
  readonly id?: InputMaybe<Scalars['Int']>
  readonly isim: Scalars['String']
  readonly mevcut?: InputMaybe<Scalars['Int']>
  readonly sinif_kategorisi_id?: InputMaybe<Scalars['Int']>
  readonly sube_id: Scalars['Int']
}

export type SinifListesiEkleInput = {
  readonly adet?: InputMaybe<Scalars['Int']>
  readonly id?: InputMaybe<Scalars['Int']>
  readonly sinif_not?: InputMaybe<Scalars['String']>
  readonly sinifdersi_id?: InputMaybe<Scalars['Int']>
  readonly urun_id?: InputMaybe<Scalars['Int']>
}

export type SinifSubeEkleInput = {
  readonly id?: InputMaybe<Scalars['Int']>
  readonly isim: Scalars['String']
  readonly sube_id: Scalars['Int']
  readonly ust_kategori_id?: InputMaybe<Scalars['Int']>
}

export type ProfilGuncelleMutationVariables = Exact<{
  email: Scalars['String']
  isim: Scalars['String']
  soyisim: Scalars['String']
  cep_telefonu: Scalars['String']
}>

export type ProfilGuncelleMutation = {
  readonly __typename?: 'Mutation'
  readonly profilGuncelle?: { readonly __typename?: 'Profil'; readonly id: number } | null
}

export type SifreGuncelleMutationVariables = Exact<{
  new_password: Scalars['String']
}>

export type SifreGuncelleMutation = { readonly __typename?: 'Mutation'; readonly sifreDegistir?: boolean | null }

export type AdresEkleMutationVariables = Exact<{
  adres: Scalars['String']
  adres_tipi: Scalars['String']
  baslik: Scalars['String']
  faks: Scalars['String']
  firma: Scalars['String']
  gsm: Scalars['String']
  il_id: Scalars['Int']
  ilce_id: Scalars['Int']
  mahalle_id: Scalars['Int']
  isim: Scalars['String']
  kurumsal_adres_mi: Scalars['Boolean']
  posta_kodu: Scalars['String']
  tel: Scalars['String']
  vergi_dairesi: Scalars['String']
  vergi_no: Scalars['String']
}>

export type AdresEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly adresEkle?: { readonly __typename?: 'Adres'; readonly id: number } | null
}

export type AdresDuzenleMutationVariables = Exact<{
  id: Scalars['Int']
  adres: Scalars['String']
  baslik: Scalars['String']
  gsm: Scalars['String']
  tel: Scalars['String']
  il_id: Scalars['Int']
  ilce_id: Scalars['Int']
  mahalle_id: Scalars['Int']
  isim: Scalars['String']
  posta_kodu: Scalars['String']
  faks: Scalars['String']
  firma: Scalars['String']
  vergi_dairesi: Scalars['String']
  vergi_no: Scalars['String']
  kurumsal_adres_mi: Scalars['Boolean']
  adres_tipi: Scalars['String']
}>

export type AdresDuzenleMutation = {
  readonly __typename?: 'Mutation'
  readonly adresDuzenle?: { readonly __typename?: 'Adres'; readonly id: number } | null
}

export type AdresSilMutationVariables = Exact<{
  id: Scalars['Int']
}>

export type AdresSilMutation = { readonly __typename?: 'Mutation'; readonly adresSil?: boolean | null }

export type HesapBilgilerimQueryVariables = Exact<{ [key: string]: never }>

export type HesapBilgilerimQuery = {
  readonly __typename?: 'Query'
  readonly profil?: {
    readonly __typename?: 'Profil'
    readonly isim?: string | null
    readonly soyisim?: string | null
    readonly email?: string | null
    readonly cep_telefonu?: string | null
  } | null
}

export type SubelerQueryVariables = Exact<{ [key: string]: never }>

export type SubelerQuery = {
  readonly __typename?: 'Query'
  readonly profil?: {
    readonly __typename?: 'Profil'
    readonly isim?: string | null
    readonly is_ogretmen?: boolean | null
    readonly email?: string | null
    readonly is_yetkili?: boolean | null
    readonly is_cirosip?: boolean | null
    readonly ciro_yetkisi?: boolean | null
    readonly okul_id?: ReadonlyArray<number | null> | null
    readonly subeler?: ReadonlyArray<{
      readonly __typename?: 'Sube'
      readonly isim?: string | null
      readonly id?: number | null
      readonly okul_id?: number | null
    } | null> | null
  } | null
}

export type AdreslerimQueryVariables = Exact<{ [key: string]: never }>

export type AdreslerimQuery = {
  readonly __typename?: 'Query'
  readonly profil?: {
    readonly __typename?: 'Profil'
    readonly adresler?: ReadonlyArray<{
      readonly __typename?: 'Adres'
      readonly id: number
      readonly adres?: string | null
      readonly gsm?: string | null
      readonly baslik?: string | null
      readonly isim?: string | null
      readonly posta_kodu?: string | null
      readonly il?: { readonly __typename?: 'Il'; readonly id: number; readonly isim?: string | null } | null
      readonly ilce?: {
        readonly __typename?: 'Ilce'
        readonly id: number
        readonly isim?: string | null
        readonly il_id: number
      } | null
      readonly mahalle?: {
        readonly __typename?: 'Mahalle'
        readonly id: number
        readonly isim?: string | null
        readonly ilce_id: number
      } | null
    } | null> | null
  } | null
}

export type IlQueryVariables = Exact<{
  id: Scalars['Int']
}>

export type IlQuery = {
  readonly __typename?: 'Query'
  readonly il?: { readonly __typename?: 'Il'; readonly id: number; readonly isim?: string | null } | null
}

export type IlcelerQueryVariables = Exact<{
  il_id: Scalars['Int']
}>

export type IlcelerQuery = {
  readonly __typename?: 'Query'
  readonly ilceler: ReadonlyArray<{
    readonly __typename?: 'Ilce'
    readonly id: number
    readonly il_id: number
    readonly isim?: string | null
  } | null>
}

export type MahallelerQueryVariables = Exact<{
  ilce_id: Scalars['Int']
}>

export type MahallelerQuery = {
  readonly __typename?: 'Query'
  readonly mahalleler: ReadonlyArray<{
    readonly __typename?: 'Mahalle'
    readonly id: number
    readonly ilce_id: number
    readonly isim?: string | null
  } | null>
}

export type IllerQueryVariables = Exact<{ [key: string]: never }>

export type IllerQuery = {
  readonly __typename?: 'Query'
  readonly iller: ReadonlyArray<{
    readonly __typename?: 'Il'
    readonly id: number
    readonly isim?: string | null
  } | null>
}

export type SiniflarQueryVariables = Exact<{
  sube_id: Scalars['Int']
}>

export type SiniflarQuery = {
  readonly __typename?: 'Query'
  readonly siniflar: ReadonlyArray<{
    readonly __typename?: 'SinifDetay'
    readonly id: number
    readonly isim?: string | null
    readonly mevcut?: number | null
    readonly sinif_aktif?: boolean | null
    readonly dersler?: ReadonlyArray<{
      readonly __typename?: 'DersDetay'
      readonly ders_id: number
      readonly ders_adi?: string | null
      readonly sinif_ders_id?: number | null
      readonly ders_aktif?: boolean | null
      readonly ders_sirasi?: number | null
      readonly sinif_not?: string | null
      readonly ders_rengi?: string | null
      readonly ogretmen?: { readonly __typename?: 'OgretmenDetay'; readonly ogretmen_id: number } | null
    } | null> | null
  } | null>
}

export type EklenenSinifDersleriQueryVariables = Exact<{
  sube_id: Scalars['Int']
}>

export type EklenenSinifDersleriQuery = {
  readonly __typename?: 'Query'
  readonly eklenenSinifDersleri?: {
    readonly __typename?: 'EklenenSinif'
    readonly ogretmen?: string | null
    readonly eklenensinif: ReadonlyArray<{
      readonly __typename?: 'EklenenSinifDetay'
      readonly id: number
      readonly isim?: string | null
      readonly sinif_ders_id: number
      readonly sinif_gonderim?: boolean | null
      readonly dersler?: ReadonlyArray<{
        readonly __typename?: 'EklenenDersDetay'
        readonly ders_id: number
        readonly ders_adi?: string | null
        readonly sinif_ders_id?: number | null
        readonly barcode?: string | null
        readonly ders_aktif?: boolean | null
        readonly ders_sirasi?: number | null
        readonly sinif_not?: string | null
        readonly ders_rengi?: string | null
        readonly ders_urunu_id?: number | null
        readonly urun_id?: number | null
        readonly urun_adi?: string | null
        readonly resim?: string | null
        readonly resim_url?: string | null
        readonly adet?: number | null
        readonly etiket_fiyati?: number | null
        readonly kdv_orani?: number | null
      } | null> | null
    } | null>
  } | null
}

export type FavorilerQueryVariables = Exact<{ [key: string]: never }>

export type FavorilerQuery = {
  readonly __typename?: 'Query'
  readonly profil?: {
    readonly __typename?: 'Profil'
    readonly favori_urunler?: ReadonlyArray<{
      readonly __typename?: 'Favoriler'
      readonly favori_id?: number | null
      readonly urun?: {
        readonly __typename?: 'UrunOkul'
        readonly id: number
        readonly isim: string
        readonly aciklama?: string | null
        readonly yayinevi?: string | null
        readonly yayinevi_slug?: string | null
        readonly yazar?: string | null
        readonly yazar_slug?: string | null
        readonly kategori?: string | null
        readonly kategori_slug?: string | null
        readonly alt_kategori?: string | null
        readonly alt_kategori_slug?: string | null
        readonly barkod?: string | null
        readonly stokkod?: string | null
        readonly kdv_orani?: number | null
        readonly etiket_fiyati?: number | null
        readonly durum?: string | null
        readonly resim_url?: string | null
        readonly resim?: string | null
        readonly tip?: string | null
        readonly tip_slug?: string | null
        readonly aktif?: boolean | null
        readonly ders?: string | null
        readonly ders_slug?: string | null
        readonly sinif?: string | null
        readonly sinif_slug?: string | null
        readonly pdf_url?: string | null
        readonly pdf?: string | null
        readonly oneri?: boolean | null
        readonly mufredat?: boolean | null
        readonly is_favori?: boolean | null
      } | null
    } | null> | null
  } | null
}

export type OkulyonetimUrunlerSuggestsQueryVariables = Exact<{
  slug: Scalars['String']
  filtre?: InputMaybe<OkulYonetimUrunSuggestsFiltre>
}>

export type OkulyonetimUrunlerSuggestsQuery = {
  readonly __typename?: 'Query'
  readonly okul?: {
    readonly __typename?: 'Okul'
    readonly okulyonetimUrunlerSuggests?: {
      readonly __typename?: 'OkulYonetimUrunSuggestResponse'
      readonly okulyonetim_urunler?: ReadonlyArray<{
        readonly __typename?: 'OkulyonetimUrun'
        readonly urun?: {
          readonly __typename?: 'UrunOkul'
          readonly id: number
          readonly isim: string
          readonly resim?: string | null
        } | null
      } | null> | null
      readonly kategoriler?: ReadonlyArray<{
        readonly __typename?: 'OkulYonetimKategori'
        readonly isim?: string | null
        readonly kategori_slug?: string | null
      } | null> | null
      readonly yayinevleri?: ReadonlyArray<{
        readonly __typename?: 'OkulYonetimYayinevi'
        readonly isim: string
        readonly yayinevi_slug?: string | null
      } | null> | null
      readonly siniflar?: ReadonlyArray<{
        readonly __typename?: 'OkulYonetimSinif'
        readonly isim: string
        readonly sinif_slug?: string | null
      } | null> | null
    } | null
  } | null
}

export type OkulyonetimrunlerQueryVariables = Exact<{
  slug: Scalars['String']
  filtre?: InputMaybe<OkulYonetimUrunFiltre>
}>

export type OkulyonetimrunlerQuery = {
  readonly __typename?: 'Query'
  readonly okul?: {
    readonly __typename?: 'Okul'
    readonly okulyonetimUrunler?: {
      readonly __typename?: 'OkulYonetimUrunResponse'
      readonly toplam_urun_sayisi?: number | null
      readonly okulyonetim_urunler?: ReadonlyArray<{
        readonly __typename?: 'OkulyonetimUrun'
        readonly urun?: {
          readonly __typename?: 'UrunOkul'
          readonly id: number
          readonly isim: string
          readonly aciklama?: string | null
          readonly yayinevi?: string | null
          readonly yayinevi_slug?: string | null
          readonly yazar?: string | null
          readonly yazar_slug?: string | null
          readonly kategori?: string | null
          readonly kategori_slug?: string | null
          readonly sub_alt_kategori?: string | null
          readonly alt_kategori?: string | null
          readonly alt_kategori_slug?: string | null
          readonly sub_alt_kategori_slug?: string | null
          readonly barkod?: string | null
          readonly stokkod?: string | null
          readonly kdv_orani?: number | null
          readonly etiket_fiyati?: number | null
          readonly durum?: string | null
          readonly resim_url?: string | null
          readonly resim?: string | null
          readonly tip?: string | null
          readonly tip_slug?: string | null
          readonly aktif?: boolean | null
          readonly ders?: string | null
          readonly ders_slug?: string | null
          readonly sinif?: string | null
          readonly sinif_slug?: string | null
          readonly pdf_url?: string | null
          readonly pdf?: string | null
          readonly oneri?: boolean | null
          readonly mufredat?: boolean | null
          readonly is_favori?: boolean | null
        } | null
      } | null> | null
      readonly kategoriler?: ReadonlyArray<{
        readonly __typename?: 'OkulYonetimKategori'
        readonly isim?: string | null
        readonly kategori_slug?: string | null
        readonly kategori_count: number
        readonly alt_kategoriler?: ReadonlyArray<{
          readonly __typename?: 'OkulYonetimAltKategori'
          readonly isim: string
          readonly alt_kategori_slug?: string | null
          readonly alt_kategori_count: number
          readonly sub_alt_kategoriler?: ReadonlyArray<{
            readonly __typename?: 'OkulYonetimSubAltKategori'
            readonly isim: string
            readonly sub_alt_kategori_slug?: string | null
            readonly sub_alt_kategori_count: number
          } | null> | null
        } | null> | null
      } | null> | null
      readonly yayinevleri?: ReadonlyArray<{
        readonly __typename?: 'OkulYonetimYayinevi'
        readonly isim: string
        readonly yayinevi_slug?: string | null
        readonly yayinevi_count: number
        readonly isSelected?: boolean | null
      } | null> | null
      readonly siniflar?: ReadonlyArray<{
        readonly __typename?: 'OkulYonetimSinif'
        readonly isim: string
        readonly sinif_slug?: string | null
        readonly sinif_count: number
      } | null> | null
      readonly dersler?: ReadonlyArray<{
        readonly __typename?: 'OkulYonetimDers'
        readonly isim: string
        readonly ders_slug?: string | null
        readonly ders_count: number
      } | null> | null
    } | null
  } | null
}

export type OkulyonetimurunQueryVariables = Exact<{
  slug: Scalars['String']
  filtre?: InputMaybe<OkulYonetimUrunFiltre>
}>

export type OkulyonetimurunQuery = {
  readonly __typename?: 'Query'
  readonly okul?: {
    readonly __typename?: 'Okul'
    readonly okulyonetimUrunler?: {
      readonly __typename?: 'OkulYonetimUrunResponse'
      readonly okulyonetim_urunler?: ReadonlyArray<{
        readonly __typename?: 'OkulyonetimUrun'
        readonly urun?: {
          readonly __typename?: 'UrunOkul'
          readonly id: number
          readonly isim: string
          readonly aciklama?: string | null
          readonly yayinevi?: string | null
          readonly yayinevi_slug?: string | null
          readonly yazar?: string | null
          readonly yazar_slug?: string | null
          readonly kategori?: string | null
          readonly kategori_slug?: string | null
          readonly alt_kategori?: string | null
          readonly alt_kategori_slug?: string | null
          readonly barkod?: string | null
          readonly stokkod?: string | null
          readonly kdv_orani?: number | null
          readonly etiket_fiyati?: number | null
          readonly durum?: string | null
          readonly resim_url?: string | null
          readonly resim?: string | null
          readonly tip?: string | null
          readonly tip_slug?: string | null
          readonly aktif?: boolean | null
          readonly ders?: string | null
          readonly ders_slug?: string | null
          readonly sinif?: string | null
          readonly sinif_slug?: string | null
          readonly pdf_url?: string | null
          readonly pdf?: string | null
          readonly oneri?: boolean | null
          readonly mufredat?: boolean | null
          readonly is_favori?: boolean | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type OkulCiroQueryVariables = Exact<{
  sube_id: Scalars['Int']
  kategori_secimi?: InputMaybe<Scalars['Int']>
  bas_tarih?: InputMaybe<Scalars['String']>
  bit_tarih?: InputMaybe<Scalars['String']>
}>

export type OkulCiroQuery = {
  readonly __typename?: 'Query'
  readonly okulCiro?: {
    readonly __typename?: 'CiroResponse'
    readonly tamamlananKdv?: number | null
    readonly tamamlananKdvDahil?: number | null
    readonly tamamlananKdvHaric?: number | null
    readonly tamamlananSiparisSayisi?: number | null
    readonly iptalKdv?: number | null
    readonly iptalKdvDahil?: number | null
    readonly iptalKdvHaric?: number | null
    readonly iptalSiparisSayisi?: number | null
    readonly toplamKdv?: number | null
    readonly toplamKdvDahil?: number | null
    readonly toplamKdvHaric?: number | null
    readonly toplamSiparisSayisi?: number | null
    readonly uyeKategorileri?: ReadonlyArray<{
      readonly __typename?: 'UyeKategori'
      readonly id?: number | null
      readonly isim?: string | null
    } | null> | null
  } | null
}

export type KategoriHiyerarsisiQueryVariables = Exact<{ [key: string]: never }>

export type KategoriHiyerarsisiQuery = {
  readonly __typename?: 'Query'
  readonly kategoriHiyerarsisi?: {
    readonly __typename?: 'KategoriHiyerarsisiResponse'
    readonly kategori_hiyerarsisi?: ReadonlyArray<{
      readonly __typename?: 'KategoriHiy'
      readonly isim?: string | null
      readonly id?: number | null
      readonly sube_id?: number | null
      readonly alt_kategoriler?: ReadonlyArray<{
        readonly __typename?: 'KategoriHiy'
        readonly id?: number | null
        readonly isim?: string | null
        readonly alt_kategoriler?: ReadonlyArray<{
          readonly __typename?: 'KategoriHiy'
          readonly isim?: string | null
          readonly id?: number | null
        } | null> | null
      } | null> | null
    } | null> | null
    readonly yetkili_subeler: ReadonlyArray<{
      readonly __typename?: 'SubeHiy'
      readonly isim: string
      readonly id: number
    } | null>
  } | null
}

export type AdminSiniflarQueryVariables = Exact<{
  sinif_kategorisi_id: Scalars['Int']
}>

export type AdminSiniflarQuery = {
  readonly __typename?: 'Query'
  readonly adminSiniflar?: {
    readonly __typename?: 'adminSiniflarResponse'
    readonly admin_sinif_dersler: ReadonlyArray<{
      readonly __typename?: 'AdminSinifDetay'
      readonly mevcut?: number | null
      readonly aktif: boolean
      readonly sinif_id: number
      readonly sinif_isim: string
      readonly toplam_adet?: number | null
      readonly toplam_fiyat?: number | null
      readonly dersler: ReadonlyArray<{
        readonly __typename?: 'AdminDersDetay'
        readonly sinif_id: number
        readonly sinif_ders_id: number
        readonly adet?: number | null
        readonly ogretmen_id: number
        readonly ders_isim: string
        readonly sinif_ders_aktif?: boolean | null
        readonly urun_isim?: string | null
        readonly barcode?: string | null
        readonly olusturma_tarihi?: string | null
        readonly sinif_not?: string | null
        readonly kategori?: string | null
        readonly alt_kategori?: string | null
        readonly yayinevi?: string | null
        readonly ogretmen_adi?: string | null
        readonly resim_url?: string | null
        readonly resim?: string | null
        readonly sinif_adi?: string | null
        readonly etiket_fiyati?: number | null
      } | null>
    } | null>
  } | null
}

export type OkulSiparisleriQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
  bas_tarih?: InputMaybe<Scalars['String']>
  bit_tarih?: InputMaybe<Scalars['String']>
  siparis_durumu?: InputMaybe<Scalars['String']>
  odeme_tipi?: InputMaybe<Scalars['String']>
  kargo_firmasi?: InputMaybe<Scalars['String']>
  arama?: InputMaybe<Scalars['String']>
  kategori_secimi?: InputMaybe<Scalars['Int']>
}>

export type OkulSiparisleriQuery = {
  readonly __typename?: 'Query'
  readonly okulSiparisleri?: {
    readonly __typename?: 'OkulSiparisResponse'
    readonly toplamSiparis: number
    readonly kargo_firmalari: ReadonlyArray<{
      readonly __typename?: 'KargoFirm'
      readonly isim: string
      readonly id: number
    } | null>
    readonly odeme_tipleri: ReadonlyArray<{
      readonly __typename?: 'TempValues'
      readonly key: string
      readonly value: string
    } | null>
    readonly siparis_durumlari: ReadonlyArray<{
      readonly __typename?: 'TempValues'
      readonly value: string
      readonly key: string
    } | null>
    readonly uyeKategorileri?: ReadonlyArray<{
      readonly __typename?: 'UyeKategori'
      readonly id?: number | null
      readonly isim?: string | null
    } | null> | null
    readonly siparisler: ReadonlyArray<{
      readonly __typename?: 'OkulSiparis'
      readonly id: number
      readonly sinif_ismi?: string | null
      readonly siparis_durumu?: string | null
      readonly siparis_durumu_aciklama?: string | null
      readonly odeme_tipi_aciklama?: string | null
      readonly ogrenci_ismi?: string | null
      readonly odeme_tipi?: string | null
      readonly kargo_firmasi?: string | null
      readonly fatura_adresi?: string | null
      readonly musteri_ismi?: string | null
      readonly tarih?: string | null
      readonly teslimat_adresi?: string | null
      readonly toplam_tutar?: number | null
      readonly email?: string | null
      readonly kargo_tipi?: string | null
      readonly kargo_notu?: string | null
      readonly kargo_tipi_aciklama?: string | null
      readonly satir_sayisi?: number | null
      readonly adet_sayisi?: number | null
    } | null>
  } | null
}

export type OkulSiparisDetayQueryVariables = Exact<{
  siparis_id?: InputMaybe<Scalars['Int']>
}>

export type OkulSiparisDetayQuery = {
  readonly __typename?: 'Query'
  readonly okulSiparisDetay?: {
    readonly __typename?: 'OkulSiparisDetayResponse'
    readonly siparis_satirlari?: ReadonlyArray<{
      readonly __typename?: 'OkulSiparisSatiri'
      readonly siparis_id?: number | null
      readonly id?: number | null
      readonly adet?: string | null
      readonly urun?: string | null
      readonly uye?: string | null
      readonly sira?: number | null
      readonly ogrenci_ismi?: string | null
      readonly ogrenci_cinsiyet?: string | null
      readonly kimlik_no?: string | null
      readonly kalan_adet?: string | null
      readonly durum?: string | null
      readonly durum_aciklama?: string | null
      readonly birim_fiyat?: number | null
    } | null> | null
    readonly siparis_bilgileri?: {
      readonly __typename?: 'SiparisBilgileri'
      readonly GenelBilgiler?: {
        readonly __typename?: 'GenelBilgiler'
        readonly durum?: string | null
        readonly tarih?: string | null
        readonly bilgilendirme_maili_gonderildi?: boolean | null
        readonly iade_talebi?: string | null
        readonly iptal_tarihi?: string | null
        readonly order_id?: string | null
        readonly sepet?: string | null
        readonly durum_aciklama?: string | null
        readonly trans_id?: string | null
        readonly user?: string | null
        readonly siparis_notu?: string | null
      } | null
      readonly OdemeBilgileri?: {
        readonly __typename?: 'OdemeBilgiler'
        readonly toplam_tutar?: number | null
        readonly odeme_tipi?: string | null
        readonly odeme_tipi_aciklama?: string | null
        readonly havale_yapilacak_hesap?: string | null
        readonly kapida_odeme_hizmet_bedeli?: number | null
        readonly kargo_ucreti?: string | null
        readonly kargo_takip_no_listesi?: string | null
        readonly kredi_karti_pos?: string | null
        readonly kredi_karti_vade_secenegi?: string | null
        readonly vade_ucreti?: string | null
      } | null
      readonly TeslimatBilgileri?: {
        readonly __typename?: 'TeslimatBilgiler'
        readonly teslimat_adresi?: string | null
        readonly fatura_adresi?: string | null
        readonly kargo_firmasi?: string | null
        readonly kargo_tipi?: string | null
        readonly kargo_tipi_aciklama?: string | null
      } | null
    } | null
    readonly siparis_faturalari?: ReadonlyArray<{
      readonly __typename?: 'SiparisFaturasi'
      readonly fatura_kodu?: string | null
      readonly faturalanma_tarihi?: string | null
      readonly kargo_maili_gonderildi?: string | null
      readonly kargo_takip_no?: string | null
      readonly kargo_teslim_tarihi?: string | null
      readonly kargo_url?: string | null
      readonly kargoya_verilme_tarihi?: string | null
    } | null> | null
  } | null
}

export type OkulSiparisSatiriDetayQueryVariables = Exact<{
  siparis_satiri_id?: InputMaybe<Scalars['Int']>
}>

export type OkulSiparisSatiriDetayQuery = {
  readonly __typename?: 'Query'
  readonly okulSiparisSatiriDetay?: {
    readonly __typename?: 'OkulSiparisSatiriDetayResponse'
    readonly siparis_satiri?: {
      readonly __typename?: 'OkulSiparisSatiri'
      readonly siparis_id?: number | null
      readonly id?: number | null
      readonly adet?: string | null
      readonly urun?: string | null
      readonly uye?: string | null
      readonly sira?: number | null
      readonly ogrenci_ismi?: string | null
      readonly ogrenci_cinsiyet?: string | null
      readonly kimlik_no?: string | null
      readonly kalan_adet?: string | null
      readonly durum?: string | null
      readonly durum_aciklama?: string | null
      readonly birim_fiyat?: number | null
    } | null
  } | null
}

export type OkulSepetDetayQueryVariables = Exact<{
  sepet_id?: InputMaybe<Scalars['Int']>
}>

export type OkulSepetDetayQuery = {
  readonly __typename?: 'Query'
  readonly okulSepetDetay?: {
    readonly __typename?: 'OkulSepetDetayResponse'
    readonly sepet_bilgileri?: {
      readonly __typename?: 'SepetBilgileri'
      readonly vade_ucreti?: string | null
      readonly trans_id?: string | null
      readonly tarih?: string | null
      readonly order_id?: string | null
      readonly degisim?: boolean | null
      readonly sinif_ismi?: string | null
      readonly banka_3d_onay_tarihi?: string | null
      readonly banka_odeme_tarihi?: string | null
      readonly kullanici?: string | null
    } | null
    readonly sepet_satirlari?: ReadonlyArray<{
      readonly __typename?: 'OkulSepetSatiri'
      readonly sinif_ismi?: string | null
      readonly id?: number | null
      readonly sepet_id?: number | null
      readonly ogrenci_cinsiyet?: string | null
      readonly ogrenci_ismi?: string | null
      readonly urun?: string | null
      readonly adet?: number | null
      readonly sinif_id?: number | null
      readonly tc_kimlik_no?: string | null
    } | null> | null
  } | null
}

export type OkulSiparisSatirlariQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
  bas_tarih?: InputMaybe<Scalars['String']>
  bit_tarih?: InputMaybe<Scalars['String']>
  siparis_durumu?: InputMaybe<Scalars['String']>
  odeme_tipi?: InputMaybe<Scalars['String']>
  kargo_firmasi?: InputMaybe<Scalars['String']>
  arama?: InputMaybe<Scalars['String']>
  kategori?: InputMaybe<Scalars['Int']>
}>

export type OkulSiparisSatirlariQuery = {
  readonly __typename?: 'Query'
  readonly okulSiparisSatirlari?: {
    readonly __typename?: 'OkulSiparisSatiriResponse'
    readonly toplam_siparis_satiri_sayisi: number
    readonly kargo_firmalari: ReadonlyArray<{
      readonly __typename?: 'KargoFirm'
      readonly isim: string
      readonly id: number
    } | null>
    readonly uyeKategorileri?: ReadonlyArray<{
      readonly __typename?: 'UyeKategori'
      readonly isim?: string | null
      readonly id?: number | null
    } | null> | null
    readonly odeme_tipleri: ReadonlyArray<{
      readonly __typename?: 'TempValues'
      readonly key: string
      readonly value: string
    } | null>
    readonly siparis_durumlari: ReadonlyArray<{
      readonly __typename?: 'TempValues'
      readonly value: string
      readonly key: string
    } | null>
    readonly siparis_satirlari: ReadonlyArray<{
      readonly __typename?: 'OkulSiparisSatiri'
      readonly id?: number | null
      readonly adet?: string | null
      readonly urun?: string | null
      readonly birim_fiyat?: number | null
      readonly durum?: string | null
      readonly durum_aciklama?: string | null
      readonly kalan_adet?: string | null
      readonly kimlik_no?: string | null
      readonly ogrenci_cinsiyet?: string | null
      readonly barkod?: string | null
      readonly ogrenci_ismi?: string | null
      readonly siparis_id?: number | null
      readonly sira?: number | null
      readonly uye?: string | null
      readonly sinif_ismi?: string | null
      readonly email?: string | null
      readonly kdv_tutari?: number | null
      readonly kdv_haric_fiyat?: number | null
      readonly kdv_dahil?: number | null
      readonly banka?: string | null
      readonly banka_id?: number | null
      readonly odeme_tipi_aciklama?: string | null
      readonly odeme_tipi?: string | null
      readonly tarih?: string | null
    } | null>
  } | null
}

export type OkulSepetleriQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
  bas_tarih?: InputMaybe<Scalars['String']>
  bit_tarih?: InputMaybe<Scalars['String']>
  arama?: InputMaybe<Scalars['String']>
  kategori_secimi?: InputMaybe<Scalars['Int']>
}>

export type OkulSepetleriQuery = {
  readonly __typename?: 'Query'
  readonly okulSepetleri?: {
    readonly __typename?: 'OkulSepetleriResponse'
    readonly toplamSepet: number
    readonly sepetler: ReadonlyArray<{
      readonly __typename?: 'OkulSepetler'
      readonly id: number
      readonly tarih?: string | null
      readonly baslangic_tarih?: string | null
      readonly degisim?: boolean | null
      readonly okul?: string | null
      readonly sinif?: string | null
      readonly uye?: string | null
    } | null>
    readonly uyeKategorileri?: ReadonlyArray<{
      readonly __typename?: 'UyeKategori'
      readonly id?: number | null
      readonly isim?: string | null
    } | null> | null
  } | null
}

export type OkulKampusleriQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
}>

export type OkulKampusleriQuery = {
  readonly __typename?: 'Query'
  readonly okulKampusleri?: {
    readonly __typename?: 'OkulKampuslerResponse'
    readonly toplamKampus: number
    readonly kampusler: ReadonlyArray<{
      readonly __typename?: 'OkulKampusler'
      readonly id: number
      readonly okul?: string | null
      readonly isim?: string | null
      readonly onay?: boolean | null
    } | null>
  } | null
}

export type OkulKampusYetkilileriQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
  arama?: InputMaybe<Scalars['String']>
}>

export type OkulKampusYetkilileriQuery = {
  readonly __typename?: 'Query'
  readonly okulKampusYetkilileri?: {
    readonly __typename?: 'OkulKampusYetkilileriResponse'
    readonly yetkil_kampusler: ReadonlyArray<{
      readonly __typename?: 'OkulYetkiliKampusler'
      readonly uye?: string | null
      readonly id: number
      readonly sube_isimler?: string | null
    } | null>
  } | null
}

export type OkulSinifSubeleriQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
  arama?: InputMaybe<Scalars['String']>
}>

export type OkulSinifSubeleriQuery = {
  readonly __typename?: 'Query'
  readonly okulSinifSubeleri?: {
    readonly __typename?: 'OkulSinifSubeleriResponse'
    readonly sinif_subeleri: ReadonlyArray<{
      readonly __typename?: 'OkulSinifSubeler'
      readonly id: number
      readonly isim?: string | null
      readonly kampus?: string | null
      readonly kampus_id?: number | null
      readonly ust_sinif_subesi?: string | null
      readonly ust_sinif_subesi_id?: number | null
    } | null>
  } | null
}

export type OkulSiniflariQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
  arama?: InputMaybe<Scalars['String']>
  sinif_sube_id?: InputMaybe<Scalars['String']>
  kampus_id?: InputMaybe<Scalars['Int']>
}>

export type OkulSiniflariQuery = {
  readonly __typename?: 'Query'
  readonly okulSiniflari?: {
    readonly __typename?: 'OkulSinifiResponse'
    readonly sinif_kategorileri: ReadonlyArray<{
      readonly __typename?: 'KargoFirm'
      readonly isim: string
      readonly id: number
    } | null>
    readonly siniflar: ReadonlyArray<{
      readonly __typename?: 'OkulSiniflar'
      readonly id: number
      readonly isim?: string | null
      readonly aktif?: boolean | null
      readonly mevcut?: number | null
      readonly kampus?: string | null
      readonly sinif_sube?: string | null
      readonly kampus_id?: number | null
      readonly kategori_id?: number | null
    } | null>
  } | null
}

export type OkulSiniflariOgretmenQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
  arama?: InputMaybe<Scalars['String']>
  sinif_sube_id?: InputMaybe<Scalars['String']>
  kampus_id?: InputMaybe<Scalars['Int']>
}>

export type OkulSiniflariOgretmenQuery = {
  readonly __typename?: 'Query'
  readonly okulSiniflari?: {
    readonly __typename?: 'OkulSinifiResponse'
    readonly siniflar: ReadonlyArray<{
      readonly __typename?: 'OkulSiniflar'
      readonly id: number
      readonly isim?: string | null
      readonly aktif?: boolean | null
      readonly mevcut?: number | null
      readonly kampus?: string | null
      readonly sinif_sube?: string | null
    } | null>
  } | null
}

export type OkulSinifDersleriQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
  arama?: InputMaybe<Scalars['String']>
  sinif_id?: InputMaybe<Scalars['String']>
  ogretmen_id?: InputMaybe<Scalars['String']>
  ders_id?: InputMaybe<Scalars['String']>
}>

export type OkulSinifDersleriQuery = {
  readonly __typename?: 'Query'
  readonly okulSinifDersleri?: {
    readonly __typename?: 'OkulSinifDersiResponse'
    readonly siniflar: ReadonlyArray<{
      readonly __typename?: 'KargoFirm'
      readonly isim: string
      readonly id: number
    } | null>
    readonly dersler: ReadonlyArray<{
      readonly __typename?: 'KargoFirm'
      readonly id: number
      readonly isim: string
    } | null>
    readonly ogretmenler: ReadonlyArray<{
      readonly __typename?: 'KargoFirm'
      readonly isim: string
      readonly id: number
    } | null>
    readonly sinif_dersleri: ReadonlyArray<{
      readonly __typename?: 'OkulSinifDersler'
      readonly id: number
      readonly sinif?: string | null
      readonly ogretmen?: string | null
      readonly ders?: string | null
      readonly ogretmen_soyadi?: string | null
      readonly ogretmen_mail?: string | null
      readonly ogretmen_adi?: string | null
      readonly ogretmen_id?: number | null
      readonly sinif_id?: number | null
      readonly ders_id?: number | null
    } | null>
  } | null
}

export type OkulSinifUrunleriQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
  arama?: InputMaybe<Scalars['String']>
  sinif_sube_id?: InputMaybe<Scalars['String']>
  ders_ids?: InputMaybe<Scalars['String']>
  ogretmen_ids?: InputMaybe<Scalars['String']>
  sinif_ids?: InputMaybe<Scalars['String']>
}>

export type OkulSinifUrunleriQuery = {
  readonly __typename?: 'Query'
  readonly okulSinifUrunleri?: {
    readonly __typename?: 'OkulSinifUrunleriResponse'
    readonly kampusler: ReadonlyArray<{
      readonly __typename?: 'KargoFirm'
      readonly id: number
      readonly isim: string
    } | null>
    readonly dersler: ReadonlyArray<{
      readonly __typename?: 'KargoFirm'
      readonly id: number
      readonly isim: string
    } | null>
    readonly ogretmenler: ReadonlyArray<{
      readonly __typename?: 'KargoFirm'
      readonly id: number
      readonly isim: string
    } | null>
    readonly siniflar: ReadonlyArray<{
      readonly __typename?: 'KargoFirm'
      readonly id: number
      readonly isim: string
    } | null>
    readonly sinif_urunleri: ReadonlyArray<{
      readonly __typename?: 'OkulSinifUrunler'
      readonly id: number
      readonly sinifdersi_id?: number | null
      readonly ders?: string | null
      readonly sinif?: string | null
      readonly mevcut?: number | null
      readonly adet?: number | null
      readonly urun?: string | null
      readonly sinif_not?: string | null
      readonly barkod?: string | null
      readonly olusturma_tarihi?: string | null
      readonly ders_id?: number | null
      readonly sinif_id?: number | null
      readonly ogretmen_id?: number | null
      readonly ogretmen_mail?: string | null
      readonly ogretmen_adi?: string | null
      readonly ogretmen_soyadi?: string | null
      readonly urun_stok_id?: string | null
      readonly urun_id?: number | null
    } | null>
  } | null
}

export type OkulOgretmenleriQueryVariables = Exact<{
  sube_id?: InputMaybe<Scalars['Int']>
  arama?: InputMaybe<Scalars['String']>
}>

export type OkulOgretmenleriQuery = {
  readonly __typename?: 'Query'
  readonly okulOgretmenleri?: {
    readonly __typename?: 'OkulOgretmenleriResponse'
    readonly ogretmenler: ReadonlyArray<{
      readonly __typename?: 'OkulOgretmenler'
      readonly id: number
      readonly ogretmen?: string | null
      readonly dersler: ReadonlyArray<string>
      readonly siniflar: ReadonlyArray<string>
      readonly sube?: string | null
      readonly okul?: string | null
      readonly cep_telefonu?: string | null
      readonly email?: string | null
    } | null>
  } | null
}

export type DersListesiOnayDurumuGuncelleMutationVariables = Exact<{
  input: DersOnayInput
}>

export type DersListesiOnayDurumuGuncelleMutation = {
  readonly __typename?: 'Mutation'
  readonly dersListesiOnayDurumuGuncelle: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
  }
}

export type DerslerQueryVariables = Exact<{ [key: string]: never }>

export type DerslerQuery = {
  readonly __typename?: 'Query'
  readonly dersler: ReadonlyArray<{
    readonly __typename?: 'Ders'
    readonly id: number
    readonly isim?: string | null
  } | null>
}

export type OkulOgretmenDetayQueryVariables = Exact<{
  ogretmen_id?: InputMaybe<Scalars['Int']>
}>

export type OkulOgretmenDetayQuery = {
  readonly __typename?: 'Query'
  readonly okulOgretmenDetay?: {
    readonly __typename?: 'OkulOgretmenDetayResponse'
    readonly ogretmen_bilgileri?: {
      readonly __typename?: 'OgretmenBilgileri'
      readonly id?: number | null
      readonly isim?: string | null
      readonly soyisim?: string | null
      readonly email?: string | null
      readonly gsm?: string | null
      readonly kampus?: string | null
      readonly dersler?: string | null
      readonly siniflar?: string | null
    } | null
  } | null
}

export type KampusDetayQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>
}>

export type KampusDetayQuery = {
  readonly __typename?: 'Query'
  readonly kampusDetay?: {
    readonly __typename?: 'KampusDetay'
    readonly id?: number | null
    readonly okul_id?: number | null
    readonly isim?: string | null
    readonly okul_isim?: string | null
  } | null
}

export type KampusYetkilisiDetayQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>
}>

export type KampusYetkilisiDetayQuery = {
  readonly __typename?: 'Query'
  readonly kampusYetkilisiDetay?: {
    readonly __typename?: 'KampusYetkiliDetay'
    readonly id?: number | null
    readonly isim?: string | null
    readonly ciro_yetkisi?: boolean | null
    readonly gsm?: string | null
    readonly email?: string | null
    readonly soyisim?: string | null
    readonly sifre?: string | null
    readonly sifre_onay?: string | null
    readonly kampus?: ReadonlyArray<{
      readonly __typename?: 'KampusDetay'
      readonly id?: number | null
      readonly isim?: string | null
    } | null> | null
  } | null
}

export type SinifSubeDetayQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>
}>

export type SinifSubeDetayQuery = {
  readonly __typename?: 'Query'
  readonly sinifSubeDetay?: {
    readonly __typename?: 'SinifSubeDetayResponse'
    readonly id?: number | null
    readonly isim?: string | null
    readonly ust_kategori?: number | null
    readonly sube_id?: number | null
    readonly sube_isim?: string | null
  } | null
}

export type SinifDetayQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>
}>

export type SinifDetayQuery = {
  readonly __typename?: 'Query'
  readonly sinifDetay?: {
    readonly __typename?: 'SinifDetayResponse'
    readonly id?: number | null
    readonly isim?: string | null
    readonly sube_id?: number | null
    readonly sube_isim?: string | null
    readonly mevcut?: number | null
    readonly aktif?: boolean | null
    readonly sinifkategorisi_id?: number | null
  } | null
}

export type SinifDersiDetayQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>
}>

export type SinifDersiDetayQuery = {
  readonly __typename?: 'Query'
  readonly sinifDersiDetay?: {
    readonly __typename?: 'sinifDersiDetayResponse'
    readonly id?: number | null
    readonly sinif_not?: string | null
    readonly sinif?: number | null
    readonly ogretmen?: number | null
    readonly ders?: number | null
  } | null
}

export type OgretmenEkleMutationVariables = Exact<{
  input: KullaniciEkleInput
}>

export type OgretmenEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly ogretmenEkle: {
    readonly __typename?: 'DefaultResponse'
    readonly success: boolean
    readonly message: string
    readonly sifre?: string | null
    readonly email?: string | null
    readonly isim?: string | null
    readonly okul_slug?: string | null
    readonly dersler?: ReadonlyArray<string | null> | null
    readonly sinifler?: ReadonlyArray<string | null> | null
  }
}

export type KampusEkleMutationVariables = Exact<{
  input: KampusEkleInput
}>

export type KampusEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly kampusEkle: { readonly __typename?: 'DefaultResponse'; readonly message: string; readonly success: boolean }
}

export type KampusSilMutationVariables = Exact<{
  id: ReadonlyArray<Scalars['Int']> | Scalars['Int']
}>

export type KampusSilMutation = {
  readonly __typename?: 'Mutation'
  readonly kampusSil: {
    readonly __typename?: 'DefaultResponse'
    readonly success: boolean
    readonly message: string
    readonly yetkililer?: ReadonlyArray<{
      readonly __typename?: 'YetkiliKampusBilgisi'
      readonly yetkililer: ReadonlyArray<string>
      readonly kampus: string
    } | null> | null
  }
}

export type KampusYetkilisiSilMutationVariables = Exact<{
  id: ReadonlyArray<Scalars['Int']> | Scalars['Int']
}>

export type KampusYetkilisiSilMutation = {
  readonly __typename?: 'Mutation'
  readonly kampusYetkilisiSil: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
  }
}

export type KampusYetkilisiEkleMutationVariables = Exact<{
  input: KampusYetkiliEkleInput
}>

export type KampusYetkilisiEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly kampusYetkilisiEkle: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
    readonly kampus_yetkilisi_id?: number | null
  }
}

export type SinifSubeTopluEkleMutationVariables = Exact<{
  input: ReadonlyArray<SinifSubeCreateInput> | SinifSubeCreateInput
}>

export type SinifSubeTopluEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifSubeTopluEkle: {
    readonly __typename?: 'DefaultResponse'
    readonly success: boolean
    readonly message: string
    readonly updatedCount?: number | null
    readonly createdCount?: number | null
    readonly errors?: ReadonlyArray<string | null> | null
  }
}

export type SinifSubeTopluGuncelleMutationVariables = Exact<{
  input: ReadonlyArray<SinifSubeUpdateInput> | SinifSubeUpdateInput
}>

export type SinifSubeTopluGuncelleMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifSubeTopluGuncelle: {
    readonly __typename?: 'DefaultResponse'
    readonly success: boolean
    readonly message: string
    readonly updatedCount?: number | null
    readonly createdCount?: number | null
    readonly errors?: ReadonlyArray<string | null> | null
  }
}

export type SinifTopluEkleMutationVariables = Exact<{
  input: ReadonlyArray<SinifCreateInput> | SinifCreateInput
}>

export type SinifTopluEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifTopluEkle: {
    readonly __typename?: 'DefaultResponse'
    readonly success: boolean
    readonly message: string
    readonly updatedCount?: number | null
    readonly createdCount?: number | null
    readonly errors?: ReadonlyArray<string | null> | null
  }
}

export type SinifTopluGuncelleMutationVariables = Exact<{
  input: ReadonlyArray<SinifUpdateInput> | SinifUpdateInput
}>

export type SinifTopluGuncelleMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifTopluGuncelle: {
    readonly __typename?: 'DefaultResponse'
    readonly success: boolean
    readonly message: string
    readonly updatedCount?: number | null
    readonly createdCount?: number | null
    readonly errors?: ReadonlyArray<string | null> | null
  }
}

export type SinifDersiTopluEkleMutationVariables = Exact<{
  input: ReadonlyArray<SinifDersiEkleInput> | SinifDersiEkleInput
}>

export type SinifDersiTopluEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifDersiTopluEkle: {
    readonly __typename?: 'DefaultResponse'
    readonly success: boolean
    readonly message: string
    readonly updatedCount?: number | null
    readonly createdCount?: number | null
    readonly errors?: ReadonlyArray<string | null> | null
  }
}

export type SinifListesiTopluEkleMutationVariables = Exact<{
  input: ReadonlyArray<SinifListesiEkleInput> | SinifListesiEkleInput
}>

export type SinifListesiTopluEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifListesiTopluEkle: {
    readonly __typename?: 'DefaultResponse'
    readonly success: boolean
    readonly message: string
    readonly updatedCount?: number | null
    readonly createdCount?: number | null
    readonly errors?: ReadonlyArray<string | null> | null
  }
}

export type SinifSubeSilMutationVariables = Exact<{
  id: ReadonlyArray<Scalars['Int']> | Scalars['Int']
}>

export type SinifSubeSilMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifSubeSil: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
    readonly silinemeyenler?: ReadonlyArray<{
      readonly __typename?: 'SilinemeyenBilgi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly neden?: ReadonlyArray<string | null> | null
    } | null> | null
    readonly silinenler?: ReadonlyArray<{
      readonly __typename?: 'SilinenBilgi'
      readonly isim?: string | null
      readonly id?: number | null
    } | null> | null
  }
}

export type SinifSilMutationVariables = Exact<{
  id: ReadonlyArray<Scalars['Int']> | Scalars['Int']
}>

export type SinifSilMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifSil: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
    readonly silinemeyenler?: ReadonlyArray<{
      readonly __typename?: 'SilinemeyenBilgi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly neden?: ReadonlyArray<string | null> | null
    } | null> | null
    readonly silinenler?: ReadonlyArray<{
      readonly __typename?: 'SilinenBilgi'
      readonly isim?: string | null
      readonly id?: number | null
    } | null> | null
  }
}

export type SinifDersiSilMutationVariables = Exact<{
  id: ReadonlyArray<Scalars['Int']> | Scalars['Int']
}>

export type SinifDersiSilMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifDersiSil: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
    readonly silinemeyenler?: ReadonlyArray<{
      readonly __typename?: 'SilinemeyenBilgi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly neden?: ReadonlyArray<string | null> | null
    } | null> | null
    readonly silinenler?: ReadonlyArray<{
      readonly __typename?: 'SilinenBilgi'
      readonly isim?: string | null
      readonly id?: number | null
    } | null> | null
  }
}

export type SinifUrunuSilMutationVariables = Exact<{
  id: ReadonlyArray<Scalars['Int']> | Scalars['Int']
}>

export type SinifUrunuSilMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifUrunuSil: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
    readonly silinemeyenler?: ReadonlyArray<{
      readonly __typename?: 'SilinemeyenBilgi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly neden?: ReadonlyArray<string | null> | null
    } | null> | null
    readonly silinenler?: ReadonlyArray<{
      readonly __typename?: 'SilinenBilgi'
      readonly isim?: string | null
      readonly id?: number | null
    } | null> | null
  }
}

export type SinifListesiSilMutationVariables = Exact<{
  id: ReadonlyArray<Scalars['Int']> | Scalars['Int']
}>

export type SinifListesiSilMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifListesiSil: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
    readonly silinemeyenler?: ReadonlyArray<{
      readonly __typename?: 'SilinemeyenBilgi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly neden?: ReadonlyArray<string | null> | null
    } | null> | null
    readonly silinenler?: ReadonlyArray<{
      readonly __typename?: 'SilinenBilgi'
      readonly isim?: string | null
      readonly id?: number | null
    } | null> | null
  }
}

export type OgretmenSilMutationVariables = Exact<{
  id: ReadonlyArray<Scalars['Int']> | Scalars['Int']
}>

export type OgretmenSilMutation = {
  readonly __typename?: 'Mutation'
  readonly ogretmenSil: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
    readonly silinemeyenler?: ReadonlyArray<{
      readonly __typename?: 'SilinemeyenBilgi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly neden?: ReadonlyArray<string | null> | null
      readonly ilgili_kayitlar?: ReadonlyArray<string | null> | null
    } | null> | null
    readonly silinenler?: ReadonlyArray<{
      readonly __typename?: 'SilinenBilgi'
      readonly isim?: string | null
      readonly id?: number | null
    } | null> | null
  }
}

export type SepetSatiriSilMutationVariables = Exact<{
  id: Scalars['Int']
}>

export type SepetSatiriSilMutation = {
  readonly __typename?: 'Mutation'
  readonly sepetSatiriSil: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
  }
}

export type SinifSubeEkleMutationVariables = Exact<{
  input: SinifSubeEkleInput
}>

export type SinifSubeEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifSubeEkle: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
    readonly id?: number | null
  }
}

export type SinifEkleMutationVariables = Exact<{
  input: SinifEkleInput
}>

export type SinifEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifEkle: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
    readonly id?: number | null
  }
}

export type SinifDersiEkleMutationVariables = Exact<{
  input: SinifDersiEkleInput
}>

export type SinifDersiEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifDersiEkle: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
    readonly id?: number | null
  }
}

export type StartExportMutationVariables = Exact<{
  input: ExportParams
}>

export type StartExportMutation = {
  readonly __typename?: 'Mutation'
  readonly startExport: {
    readonly __typename?: 'ExportJob'
    readonly id: string
    readonly resultUrl?: string | null
    readonly status: string
    readonly createdAt: any
    readonly updatedAt: any
  }
}

export type LoginMutationVariables = Exact<{
  email: Scalars['String']
  password: Scalars['String']
}>

export type LoginMutation = {
  readonly __typename?: 'Mutation'
  readonly login?: {
    readonly __typename?: 'LoginSession'
    readonly user_id?: number | null
    readonly token?: string | null
    readonly expire_at?: number | null
    readonly errorMessage?: string | null
  } | null
}

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never }>

export type RefreshTokenMutation = {
  readonly __typename?: 'Mutation'
  readonly refreshToken?: {
    readonly __typename?: 'LoginSession'
    readonly user_id?: number | null
    readonly token?: string | null
    readonly expire_at?: number | null
    readonly errorMessage?: string | null
  } | null
}

export type YeniUyeMutationVariables = Exact<{
  email: Scalars['String']
  isim: Scalars['String']
  soyisim: Scalars['String']
  cep_telefonu?: InputMaybe<Scalars['String']>
  sifre: Scalars['String']
}>

export type YeniUyeMutation = {
  readonly __typename?: 'Mutation'
  readonly yeniUye?: {
    readonly __typename?: 'LoginSession'
    readonly user_id?: number | null
    readonly token?: string | null
    readonly expire_at?: number | null
    readonly errorMessage?: string | null
  } | null
}

export type UyeMailGuncelleMutationVariables = Exact<{
  email: Scalars['String']
}>

export type UyeMailGuncelleMutation = {
  readonly __typename?: 'Mutation'
  readonly uyeMailGuncelle: {
    readonly __typename?: 'DefaultResponse'
    readonly success: boolean
    readonly message: string
  }
}

export type SepetPaketDuzenleMutationVariables = Exact<{
  okulSlug: Scalars['String']
  sinifId: Scalars['Int']
  urunler?: InputMaybe<ReadonlyArray<InputMaybe<SepetUrunuInput>> | InputMaybe<SepetUrunuInput>>
}>

export type SepetPaketDuzenleMutation = {
  readonly __typename?: 'Mutation'
  readonly sepetPaketDuzenleTest?: {
    readonly __typename?: 'Sepet'
    readonly id: number
    readonly okul_slug: string
    readonly ogretmen_indirimi_uygulandi?: boolean | null
    readonly ogretmen_indirimi_tutari?: string | null
    readonly sinif?: {
      readonly __typename?: 'SepetSinifi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly kampus_adi?: string | null
      readonly kapali_uyarisi?: string | null
      readonly aktif?: boolean | null
      readonly ders_kirilimi?: boolean | null
      readonly indirim?: number | null
    } | null
    readonly urunler?: ReadonlyArray<{
      readonly __typename?: 'SepetSatiri'
      readonly id: number
      readonly sinif_id?: number | null
      readonly adet: number
      readonly indirimsiz_birim_fiyat: string
      readonly indirimli_birim_fiyat: string
      readonly indirimsiz_fiyat: string
      readonly indirimli_fiyat: string
      readonly indirim: string
      readonly readonly: boolean
      readonly urun?: {
        readonly __typename?: 'Urun'
        readonly id: number
        readonly isim: string
        readonly yazar?: string | null
        readonly resim?: string | null
        readonly sinif_seviyesi?: number | null
        readonly kdv_yuzde: number
        readonly kisa_aciklama?: string | null
        readonly kitap_kaplama?: number | null
        readonly aciklamalar?: string | null
        readonly aktif?: boolean | null
        readonly kargodan_muaf?: boolean | null
        readonly resimler?: ReadonlyArray<string | null> | null
        readonly kategori?: {
          readonly __typename?: 'UrunKategorisi'
          readonly id: number
          readonly isim?: string | null
          readonly resim?: string | null
          readonly ust_kategori_id?: number | null
        } | null
        readonly marka?: {
          readonly __typename?: 'Marka'
          readonly id?: number | null
          readonly isim?: string | null
        } | null
        readonly bilgiler?: ReadonlyArray<{
          readonly __typename?: 'UrunBilgi'
          readonly isim?: string | null
          readonly deger?: string | null
          readonly tip?: number | null
        } | null> | null
        readonly grup?: {
          readonly __typename?: 'UrunGrubu'
          readonly id: number
          readonly isim?: string | null
          readonly resimler?: ReadonlyArray<string | null> | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type SepetUrunSilMutationVariables = Exact<{
  okulSlug: Scalars['String']
  urunId: Scalars['Int']
}>

export type SepetUrunSilMutation = {
  readonly __typename?: 'Mutation'
  readonly sepetUrunSilTest?: {
    readonly __typename?: 'Sepet'
    readonly id: number
    readonly okul_slug: string
    readonly ogretmen_indirimi_uygulandi?: boolean | null
    readonly ogretmen_indirimi_tutari?: string | null
    readonly sinif?: {
      readonly __typename?: 'SepetSinifi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly kampus_adi?: string | null
      readonly kapali_uyarisi?: string | null
      readonly aktif?: boolean | null
      readonly ders_kirilimi?: boolean | null
      readonly indirim?: number | null
    } | null
    readonly urunler?: ReadonlyArray<{
      readonly __typename?: 'SepetSatiri'
      readonly id: number
      readonly sinif_id?: number | null
      readonly adet: number
      readonly indirimsiz_birim_fiyat: string
      readonly indirimli_birim_fiyat: string
      readonly indirimsiz_fiyat: string
      readonly indirimli_fiyat: string
      readonly indirim: string
      readonly readonly: boolean
      readonly urun?: {
        readonly __typename?: 'Urun'
        readonly id: number
        readonly isim: string
        readonly yazar?: string | null
        readonly resim?: string | null
        readonly sinif_seviyesi?: number | null
        readonly kdv_yuzde: number
        readonly kisa_aciklama?: string | null
        readonly kitap_kaplama?: number | null
        readonly aciklamalar?: string | null
        readonly aktif?: boolean | null
        readonly kargodan_muaf?: boolean | null
        readonly resimler?: ReadonlyArray<string | null> | null
        readonly kategori?: {
          readonly __typename?: 'UrunKategorisi'
          readonly id: number
          readonly isim?: string | null
          readonly resim?: string | null
          readonly ust_kategori_id?: number | null
        } | null
        readonly marka?: {
          readonly __typename?: 'Marka'
          readonly id?: number | null
          readonly isim?: string | null
        } | null
        readonly bilgiler?: ReadonlyArray<{
          readonly __typename?: 'UrunBilgi'
          readonly isim?: string | null
          readonly deger?: string | null
          readonly tip?: number | null
        } | null> | null
        readonly grup?: {
          readonly __typename?: 'UrunGrubu'
          readonly id: number
          readonly isim?: string | null
          readonly resimler?: ReadonlyArray<string | null> | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type SepetUrunDuzenleMutationVariables = Exact<{
  okulSlug: Scalars['String']
  urun?: InputMaybe<SepetUrunuInput>
}>

export type SepetUrunDuzenleMutation = {
  readonly __typename?: 'Mutation'
  readonly sepetUrunDuzenleTest?: {
    readonly __typename?: 'Sepet'
    readonly id: number
    readonly okul_slug: string
    readonly ogretmen_indirimi_uygulandi?: boolean | null
    readonly ogretmen_indirimi_tutari?: string | null
    readonly sinif?: {
      readonly __typename?: 'SepetSinifi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly kampus_adi?: string | null
      readonly kapali_uyarisi?: string | null
      readonly aktif?: boolean | null
      readonly ders_kirilimi?: boolean | null
      readonly indirim?: number | null
    } | null
    readonly urunler?: ReadonlyArray<{
      readonly __typename?: 'SepetSatiri'
      readonly id: number
      readonly sinif_id?: number | null
      readonly adet: number
      readonly indirimsiz_birim_fiyat: string
      readonly indirimli_birim_fiyat: string
      readonly indirimsiz_fiyat: string
      readonly indirimli_fiyat: string
      readonly indirim: string
      readonly readonly: boolean
      readonly urun?: {
        readonly __typename?: 'Urun'
        readonly id: number
        readonly isim: string
        readonly yazar?: string | null
        readonly resim?: string | null
        readonly sinif_seviyesi?: number | null
        readonly kdv_yuzde: number
        readonly kisa_aciklama?: string | null
        readonly kitap_kaplama?: number | null
        readonly aciklamalar?: string | null
        readonly aktif?: boolean | null
        readonly kargodan_muaf?: boolean | null
        readonly resimler?: ReadonlyArray<string | null> | null
        readonly kategori?: {
          readonly __typename?: 'UrunKategorisi'
          readonly id: number
          readonly isim?: string | null
          readonly resim?: string | null
          readonly ust_kategori_id?: number | null
        } | null
        readonly marka?: {
          readonly __typename?: 'Marka'
          readonly id?: number | null
          readonly isim?: string | null
        } | null
        readonly bilgiler?: ReadonlyArray<{
          readonly __typename?: 'UrunBilgi'
          readonly isim?: string | null
          readonly deger?: string | null
          readonly tip?: number | null
        } | null> | null
        readonly grup?: {
          readonly __typename?: 'UrunGrubu'
          readonly id: number
          readonly isim?: string | null
          readonly resimler?: ReadonlyArray<string | null> | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type SepetiBosaltMutationVariables = Exact<{
  okulSlug: Scalars['String']
}>

export type SepetiBosaltMutation = {
  readonly __typename?: 'Mutation'
  readonly sepetiBosaltTest?: {
    readonly __typename?: 'Sepet'
    readonly id: number
    readonly okul_slug: string
    readonly ogretmen_indirimi_uygulandi?: boolean | null
    readonly ogretmen_indirimi_tutari?: string | null
    readonly sinif?: {
      readonly __typename?: 'SepetSinifi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly kampus_adi?: string | null
      readonly kapali_uyarisi?: string | null
      readonly aktif?: boolean | null
      readonly ders_kirilimi?: boolean | null
      readonly indirim?: number | null
    } | null
    readonly urunler?: ReadonlyArray<{
      readonly __typename?: 'SepetSatiri'
      readonly id: number
      readonly sinif_id?: number | null
      readonly adet: number
      readonly indirimsiz_birim_fiyat: string
      readonly indirimli_birim_fiyat: string
      readonly indirimsiz_fiyat: string
      readonly indirimli_fiyat: string
      readonly indirim: string
      readonly readonly: boolean
      readonly urun?: {
        readonly __typename?: 'Urun'
        readonly id: number
        readonly isim: string
        readonly yazar?: string | null
        readonly resim?: string | null
        readonly sinif_seviyesi?: number | null
        readonly kdv_yuzde: number
        readonly kisa_aciklama?: string | null
        readonly kitap_kaplama?: number | null
        readonly aciklamalar?: string | null
        readonly aktif?: boolean | null
        readonly kargodan_muaf?: boolean | null
        readonly resimler?: ReadonlyArray<string | null> | null
        readonly kategori?: {
          readonly __typename?: 'UrunKategorisi'
          readonly id: number
          readonly isim?: string | null
          readonly resim?: string | null
          readonly ust_kategori_id?: number | null
        } | null
        readonly marka?: {
          readonly __typename?: 'Marka'
          readonly id?: number | null
          readonly isim?: string | null
        } | null
        readonly bilgiler?: ReadonlyArray<{
          readonly __typename?: 'UrunBilgi'
          readonly isim?: string | null
          readonly deger?: string | null
          readonly tip?: number | null
        } | null> | null
        readonly grup?: {
          readonly __typename?: 'UrunGrubu'
          readonly id: number
          readonly isim?: string | null
          readonly resimler?: ReadonlyArray<string | null> | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type SepetPaketSilMutationVariables = Exact<{
  okulSlug: Scalars['String']
  sinifId: Scalars['Int']
}>

export type SepetPaketSilMutation = {
  readonly __typename?: 'Mutation'
  readonly sepetPaketSilTest?: {
    readonly __typename?: 'Sepet'
    readonly id: number
    readonly okul_slug: string
    readonly ogretmen_indirimi_uygulandi?: boolean | null
    readonly ogretmen_indirimi_tutari?: string | null
    readonly sinif?: {
      readonly __typename?: 'SepetSinifi'
      readonly id?: number | null
      readonly isim?: string | null
      readonly kampus_adi?: string | null
      readonly kapali_uyarisi?: string | null
      readonly aktif?: boolean | null
      readonly ders_kirilimi?: boolean | null
      readonly indirim?: number | null
    } | null
    readonly urunler?: ReadonlyArray<{
      readonly __typename?: 'SepetSatiri'
      readonly id: number
      readonly sinif_id?: number | null
      readonly adet: number
      readonly indirimsiz_birim_fiyat: string
      readonly indirimli_birim_fiyat: string
      readonly indirimsiz_fiyat: string
      readonly indirimli_fiyat: string
      readonly indirim: string
      readonly readonly: boolean
      readonly urun?: {
        readonly __typename?: 'Urun'
        readonly id: number
        readonly isim: string
        readonly yazar?: string | null
        readonly resim?: string | null
        readonly sinif_seviyesi?: number | null
        readonly kdv_yuzde: number
        readonly kisa_aciklama?: string | null
        readonly kitap_kaplama?: number | null
        readonly aciklamalar?: string | null
        readonly aktif?: boolean | null
        readonly kargodan_muaf?: boolean | null
        readonly resimler?: ReadonlyArray<string | null> | null
        readonly kategori?: {
          readonly __typename?: 'UrunKategorisi'
          readonly id: number
          readonly isim?: string | null
          readonly resim?: string | null
          readonly ust_kategori_id?: number | null
        } | null
        readonly marka?: {
          readonly __typename?: 'Marka'
          readonly id?: number | null
          readonly isim?: string | null
        } | null
        readonly bilgiler?: ReadonlyArray<{
          readonly __typename?: 'UrunBilgi'
          readonly isim?: string | null
          readonly deger?: string | null
          readonly tip?: number | null
        } | null> | null
        readonly grup?: {
          readonly __typename?: 'UrunGrubu'
          readonly id: number
          readonly isim?: string | null
          readonly resimler?: ReadonlyArray<string | null> | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type SepetQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type SepetQuery = {
  readonly __typename?: 'Query'
  readonly sepetTest?: {
    readonly __typename?: 'Sepet'
    readonly id: number
    readonly ogretmen_indirimi_uygulandi?: boolean | null
    readonly ogretmen_indirimi_tutari?: string | null
    readonly okul_slug: string
    readonly sinif?: {
      readonly __typename?: 'SepetSinifi'
      readonly aktif?: boolean | null
      readonly ders_kirilimi?: boolean | null
      readonly id?: number | null
      readonly indirim?: number | null
      readonly kampus_adi?: string | null
      readonly isim?: string | null
      readonly kapali_uyarisi?: string | null
    } | null
    readonly urunler?: ReadonlyArray<{
      readonly __typename?: 'SepetSatiri'
      readonly adet: number
      readonly stok: number
      readonly max_adet?: number | null
      readonly indirim: string
      readonly id: number
      readonly indirimli_birim_fiyat: string
      readonly indirimli_fiyat: string
      readonly indirimsiz_birim_fiyat: string
      readonly indirimsiz_fiyat: string
      readonly readonly: boolean
      readonly sinif_id?: number | null
      readonly ogrenci_ismi?: string | null
      readonly urun?: {
        readonly __typename?: 'Urun'
        readonly aciklamalar?: string | null
        readonly aktif?: boolean | null
        readonly id: number
        readonly isim: string
        readonly kargodan_muaf?: boolean | null
        readonly dinamik_koli?: boolean | null
        readonly okul_indirimi?: boolean | null
        readonly resim?: string | null
        readonly kdv_yuzde: number
        readonly kisa_aciklama?: string | null
        readonly kitap_kaplama?: number | null
        readonly resimler?: ReadonlyArray<string | null> | null
        readonly sinif_seviyesi?: number | null
        readonly yazar?: string | null
        readonly bilgiler?: ReadonlyArray<{
          readonly __typename?: 'UrunBilgi'
          readonly deger?: string | null
          readonly isim?: string | null
          readonly tip?: number | null
        } | null> | null
        readonly grup?: {
          readonly __typename?: 'UrunGrubu'
          readonly id: number
          readonly isim?: string | null
          readonly resimler?: ReadonlyArray<string | null> | null
        } | null
        readonly kategori?: {
          readonly __typename?: 'UrunKategorisi'
          readonly id: number
          readonly isim?: string | null
          readonly resim?: string | null
          readonly ust_kategori_id?: number | null
        } | null
        readonly marka?: {
          readonly __typename?: 'Marka'
          readonly id?: number | null
          readonly isim?: string | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type SepetePaketEkleMutationVariables = Exact<{
  okul_slug: Scalars['String']
  sinif_id: Scalars['Int']
  urunler?: InputMaybe<ReadonlyArray<InputMaybe<SepetUrunuInput>> | InputMaybe<SepetUrunuInput>>
}>

export type SepetePaketEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly sepetPaketEkleTest?: { readonly __typename?: 'Sepet'; readonly id: number } | null
}

export type SinifUrunleriQueryVariables = Exact<{
  slug: Scalars['String']
  sinif_id: Scalars['Int']
}>

export type SinifUrunleriQuery = {
  readonly __typename?: 'Query'
  readonly okul?: {
    readonly __typename?: 'Okul'
    readonly active?: boolean | null
    readonly capraz_urun_satis_popupi_varmi?: boolean | null
    readonly indirim?: number | null
    readonly indirimli_fiyat_gosterimi?: boolean | null
    readonly id: number
    readonly isim: string
    readonly kapida_odeme_tutari?: number | null
    readonly kapida_odeme_varmi?: boolean | null
    readonly kargo_tutar_kosulu?: number | null
    readonly kargo_tutari?: number | null
    readonly ogrenci_girisi_varmi?: boolean | null
    readonly tab_gosterim?: boolean | null
    readonly tekstil_toplu_satis?: boolean | null
    readonly logo: string
    readonly uyari?: string | null
    readonly sinif?: {
      readonly __typename?: 'Sinif'
      readonly aktif?: boolean | null
      readonly uye_indirim_var: boolean
      readonly duyuru_popup?: string | null
      readonly id: number
      readonly indirim?: number | null
      readonly isim?: string | null
      readonly kampus_adi?: string | null
      readonly kapali_uyarisi?: string | null
      readonly ders_kirilimi?: boolean | null
      readonly kategori_id?: number | null
      readonly liste_resmi?: string | null
      readonly sifre_varmi?: boolean | null
      readonly paket_resmi?: string | null
      readonly sepet_icinde_degistirme_varmi?: boolean | null
      readonly sinif_seviyesi?: number | null
      readonly sira?: number | null
      readonly urunler_secili_gelsin?: boolean | null
      readonly uyari?: string | null
      readonly sinif_urunleri_test?: ReadonlyArray<{
        readonly __typename?: 'SinifUrunuKampanya'
        readonly adet?: number | null
        readonly indirimli_birim_fiyat?: string | null
        readonly indirimsiz_birim_fiyat?: string | null
        readonly min_adet?: number | null
        readonly max_adet?: number | null
        readonly stok?: number | null
        readonly position?: number | null
        readonly sinif_id: number
        readonly sinif_liste_notu?: string | null
        readonly urun_id: number
        readonly zorunluluk_grubu?: number | null
        readonly ders?: {
          readonly __typename?: 'Ders'
          readonly id: number
          readonly isim?: string | null
          readonly renk?: string | null
          readonly ders_sira?: string | null
        } | null
        readonly urun?: {
          readonly __typename?: 'Urun'
          readonly aciklamalar?: string | null
          readonly aktif?: boolean | null
          readonly dinamik_koli?: boolean | null
          readonly dinamik_koli_siparis_aktarma?: boolean | null
          readonly urun_kademeleri?: string | null
          readonly okul_indirimi?: boolean | null
          readonly sira?: number | null
          readonly isim: string
          readonly id: number
          readonly kargodan_muaf?: boolean | null
          readonly kdv_yuzde: number
          readonly kisa_aciklama?: string | null
          readonly kitap_kaplama?: number | null
          readonly resim?: string | null
          readonly resimler?: ReadonlyArray<string | null> | null
          readonly sinif_seviyesi?: number | null
          readonly yazar?: string | null
          readonly bilgiler?: ReadonlyArray<{
            readonly __typename?: 'UrunBilgi'
            readonly deger?: string | null
            readonly isim?: string | null
            readonly tip?: number | null
          } | null> | null
          readonly grup?: {
            readonly __typename?: 'UrunGrubu'
            readonly id: number
            readonly isim?: string | null
            readonly resimler?: ReadonlyArray<string | null> | null
            readonly sira?: number | null
          } | null
          readonly kategori?: {
            readonly __typename?: 'UrunKategorisi'
            readonly id: number
            readonly isim?: string | null
            readonly resim?: string | null
            readonly ust_kategori_id?: number | null
          } | null
          readonly marka?: {
            readonly __typename?: 'Marka'
            readonly id?: number | null
            readonly isim?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type SinifUrunleriTestQueryVariables = Exact<{
  slug: Scalars['String']
  sinif_id: Scalars['Int']
}>

export type SinifUrunleriTestQuery = {
  readonly __typename?: 'Query'
  readonly okul?: {
    readonly __typename?: 'Okul'
    readonly active?: boolean | null
    readonly capraz_urun_satis_popupi_varmi?: boolean | null
    readonly indirim?: number | null
    readonly indirimli_fiyat_gosterimi?: boolean | null
    readonly id: number
    readonly isim: string
    readonly kapida_odeme_tutari?: number | null
    readonly kapida_odeme_varmi?: boolean | null
    readonly kargo_tutar_kosulu?: number | null
    readonly kargo_tutari?: number | null
    readonly ogrenci_girisi_varmi?: boolean | null
    readonly tab_gosterim?: boolean | null
    readonly tekstil_toplu_satis?: boolean | null
    readonly logo: string
    readonly uyari?: string | null
    readonly sinif?: {
      readonly __typename?: 'Sinif'
      readonly aktif?: boolean | null
      readonly uye_indirim_var: boolean
      readonly duyuru_popup?: string | null
      readonly id: number
      readonly indirim?: number | null
      readonly isim?: string | null
      readonly kampus_adi?: string | null
      readonly kapali_uyarisi?: string | null
      readonly ders_kirilimi?: boolean | null
      readonly kategori_id?: number | null
      readonly liste_resmi?: string | null
      readonly sifre_varmi?: boolean | null
      readonly paket_resmi?: string | null
      readonly sepet_icinde_degistirme_varmi?: boolean | null
      readonly sinif_seviyesi?: number | null
      readonly sira?: number | null
      readonly urunler_secili_gelsin?: boolean | null
      readonly uyari?: string | null
      readonly sinif_urunleri_test?: ReadonlyArray<{
        readonly __typename?: 'SinifUrunuKampanya'
        readonly adet?: number | null
        readonly position?: number | null
        readonly indirimli_birim_fiyat?: string | null
        readonly indirimsiz_birim_fiyat?: string | null
        readonly min_adet?: number | null
        readonly max_adet?: number | null
        readonly stok?: number | null
        readonly satin_alindi_mi?: boolean | null
        readonly satin_alinan_adet?: number | null
        readonly sinif_id: number
        readonly sinif_liste_notu?: string | null
        readonly urun_id: number
        readonly zorunluluk_grubu?: number | null
        readonly ders?: {
          readonly __typename?: 'Ders'
          readonly id: number
          readonly isim?: string | null
          readonly renk?: string | null
          readonly ders_sira?: string | null
        } | null
        readonly urun?: {
          readonly __typename?: 'Urun'
          readonly aciklamalar?: string | null
          readonly aktif?: boolean | null
          readonly dinamik_koli_siparis_aktarma?: boolean | null
          readonly urun_kademeleri?: string | null
          readonly okul_indirimi?: boolean | null
          readonly sira?: number | null
          readonly isim: string
          readonly id: number
          readonly kargodan_muaf?: boolean | null
          readonly kdv_yuzde: number
          readonly kisa_aciklama?: string | null
          readonly kitap_kaplama?: number | null
          readonly resim?: string | null
          readonly resimler?: ReadonlyArray<string | null> | null
          readonly sinif_seviyesi?: number | null
          readonly yazar?: string | null
          readonly bilgiler?: ReadonlyArray<{
            readonly __typename?: 'UrunBilgi'
            readonly deger?: string | null
            readonly isim?: string | null
            readonly tip?: number | null
          } | null> | null
          readonly grup?: {
            readonly __typename?: 'UrunGrubu'
            readonly id: number
            readonly isim?: string | null
            readonly resimler?: ReadonlyArray<string | null> | null
            readonly sira?: number | null
          } | null
          readonly kategori?: {
            readonly __typename?: 'UrunKategorisi'
            readonly id: number
            readonly isim?: string | null
            readonly resim?: string | null
            readonly ust_kategori_id?: number | null
          } | null
          readonly marka?: {
            readonly __typename?: 'Marka'
            readonly id?: number | null
            readonly isim?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type SepetUrunEkleMutationVariables = Exact<{
  okulSlug: Scalars['String']
  urun?: InputMaybe<SepetUrunuInput>
}>

export type SepetUrunEkleMutation = { readonly __typename?: 'Mutation'; readonly sepetUrunEkle?: boolean | null }

export type GetCategoriesQueryVariables = Exact<{
  ust_kategori_id: Scalars['Int']
}>

export type GetCategoriesQuery = {
  readonly __typename?: 'Query'
  readonly urunKategorileri?: ReadonlyArray<{
    readonly __typename?: 'UrunKategorisi'
    readonly id: number
    readonly isim?: string | null
    readonly resim?: string | null
    readonly ust_kategori_id?: number | null
  } | null> | null
}

export type KategoriveMarkalarQueryVariables = Exact<{
  kategoriId: Scalars['Int']
}>

export type KategoriveMarkalarQuery = {
  readonly __typename?: 'Query'
  readonly urunKategorisi?: {
    readonly __typename?: 'KategoriMarkalarResponse'
    readonly kategori?: {
      readonly __typename?: 'UrunKategorisi'
      readonly id: number
      readonly isim?: string | null
      readonly resim?: string | null
      readonly ust_kategori_id?: number | null
    } | null
    readonly markalar?: ReadonlyArray<{
      readonly __typename?: 'Marka'
      readonly id?: number | null
      readonly isim?: string | null
    } | null> | null
  } | null
}

export type CarprazUrunlerQueryVariables = Exact<{
  slug: Scalars['String']
  filtre?: InputMaybe<CaprazUrunFiltre>
}>

export type CarprazUrunlerQuery = {
  readonly __typename?: 'Query'
  readonly okul?: {
    readonly __typename?: 'Okul'
    readonly urunler?: {
      readonly __typename?: 'CaprazUrunResponse'
      readonly urun_sayisi: number
      readonly capraz_urunler?: ReadonlyArray<{
        readonly __typename?: 'CaprazUrun'
        readonly indirimli_birim_fiyat?: string | null
        readonly indirimsiz_birim_fiyat?: string | null
        readonly urun?: {
          readonly __typename?: 'Urun'
          readonly aciklamalar?: string | null
          readonly aktif?: boolean | null
          readonly id: number
          readonly isim: string
          readonly kargodan_muaf?: boolean | null
          readonly kdv_yuzde: number
          readonly kisa_aciklama?: string | null
          readonly kitap_kaplama?: number | null
          readonly resim?: string | null
          readonly resimler?: ReadonlyArray<string | null> | null
          readonly sinif_seviyesi?: number | null
          readonly yazar?: string | null
          readonly marka?: {
            readonly __typename?: 'Marka'
            readonly id?: number | null
            readonly isim?: string | null
          } | null
          readonly kategori?: {
            readonly __typename?: 'UrunKategorisi'
            readonly id: number
            readonly isim?: string | null
            readonly resim?: string | null
            readonly ust_kategori_id?: number | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type SinifSecimSifreMutationVariables = Exact<{
  okul_id: Scalars['Int']
  password: Scalars['String']
  sinif_id: Scalars['Int']
}>

export type SinifSecimSifreMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifSecimSifre: {
    readonly __typename?: 'SinifSecimSifreResponse'
    readonly statusCode: number
    readonly message: string
  }
}

export type SinifaUrunEkleMutationVariables = Exact<{
  input: SinifaUrunEkleInput
}>

export type SinifaUrunEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifaUrunEkle?: {
    readonly __typename?: 'SinifaUrunEkleResponse'
    readonly success: boolean
    readonly message?: string | null
    readonly urun_id?: number | null
    readonly adet?: number | null
    readonly dersler?: ReadonlyArray<string | null> | null
  } | null
}

export type FavoriEkleMutationVariables = Exact<{
  input: FavoriEkleInput
}>

export type FavoriEkleMutation = {
  readonly __typename?: 'Mutation'
  readonly favoriEkle: {
    readonly __typename?: 'FavoriEkleResponse'
    readonly message: string
    readonly success: boolean
  }
}

export type SinifDersUrunuNotGuncellemeMutationVariables = Exact<{
  input: SinifDersUrunuNotGuncellemeInput
}>

export type SinifDersUrunuNotGuncellemeMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifDersUrunuNotGuncelleme: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
  }
}

export type SinifDersUrunuAdetGuncellemeMutationVariables = Exact<{
  input: SinifDersUrunuAdetGuncellemeInput
}>

export type SinifDersUrunuAdetGuncellemeMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifDersUrunuAdetGuncelleme: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
  }
}

export type SinifDersUrunuSilmeMutationVariables = Exact<{
  input: SinifDersUrunuSilmeInput
}>

export type SinifDersUrunuSilmeMutation = {
  readonly __typename?: 'Mutation'
  readonly sinifDersUrunuSilme: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
  }
}

export type DersListesiniOnayaGonderMutationVariables = Exact<{
  input: DersOnaylaInput
}>

export type DersListesiniOnayaGonderMutation = {
  readonly __typename?: 'Mutation'
  readonly dersListesiniOnayaGonder: {
    readonly __typename?: 'DefaultResponse'
    readonly message: string
    readonly success: boolean
  }
}

export type OkulQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type OkulQuery = {
  readonly __typename?: 'Query'
  readonly okul?: {
    readonly __typename?: 'Okul'
    readonly id: number
    readonly slug: string
    readonly isim: string
    readonly logo: string
    readonly email?: string | null
    readonly banner?: string | null
    readonly uyari?: string | null
    readonly genel_uyari?: string | null
    readonly indirim?: number | null
    readonly yabanci_dil_indirimi_varmi?: boolean | null
    readonly renk1?: string | null
    readonly renk2?: string | null
    readonly odeme_varmi?: boolean | null
    readonly ogrenci_girisi_varmi?: boolean | null
    readonly okul_acilis_tarih?: string | null
    readonly kargo_tutar_kosulu?: number | null
    readonly kargo_tutari?: number | null
    readonly kapida_odeme_varmi?: boolean | null
    readonly kapida_odeme_tutari?: number | null
    readonly stok_bitince_satisa_kapat?: boolean | null
    readonly capraz_urun_satisi_varmi?: boolean | null
    readonly capraz_urun_satis_popupi_varmi?: boolean | null
    readonly indirimli_fiyat_gosterimi?: boolean | null
    readonly active?: boolean | null
    readonly bannerlari_goster?: boolean | null
    readonly alan_resimlerini_goster?: boolean | null
    readonly cari_ad?: string | null
    readonly okul_adres?: string | null
    readonly urunler_secili_gelsin?: boolean | null
    readonly okul_kategorileri?: string | null
    readonly tekstil_toplu_satis?: boolean | null
    readonly kiyafet_varmi?: boolean | null
    readonly kitap_varmi?: boolean | null
    readonly sezon?: string | null
    readonly yetkili_ad?: string | null
    readonly yetkili_soyad?: string | null
    readonly yetkili_numara?: string | null
    readonly okul_satis_sozlezmesi?: string | null
    readonly okul_kisisel_verilerin_korunmasi_kanunu?: string | null
    readonly okul_musteri_aydinlatma_metni?: string | null
    readonly okul_musteri_onay_aydinlatma_metni?: string | null
    readonly okul_tedarikci_aydinlatma_metni?: string | null
    readonly okul_cagri_merkezi_ses_kaydi_aydinlatma_metni?: string | null
    readonly okul_gizlilik_ve_cerez_politikasi?: string | null
    readonly okul_kvkk_basvuru_formu?: string | null
    readonly bannerlar?: ReadonlyArray<{
      readonly __typename?: 'OkulBanner'
      readonly id: number
      readonly resim: string
      readonly resim_mobil?: string | null
      readonly link?: string | null
      readonly sira?: number | null
    } | null> | null
    readonly alan_resimleri?: ReadonlyArray<{
      readonly __typename?: 'OkulAlanResmi'
      readonly id: number
      readonly resim: string
      readonly resim_mobil?: string | null
      readonly link?: string | null
      readonly alan: number
    } | null> | null
  } | null
}

export type SinifListesiVeKategorileriQueryVariables = Exact<{
  slug: Scalars['String']
  ust_kategori_id?: InputMaybe<Scalars['Int']>
}>

export type SinifListesiVeKategorileriQuery = {
  readonly __typename?: 'Query'
  readonly okul?: {
    readonly __typename?: 'Okul'
    readonly sinif_secim_liste?: ReadonlyArray<{
      readonly __typename?: 'SinifSecimSatiri'
      readonly sinif_id?: number | null
      readonly kategori_id?: number | null
      readonly isim?: string | null
      readonly sifre_var?: boolean | null
    } | null> | null
  } | null
}

export type UyeBildirimMailleriQueryVariables = Exact<{
  email: Scalars['String']
}>

export type UyeBildirimMailleriQuery = {
  readonly __typename?: 'Query'
  readonly uyeBildirimMailleri: ReadonlyArray<{
    readonly __typename?: 'UyeBildirimleriDetay'
    readonly tarih?: string | null
    readonly aciklama?: string | null
  }>
}

export type IadeTalebiOlusturMutationVariables = Exact<{
  okul_slug: Scalars['String']
  siparis_id: Scalars['Int']
  satirlar?: InputMaybe<ReadonlyArray<InputMaybe<IadeSatiriInput>> | InputMaybe<IadeSatiriInput>>
}>

export type IadeTalebiOlusturMutation = {
  readonly __typename?: 'Mutation'
  readonly iadeTalebiOlustur?: { readonly __typename?: 'IadeResponse'; readonly kargo_takip_no: string } | null
}

export type SiparislerimQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>
}>

export type SiparislerimQuery = {
  readonly __typename?: 'Query'
  readonly siparislerim: ReadonlyArray<{
    readonly __typename?: 'SiparisOzet'
    readonly id: number
    readonly tarih: string
    readonly toplam_tutar: string
    readonly durum: string
  } | null>
}

export type SiparisDetayQueryVariables = Exact<{
  siparis_id: Scalars['Int']
}>

export type SiparisDetayQuery = {
  readonly __typename?: 'Query'
  readonly siparisDetay: {
    readonly __typename?: 'Siparis'
    readonly id: number
    readonly sinif_id?: number | null
    readonly tarih: string
    readonly toplam_tutar: string
    readonly kargo_ucreti?: string | null
    readonly durum: string
    readonly kredi_karti_pos?: string | null
    readonly kredi_karti_vade_secenegi?: number | null
    readonly odeme_tipi: string
    readonly satirlar: ReadonlyArray<{
      readonly __typename?: 'SiparisSatiri'
      readonly adet?: number | null
      readonly birim_fiyat?: string | null
      readonly durum?: string | null
      readonly id?: number | null
      readonly kalan_adet?: number | null
      readonly kargo_takip_no?: string | null
      readonly min_adet?: number | null
      readonly urun: {
        readonly __typename?: 'Urun'
        readonly id: number
        readonly isim: string
        readonly kisa_aciklama?: string | null
        readonly aciklamalar?: string | null
        readonly kdv_yuzde: number
        readonly sinif_seviyesi?: number | null
        readonly aktif?: boolean | null
        readonly yazar?: string | null
        readonly resim?: string | null
        readonly kargodan_muaf?: boolean | null
        readonly kitap_kaplama?: number | null
        readonly resimler?: ReadonlyArray<string | null> | null
        readonly grup?: {
          readonly __typename?: 'UrunGrubu'
          readonly isim?: string | null
          readonly id: number
          readonly resimler?: ReadonlyArray<string | null> | null
        } | null
        readonly marka?: {
          readonly __typename?: 'Marka'
          readonly id?: number | null
          readonly isim?: string | null
        } | null
        readonly kategori?: {
          readonly __typename?: 'UrunKategorisi'
          readonly id: number
          readonly isim?: string | null
          readonly resim?: string | null
          readonly ust_kategori_id?: number | null
        } | null
        readonly bilgiler?: ReadonlyArray<{
          readonly __typename?: 'UrunBilgi'
          readonly deger?: string | null
          readonly isim?: string | null
          readonly tip?: number | null
        } | null> | null
      }
    } | null>
    readonly faturalar?: ReadonlyArray<{
      readonly __typename?: 'Fatura'
      readonly id: number
      readonly durum?: string | null
      readonly belge_kodu?: string | null
      readonly gonderi_tarihi?: string | null
      readonly kargo_takip_no?: string | null
      readonly kargo_teslim_tarihi?: string | null
      readonly kargoya_verilme_tarihi?: string | null
      readonly satirlar?: ReadonlyArray<{
        readonly __typename?: 'UrunOzet'
        readonly urun_id?: string | null
        readonly urun_adet?: string | null
        readonly urun_birim_fiyat?: string | null
        readonly urun_ismi?: string | null
      } | null> | null
    } | null> | null
    readonly satin_alinmayan_urunler?: ReadonlyArray<{
      readonly __typename?: 'UrunOzet'
      readonly urun_id?: string | null
      readonly urun_ismi?: string | null
      readonly urun_birim_fiyat?: string | null
      readonly urun_adet?: string | null
      readonly ders_ismi?: string | null
      readonly resim?: string | null
      readonly resimler?: ReadonlyArray<string | null> | null
    } | null> | null
    readonly teslimat_adresi: {
      readonly __typename?: 'UyeAdresi'
      readonly isim?: string | null
      readonly adres?: string | null
      readonly ilce?: string | null
      readonly il?: string | null
      readonly posta_kodu?: string | null
      readonly gsm?: string | null
      readonly tel?: string | null
    }
    readonly fatura_adresi: {
      readonly __typename?: 'UyeAdresi'
      readonly isim?: string | null
      readonly adres?: string | null
      readonly ilce?: string | null
      readonly il?: string | null
      readonly posta_kodu?: string | null
      readonly gsm?: string | null
      readonly tel?: string | null
      readonly firma?: string | null
      readonly vergi_dairesi?: string | null
      readonly vergi_no?: string | null
    }
  }
}

export const ProfilGuncelleDocument = gql`
  mutation ProfilGuncelle($email: String!, $isim: String!, $soyisim: String!, $cep_telefonu: String!) {
    profilGuncelle(input: { email: $email, isim: $isim, soyisim: $soyisim, cep_telefonu: $cep_telefonu }) {
      id
    }
  }
`
export type ProfilGuncelleMutationFn = Apollo.MutationFunction<ProfilGuncelleMutation, ProfilGuncelleMutationVariables>

/**
 * __useProfilGuncelleMutation__
 *
 * To run a mutation, you first call `useProfilGuncelleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfilGuncelleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profilGuncelleMutation, { data, loading, error }] = useProfilGuncelleMutation({
 *   variables: {
 *      email: // value for 'email'
 *      isim: // value for 'isim'
 *      soyisim: // value for 'soyisim'
 *      cep_telefonu: // value for 'cep_telefonu'
 *   },
 * });
 */
export function useProfilGuncelleMutation(
  baseOptions?: Apollo.MutationHookOptions<ProfilGuncelleMutation, ProfilGuncelleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ProfilGuncelleMutation, ProfilGuncelleMutationVariables>(ProfilGuncelleDocument, options)
}
export type ProfilGuncelleMutationHookResult = ReturnType<typeof useProfilGuncelleMutation>
export type ProfilGuncelleMutationResult = Apollo.MutationResult<ProfilGuncelleMutation>
export type ProfilGuncelleMutationOptions = Apollo.BaseMutationOptions<
  ProfilGuncelleMutation,
  ProfilGuncelleMutationVariables
>
export const SifreGuncelleDocument = gql`
  mutation SifreGuncelle($new_password: String!) {
    sifreDegistir(new_password: $new_password)
  }
`
export type SifreGuncelleMutationFn = Apollo.MutationFunction<SifreGuncelleMutation, SifreGuncelleMutationVariables>

/**
 * __useSifreGuncelleMutation__
 *
 * To run a mutation, you first call `useSifreGuncelleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSifreGuncelleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sifreGuncelleMutation, { data, loading, error }] = useSifreGuncelleMutation({
 *   variables: {
 *      new_password: // value for 'new_password'
 *   },
 * });
 */
export function useSifreGuncelleMutation(
  baseOptions?: Apollo.MutationHookOptions<SifreGuncelleMutation, SifreGuncelleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SifreGuncelleMutation, SifreGuncelleMutationVariables>(SifreGuncelleDocument, options)
}
export type SifreGuncelleMutationHookResult = ReturnType<typeof useSifreGuncelleMutation>
export type SifreGuncelleMutationResult = Apollo.MutationResult<SifreGuncelleMutation>
export type SifreGuncelleMutationOptions = Apollo.BaseMutationOptions<
  SifreGuncelleMutation,
  SifreGuncelleMutationVariables
>
export const AdresEkleDocument = gql`
  mutation AdresEkle(
    $adres: String!
    $adres_tipi: String!
    $baslik: String!
    $faks: String!
    $firma: String!
    $gsm: String!
    $il_id: Int!
    $ilce_id: Int!
    $mahalle_id: Int!
    $isim: String!
    $kurumsal_adres_mi: Boolean!
    $posta_kodu: String!
    $tel: String!
    $vergi_dairesi: String!
    $vergi_no: String!
  ) {
    adresEkle(
      input: {
        adres: $adres
        adres_tipi: $adres_tipi
        baslik: $baslik
        faks: $faks
        firma: $firma
        gsm: $gsm
        il_id: $il_id
        ilce_id: $ilce_id
        isim: $isim
        kurumsal_adres_mi: $kurumsal_adres_mi
        mahalle_id: $mahalle_id
        posta_kodu: $posta_kodu
        tel: $tel
        vergi_dairesi: $vergi_dairesi
        vergi_no: $vergi_no
      }
    ) {
      id
    }
  }
`
export type AdresEkleMutationFn = Apollo.MutationFunction<AdresEkleMutation, AdresEkleMutationVariables>

/**
 * __useAdresEkleMutation__
 *
 * To run a mutation, you first call `useAdresEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdresEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adresEkleMutation, { data, loading, error }] = useAdresEkleMutation({
 *   variables: {
 *      adres: // value for 'adres'
 *      adres_tipi: // value for 'adres_tipi'
 *      baslik: // value for 'baslik'
 *      faks: // value for 'faks'
 *      firma: // value for 'firma'
 *      gsm: // value for 'gsm'
 *      il_id: // value for 'il_id'
 *      ilce_id: // value for 'ilce_id'
 *      mahalle_id: // value for 'mahalle_id'
 *      isim: // value for 'isim'
 *      kurumsal_adres_mi: // value for 'kurumsal_adres_mi'
 *      posta_kodu: // value for 'posta_kodu'
 *      tel: // value for 'tel'
 *      vergi_dairesi: // value for 'vergi_dairesi'
 *      vergi_no: // value for 'vergi_no'
 *   },
 * });
 */
export function useAdresEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<AdresEkleMutation, AdresEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AdresEkleMutation, AdresEkleMutationVariables>(AdresEkleDocument, options)
}
export type AdresEkleMutationHookResult = ReturnType<typeof useAdresEkleMutation>
export type AdresEkleMutationResult = Apollo.MutationResult<AdresEkleMutation>
export type AdresEkleMutationOptions = Apollo.BaseMutationOptions<AdresEkleMutation, AdresEkleMutationVariables>
export const AdresDuzenleDocument = gql`
  mutation AdresDuzenle(
    $id: Int!
    $adres: String!
    $baslik: String!
    $gsm: String!
    $tel: String!
    $il_id: Int!
    $ilce_id: Int!
    $mahalle_id: Int!
    $isim: String!
    $posta_kodu: String!
    $faks: String!
    $firma: String!
    $vergi_dairesi: String!
    $vergi_no: String!
    $kurumsal_adres_mi: Boolean!
    $adres_tipi: String!
  ) {
    adresDuzenle(
      id: $id
      input: {
        adres: $adres
        baslik: $baslik
        gsm: $gsm
        tel: $tel
        il_id: $il_id
        ilce_id: $ilce_id
        mahalle_id: $mahalle_id
        isim: $isim
        posta_kodu: $posta_kodu
        faks: $faks
        firma: $firma
        vergi_dairesi: $vergi_dairesi
        vergi_no: $vergi_no
        kurumsal_adres_mi: $kurumsal_adres_mi
        adres_tipi: $adres_tipi
      }
    ) {
      id
    }
  }
`
export type AdresDuzenleMutationFn = Apollo.MutationFunction<AdresDuzenleMutation, AdresDuzenleMutationVariables>

/**
 * __useAdresDuzenleMutation__
 *
 * To run a mutation, you first call `useAdresDuzenleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdresDuzenleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adresDuzenleMutation, { data, loading, error }] = useAdresDuzenleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adres: // value for 'adres'
 *      baslik: // value for 'baslik'
 *      gsm: // value for 'gsm'
 *      tel: // value for 'tel'
 *      il_id: // value for 'il_id'
 *      ilce_id: // value for 'ilce_id'
 *      mahalle_id: // value for 'mahalle_id'
 *      isim: // value for 'isim'
 *      posta_kodu: // value for 'posta_kodu'
 *      faks: // value for 'faks'
 *      firma: // value for 'firma'
 *      vergi_dairesi: // value for 'vergi_dairesi'
 *      vergi_no: // value for 'vergi_no'
 *      kurumsal_adres_mi: // value for 'kurumsal_adres_mi'
 *      adres_tipi: // value for 'adres_tipi'
 *   },
 * });
 */
export function useAdresDuzenleMutation(
  baseOptions?: Apollo.MutationHookOptions<AdresDuzenleMutation, AdresDuzenleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AdresDuzenleMutation, AdresDuzenleMutationVariables>(AdresDuzenleDocument, options)
}
export type AdresDuzenleMutationHookResult = ReturnType<typeof useAdresDuzenleMutation>
export type AdresDuzenleMutationResult = Apollo.MutationResult<AdresDuzenleMutation>
export type AdresDuzenleMutationOptions = Apollo.BaseMutationOptions<
  AdresDuzenleMutation,
  AdresDuzenleMutationVariables
>
export const AdresSilDocument = gql`
  mutation AdresSil($id: Int!) {
    adresSil(id: $id)
  }
`
export type AdresSilMutationFn = Apollo.MutationFunction<AdresSilMutation, AdresSilMutationVariables>

/**
 * __useAdresSilMutation__
 *
 * To run a mutation, you first call `useAdresSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdresSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adresSilMutation, { data, loading, error }] = useAdresSilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdresSilMutation(
  baseOptions?: Apollo.MutationHookOptions<AdresSilMutation, AdresSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AdresSilMutation, AdresSilMutationVariables>(AdresSilDocument, options)
}
export type AdresSilMutationHookResult = ReturnType<typeof useAdresSilMutation>
export type AdresSilMutationResult = Apollo.MutationResult<AdresSilMutation>
export type AdresSilMutationOptions = Apollo.BaseMutationOptions<AdresSilMutation, AdresSilMutationVariables>
export const HesapBilgilerimDocument = gql`
  query HesapBilgilerim {
    profil {
      isim
      soyisim
      email
      cep_telefonu
    }
  }
`

/**
 * __useHesapBilgilerimQuery__
 *
 * To run a query within a React component, call `useHesapBilgilerimQuery` and pass it any options that fit your needs.
 * When your component renders, `useHesapBilgilerimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHesapBilgilerimQuery({
 *   variables: {
 *   },
 * });
 */
export function useHesapBilgilerimQuery(
  baseOptions?: Apollo.QueryHookOptions<HesapBilgilerimQuery, HesapBilgilerimQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<HesapBilgilerimQuery, HesapBilgilerimQueryVariables>(HesapBilgilerimDocument, options)
}
export function useHesapBilgilerimLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HesapBilgilerimQuery, HesapBilgilerimQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<HesapBilgilerimQuery, HesapBilgilerimQueryVariables>(HesapBilgilerimDocument, options)
}
export type HesapBilgilerimQueryHookResult = ReturnType<typeof useHesapBilgilerimQuery>
export type HesapBilgilerimLazyQueryHookResult = ReturnType<typeof useHesapBilgilerimLazyQuery>
export type HesapBilgilerimQueryResult = Apollo.QueryResult<HesapBilgilerimQuery, HesapBilgilerimQueryVariables>
export const SubelerDocument = gql`
  query Subeler {
    profil {
      subeler {
        isim
        id
        okul_id
      }
      isim
      is_ogretmen
      email
      is_yetkili
      is_cirosip
      ciro_yetkisi
      okul_id
    }
  }
`

/**
 * __useSubelerQuery__
 *
 * To run a query within a React component, call `useSubelerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubelerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubelerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubelerQuery(baseOptions?: Apollo.QueryHookOptions<SubelerQuery, SubelerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SubelerQuery, SubelerQueryVariables>(SubelerDocument, options)
}
export function useSubelerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubelerQuery, SubelerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SubelerQuery, SubelerQueryVariables>(SubelerDocument, options)
}
export type SubelerQueryHookResult = ReturnType<typeof useSubelerQuery>
export type SubelerLazyQueryHookResult = ReturnType<typeof useSubelerLazyQuery>
export type SubelerQueryResult = Apollo.QueryResult<SubelerQuery, SubelerQueryVariables>
export const AdreslerimDocument = gql`
  query Adreslerim {
    profil {
      adresler {
        id
        adres
        gsm
        baslik
        isim
        posta_kodu
        il {
          id
          isim
        }
        ilce {
          id
          isim
          il_id
        }
        mahalle {
          id
          isim
          ilce_id
        }
      }
    }
  }
`

/**
 * __useAdreslerimQuery__
 *
 * To run a query within a React component, call `useAdreslerimQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdreslerimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdreslerimQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdreslerimQuery(baseOptions?: Apollo.QueryHookOptions<AdreslerimQuery, AdreslerimQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AdreslerimQuery, AdreslerimQueryVariables>(AdreslerimDocument, options)
}
export function useAdreslerimLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdreslerimQuery, AdreslerimQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AdreslerimQuery, AdreslerimQueryVariables>(AdreslerimDocument, options)
}
export type AdreslerimQueryHookResult = ReturnType<typeof useAdreslerimQuery>
export type AdreslerimLazyQueryHookResult = ReturnType<typeof useAdreslerimLazyQuery>
export type AdreslerimQueryResult = Apollo.QueryResult<AdreslerimQuery, AdreslerimQueryVariables>
export const IlDocument = gql`
  query il($id: Int!) {
    il(id: $id) {
      id
      isim
    }
  }
`

/**
 * __useIlQuery__
 *
 * To run a query within a React component, call `useIlQuery` and pass it any options that fit your needs.
 * When your component renders, `useIlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIlQuery(baseOptions: Apollo.QueryHookOptions<IlQuery, IlQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IlQuery, IlQueryVariables>(IlDocument, options)
}
export function useIlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IlQuery, IlQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IlQuery, IlQueryVariables>(IlDocument, options)
}
export type IlQueryHookResult = ReturnType<typeof useIlQuery>
export type IlLazyQueryHookResult = ReturnType<typeof useIlLazyQuery>
export type IlQueryResult = Apollo.QueryResult<IlQuery, IlQueryVariables>
export const IlcelerDocument = gql`
  query ilceler($il_id: Int!) {
    ilceler(il_id: $il_id) {
      id
      il_id
      isim
    }
  }
`

/**
 * __useIlcelerQuery__
 *
 * To run a query within a React component, call `useIlcelerQuery` and pass it any options that fit your needs.
 * When your component renders, `useIlcelerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIlcelerQuery({
 *   variables: {
 *      il_id: // value for 'il_id'
 *   },
 * });
 */
export function useIlcelerQuery(baseOptions: Apollo.QueryHookOptions<IlcelerQuery, IlcelerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IlcelerQuery, IlcelerQueryVariables>(IlcelerDocument, options)
}
export function useIlcelerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IlcelerQuery, IlcelerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IlcelerQuery, IlcelerQueryVariables>(IlcelerDocument, options)
}
export type IlcelerQueryHookResult = ReturnType<typeof useIlcelerQuery>
export type IlcelerLazyQueryHookResult = ReturnType<typeof useIlcelerLazyQuery>
export type IlcelerQueryResult = Apollo.QueryResult<IlcelerQuery, IlcelerQueryVariables>
export const MahallelerDocument = gql`
  query mahalleler($ilce_id: Int!) {
    mahalleler(ilce_id: $ilce_id) {
      id
      ilce_id
      isim
    }
  }
`

/**
 * __useMahallelerQuery__
 *
 * To run a query within a React component, call `useMahallelerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMahallelerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMahallelerQuery({
 *   variables: {
 *      ilce_id: // value for 'ilce_id'
 *   },
 * });
 */
export function useMahallelerQuery(baseOptions: Apollo.QueryHookOptions<MahallelerQuery, MahallelerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MahallelerQuery, MahallelerQueryVariables>(MahallelerDocument, options)
}
export function useMahallelerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MahallelerQuery, MahallelerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MahallelerQuery, MahallelerQueryVariables>(MahallelerDocument, options)
}
export type MahallelerQueryHookResult = ReturnType<typeof useMahallelerQuery>
export type MahallelerLazyQueryHookResult = ReturnType<typeof useMahallelerLazyQuery>
export type MahallelerQueryResult = Apollo.QueryResult<MahallelerQuery, MahallelerQueryVariables>
export const IllerDocument = gql`
  query iller {
    iller {
      id
      isim
    }
  }
`

/**
 * __useIllerQuery__
 *
 * To run a query within a React component, call `useIllerQuery` and pass it any options that fit your needs.
 * When your component renders, `useIllerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIllerQuery({
 *   variables: {
 *   },
 * });
 */
export function useIllerQuery(baseOptions?: Apollo.QueryHookOptions<IllerQuery, IllerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IllerQuery, IllerQueryVariables>(IllerDocument, options)
}
export function useIllerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IllerQuery, IllerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IllerQuery, IllerQueryVariables>(IllerDocument, options)
}
export type IllerQueryHookResult = ReturnType<typeof useIllerQuery>
export type IllerLazyQueryHookResult = ReturnType<typeof useIllerLazyQuery>
export type IllerQueryResult = Apollo.QueryResult<IllerQuery, IllerQueryVariables>
export const SiniflarDocument = gql`
  query siniflar($sube_id: Int!) {
    siniflar(sube_id: $sube_id) {
      id
      isim
      mevcut
      sinif_aktif
      dersler {
        ders_id
        ders_adi
        sinif_ders_id
        ders_aktif
        ders_sirasi
        sinif_not
        ders_rengi
        ogretmen {
          ogretmen_id
        }
      }
    }
  }
`

/**
 * __useSiniflarQuery__
 *
 * To run a query within a React component, call `useSiniflarQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiniflarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiniflarQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *   },
 * });
 */
export function useSiniflarQuery(baseOptions: Apollo.QueryHookOptions<SiniflarQuery, SiniflarQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SiniflarQuery, SiniflarQueryVariables>(SiniflarDocument, options)
}
export function useSiniflarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiniflarQuery, SiniflarQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SiniflarQuery, SiniflarQueryVariables>(SiniflarDocument, options)
}
export type SiniflarQueryHookResult = ReturnType<typeof useSiniflarQuery>
export type SiniflarLazyQueryHookResult = ReturnType<typeof useSiniflarLazyQuery>
export type SiniflarQueryResult = Apollo.QueryResult<SiniflarQuery, SiniflarQueryVariables>
export const EklenenSinifDersleriDocument = gql`
  query eklenenSinifDersleri($sube_id: Int!) {
    eklenenSinifDersleri(sube_id: $sube_id) {
      eklenensinif {
        id
        isim
        sinif_ders_id
        sinif_gonderim
        dersler {
          ders_id
          ders_adi
          sinif_ders_id
          barcode
          ders_aktif
          ders_sirasi
          sinif_not
          ders_rengi
          ders_urunu_id
          urun_id
          urun_adi
          resim
          resim_url
          adet
          etiket_fiyati
          kdv_orani
        }
      }
      ogretmen
    }
  }
`

/**
 * __useEklenenSinifDersleriQuery__
 *
 * To run a query within a React component, call `useEklenenSinifDersleriQuery` and pass it any options that fit your needs.
 * When your component renders, `useEklenenSinifDersleriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEklenenSinifDersleriQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *   },
 * });
 */
export function useEklenenSinifDersleriQuery(
  baseOptions: Apollo.QueryHookOptions<EklenenSinifDersleriQuery, EklenenSinifDersleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<EklenenSinifDersleriQuery, EklenenSinifDersleriQueryVariables>(
    EklenenSinifDersleriDocument,
    options,
  )
}
export function useEklenenSinifDersleriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EklenenSinifDersleriQuery, EklenenSinifDersleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<EklenenSinifDersleriQuery, EklenenSinifDersleriQueryVariables>(
    EklenenSinifDersleriDocument,
    options,
  )
}
export type EklenenSinifDersleriQueryHookResult = ReturnType<typeof useEklenenSinifDersleriQuery>
export type EklenenSinifDersleriLazyQueryHookResult = ReturnType<typeof useEklenenSinifDersleriLazyQuery>
export type EklenenSinifDersleriQueryResult = Apollo.QueryResult<
  EklenenSinifDersleriQuery,
  EklenenSinifDersleriQueryVariables
>
export const FavorilerDocument = gql`
  query Favoriler {
    profil {
      favori_urunler {
        favori_id
        urun {
          id
          isim
          aciklama
          yayinevi
          yayinevi_slug
          yazar
          yazar_slug
          kategori
          kategori_slug
          alt_kategori
          alt_kategori_slug
          barkod
          stokkod
          kdv_orani
          etiket_fiyati
          durum
          resim_url
          resim
          tip
          tip_slug
          aktif
          ders
          ders_slug
          sinif
          sinif_slug
          pdf_url
          pdf
          oneri
          mufredat
          is_favori
        }
      }
    }
  }
`

/**
 * __useFavorilerQuery__
 *
 * To run a query within a React component, call `useFavorilerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavorilerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavorilerQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavorilerQuery(baseOptions?: Apollo.QueryHookOptions<FavorilerQuery, FavorilerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FavorilerQuery, FavorilerQueryVariables>(FavorilerDocument, options)
}
export function useFavorilerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<FavorilerQuery, FavorilerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FavorilerQuery, FavorilerQueryVariables>(FavorilerDocument, options)
}
export type FavorilerQueryHookResult = ReturnType<typeof useFavorilerQuery>
export type FavorilerLazyQueryHookResult = ReturnType<typeof useFavorilerLazyQuery>
export type FavorilerQueryResult = Apollo.QueryResult<FavorilerQuery, FavorilerQueryVariables>
export const OkulyonetimUrunlerSuggestsDocument = gql`
  query okulyonetimUrunlerSuggests($slug: String!, $filtre: OkulYonetimUrunSuggestsFiltre = {}) {
    okul(slug: $slug) {
      okulyonetimUrunlerSuggests(filtre: $filtre) {
        okulyonetim_urunler {
          urun {
            id
            isim
            resim
          }
        }
        kategoriler {
          isim
          kategori_slug
        }
        yayinevleri {
          isim
          yayinevi_slug
        }
        siniflar {
          isim
          sinif_slug
        }
      }
    }
  }
`

/**
 * __useOkulyonetimUrunlerSuggestsQuery__
 *
 * To run a query within a React component, call `useOkulyonetimUrunlerSuggestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulyonetimUrunlerSuggestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulyonetimUrunlerSuggestsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      filtre: // value for 'filtre'
 *   },
 * });
 */
export function useOkulyonetimUrunlerSuggestsQuery(
  baseOptions: Apollo.QueryHookOptions<OkulyonetimUrunlerSuggestsQuery, OkulyonetimUrunlerSuggestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulyonetimUrunlerSuggestsQuery, OkulyonetimUrunlerSuggestsQueryVariables>(
    OkulyonetimUrunlerSuggestsDocument,
    options,
  )
}
export function useOkulyonetimUrunlerSuggestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulyonetimUrunlerSuggestsQuery, OkulyonetimUrunlerSuggestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulyonetimUrunlerSuggestsQuery, OkulyonetimUrunlerSuggestsQueryVariables>(
    OkulyonetimUrunlerSuggestsDocument,
    options,
  )
}
export type OkulyonetimUrunlerSuggestsQueryHookResult = ReturnType<typeof useOkulyonetimUrunlerSuggestsQuery>
export type OkulyonetimUrunlerSuggestsLazyQueryHookResult = ReturnType<typeof useOkulyonetimUrunlerSuggestsLazyQuery>
export type OkulyonetimUrunlerSuggestsQueryResult = Apollo.QueryResult<
  OkulyonetimUrunlerSuggestsQuery,
  OkulyonetimUrunlerSuggestsQueryVariables
>
export const OkulyonetimrunlerDocument = gql`
  query Okulyonetimrunler($slug: String!, $filtre: OkulYonetimUrunFiltre = {}) {
    okul(slug: $slug) {
      okulyonetimUrunler(filtre: $filtre) {
        okulyonetim_urunler {
          urun {
            id
            isim
            aciklama
            yayinevi
            yayinevi_slug
            yazar
            yazar_slug
            kategori
            kategori_slug
            sub_alt_kategori
            alt_kategori
            alt_kategori_slug
            sub_alt_kategori_slug
            barkod
            stokkod
            kdv_orani
            etiket_fiyati
            durum
            resim_url
            resim
            tip
            tip_slug
            aktif
            ders
            ders_slug
            sinif
            sinif_slug
            pdf_url
            pdf
            oneri
            mufredat
            is_favori
          }
        }
        kategoriler {
          isim
          kategori_slug
          kategori_count
          alt_kategoriler {
            isim
            alt_kategori_slug
            alt_kategori_count
            sub_alt_kategoriler {
              isim
              sub_alt_kategori_slug
              sub_alt_kategori_count
            }
          }
        }
        yayinevleri {
          isim
          yayinevi_slug
          yayinevi_count
          isSelected
        }
        siniflar {
          isim
          sinif_slug
          sinif_count
        }
        dersler {
          isim
          ders_slug
          ders_count
        }
        toplam_urun_sayisi
      }
    }
  }
`

/**
 * __useOkulyonetimrunlerQuery__
 *
 * To run a query within a React component, call `useOkulyonetimrunlerQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulyonetimrunlerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulyonetimrunlerQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      filtre: // value for 'filtre'
 *   },
 * });
 */
export function useOkulyonetimrunlerQuery(
  baseOptions: Apollo.QueryHookOptions<OkulyonetimrunlerQuery, OkulyonetimrunlerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulyonetimrunlerQuery, OkulyonetimrunlerQueryVariables>(OkulyonetimrunlerDocument, options)
}
export function useOkulyonetimrunlerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulyonetimrunlerQuery, OkulyonetimrunlerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulyonetimrunlerQuery, OkulyonetimrunlerQueryVariables>(
    OkulyonetimrunlerDocument,
    options,
  )
}
export type OkulyonetimrunlerQueryHookResult = ReturnType<typeof useOkulyonetimrunlerQuery>
export type OkulyonetimrunlerLazyQueryHookResult = ReturnType<typeof useOkulyonetimrunlerLazyQuery>
export type OkulyonetimrunlerQueryResult = Apollo.QueryResult<OkulyonetimrunlerQuery, OkulyonetimrunlerQueryVariables>
export const OkulyonetimurunDocument = gql`
  query Okulyonetimurun($slug: String!, $filtre: OkulYonetimUrunFiltre = {}) {
    okul(slug: $slug) {
      okulyonetimUrunler(filtre: $filtre) {
        okulyonetim_urunler {
          urun {
            id
            isim
            aciklama
            yayinevi
            yayinevi_slug
            yazar
            yazar_slug
            kategori
            kategori_slug
            alt_kategori
            alt_kategori_slug
            barkod
            stokkod
            kdv_orani
            etiket_fiyati
            durum
            resim_url
            resim
            tip
            tip_slug
            aktif
            ders
            ders_slug
            sinif
            sinif_slug
            pdf_url
            pdf
            oneri
            mufredat
            is_favori
          }
        }
      }
    }
  }
`

/**
 * __useOkulyonetimurunQuery__
 *
 * To run a query within a React component, call `useOkulyonetimurunQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulyonetimurunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulyonetimurunQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      filtre: // value for 'filtre'
 *   },
 * });
 */
export function useOkulyonetimurunQuery(
  baseOptions: Apollo.QueryHookOptions<OkulyonetimurunQuery, OkulyonetimurunQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulyonetimurunQuery, OkulyonetimurunQueryVariables>(OkulyonetimurunDocument, options)
}
export function useOkulyonetimurunLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulyonetimurunQuery, OkulyonetimurunQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulyonetimurunQuery, OkulyonetimurunQueryVariables>(OkulyonetimurunDocument, options)
}
export type OkulyonetimurunQueryHookResult = ReturnType<typeof useOkulyonetimurunQuery>
export type OkulyonetimurunLazyQueryHookResult = ReturnType<typeof useOkulyonetimurunLazyQuery>
export type OkulyonetimurunQueryResult = Apollo.QueryResult<OkulyonetimurunQuery, OkulyonetimurunQueryVariables>
export const OkulCiroDocument = gql`
  query okulCiro($sube_id: Int!, $kategori_secimi: Int, $bas_tarih: String, $bit_tarih: String) {
    okulCiro(sube_id: $sube_id, bas_tarih: $bas_tarih, bit_tarih: $bit_tarih, kategori_secimi: $kategori_secimi) {
      tamamlananKdv
      tamamlananKdvDahil
      tamamlananKdvHaric
      tamamlananSiparisSayisi
      iptalKdv
      iptalKdvDahil
      iptalKdvHaric
      iptalSiparisSayisi
      toplamKdv
      toplamKdvDahil
      toplamKdvHaric
      toplamSiparisSayisi
      uyeKategorileri {
        id
        isim
      }
    }
  }
`

/**
 * __useOkulCiroQuery__
 *
 * To run a query within a React component, call `useOkulCiroQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulCiroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulCiroQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      kategori_secimi: // value for 'kategori_secimi'
 *      bas_tarih: // value for 'bas_tarih'
 *      bit_tarih: // value for 'bit_tarih'
 *   },
 * });
 */
export function useOkulCiroQuery(baseOptions: Apollo.QueryHookOptions<OkulCiroQuery, OkulCiroQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulCiroQuery, OkulCiroQueryVariables>(OkulCiroDocument, options)
}
export function useOkulCiroLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OkulCiroQuery, OkulCiroQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulCiroQuery, OkulCiroQueryVariables>(OkulCiroDocument, options)
}
export type OkulCiroQueryHookResult = ReturnType<typeof useOkulCiroQuery>
export type OkulCiroLazyQueryHookResult = ReturnType<typeof useOkulCiroLazyQuery>
export type OkulCiroQueryResult = Apollo.QueryResult<OkulCiroQuery, OkulCiroQueryVariables>
export const KategoriHiyerarsisiDocument = gql`
  query kategoriHiyerarsisi {
    kategoriHiyerarsisi {
      kategori_hiyerarsisi {
        isim
        id
        sube_id
        alt_kategoriler {
          id
          isim
          alt_kategoriler {
            isim
            id
          }
        }
      }
      yetkili_subeler {
        isim
        id
      }
    }
  }
`

/**
 * __useKategoriHiyerarsisiQuery__
 *
 * To run a query within a React component, call `useKategoriHiyerarsisiQuery` and pass it any options that fit your needs.
 * When your component renders, `useKategoriHiyerarsisiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKategoriHiyerarsisiQuery({
 *   variables: {
 *   },
 * });
 */
export function useKategoriHiyerarsisiQuery(
  baseOptions?: Apollo.QueryHookOptions<KategoriHiyerarsisiQuery, KategoriHiyerarsisiQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<KategoriHiyerarsisiQuery, KategoriHiyerarsisiQueryVariables>(
    KategoriHiyerarsisiDocument,
    options,
  )
}
export function useKategoriHiyerarsisiLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KategoriHiyerarsisiQuery, KategoriHiyerarsisiQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<KategoriHiyerarsisiQuery, KategoriHiyerarsisiQueryVariables>(
    KategoriHiyerarsisiDocument,
    options,
  )
}
export type KategoriHiyerarsisiQueryHookResult = ReturnType<typeof useKategoriHiyerarsisiQuery>
export type KategoriHiyerarsisiLazyQueryHookResult = ReturnType<typeof useKategoriHiyerarsisiLazyQuery>
export type KategoriHiyerarsisiQueryResult = Apollo.QueryResult<
  KategoriHiyerarsisiQuery,
  KategoriHiyerarsisiQueryVariables
>
export const AdminSiniflarDocument = gql`
  query adminSiniflar($sinif_kategorisi_id: Int!) {
    adminSiniflar(sinif_kategorisi_id: $sinif_kategorisi_id) {
      admin_sinif_dersler {
        mevcut
        aktif
        sinif_id
        sinif_isim
        toplam_adet
        toplam_fiyat
        dersler {
          sinif_id
          sinif_ders_id
          adet
          ogretmen_id
          ders_isim
          sinif_ders_aktif
          urun_isim
          barcode
          olusturma_tarihi
          sinif_not
          kategori
          alt_kategori
          yayinevi
          ogretmen_adi
          resim_url
          resim
          sinif_adi
          etiket_fiyati
        }
      }
    }
  }
`

/**
 * __useAdminSiniflarQuery__
 *
 * To run a query within a React component, call `useAdminSiniflarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSiniflarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSiniflarQuery({
 *   variables: {
 *      sinif_kategorisi_id: // value for 'sinif_kategorisi_id'
 *   },
 * });
 */
export function useAdminSiniflarQuery(
  baseOptions: Apollo.QueryHookOptions<AdminSiniflarQuery, AdminSiniflarQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AdminSiniflarQuery, AdminSiniflarQueryVariables>(AdminSiniflarDocument, options)
}
export function useAdminSiniflarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AdminSiniflarQuery, AdminSiniflarQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AdminSiniflarQuery, AdminSiniflarQueryVariables>(AdminSiniflarDocument, options)
}
export type AdminSiniflarQueryHookResult = ReturnType<typeof useAdminSiniflarQuery>
export type AdminSiniflarLazyQueryHookResult = ReturnType<typeof useAdminSiniflarLazyQuery>
export type AdminSiniflarQueryResult = Apollo.QueryResult<AdminSiniflarQuery, AdminSiniflarQueryVariables>
export const OkulSiparisleriDocument = gql`
  query okulSiparisleri(
    $sube_id: Int
    $bas_tarih: String
    $bit_tarih: String
    $siparis_durumu: String
    $odeme_tipi: String
    $kargo_firmasi: String
    $arama: String
    $kategori_secimi: Int
  ) {
    okulSiparisleri(
      sube_id: $sube_id
      bas_tarih: $bas_tarih
      bit_tarih: $bit_tarih
      kargo_firmasi: $kargo_firmasi
      odeme_tipi: $odeme_tipi
      siparis_durumu: $siparis_durumu
      arama: $arama
      kategori_secimi: $kategori_secimi
    ) {
      kargo_firmalari {
        isim
        id
      }
      odeme_tipleri {
        key
        value
        value
      }
      siparis_durumlari {
        value
        key
      }
      uyeKategorileri {
        id
        isim
      }
      toplamSiparis
      siparisler {
        id
        sinif_ismi
        siparis_durumu
        siparis_durumu_aciklama
        odeme_tipi_aciklama
        ogrenci_ismi
        odeme_tipi
        kargo_firmasi
        fatura_adresi
        musteri_ismi
        tarih
        teslimat_adresi
        toplam_tutar
        email
        kargo_tipi
        kargo_notu
        kargo_tipi_aciklama
        satir_sayisi
        adet_sayisi
      }
    }
  }
`

/**
 * __useOkulSiparisleriQuery__
 *
 * To run a query within a React component, call `useOkulSiparisleriQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSiparisleriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSiparisleriQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      bas_tarih: // value for 'bas_tarih'
 *      bit_tarih: // value for 'bit_tarih'
 *      siparis_durumu: // value for 'siparis_durumu'
 *      odeme_tipi: // value for 'odeme_tipi'
 *      kargo_firmasi: // value for 'kargo_firmasi'
 *      arama: // value for 'arama'
 *      kategori_secimi: // value for 'kategori_secimi'
 *   },
 * });
 */
export function useOkulSiparisleriQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSiparisleriQuery, OkulSiparisleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSiparisleriQuery, OkulSiparisleriQueryVariables>(OkulSiparisleriDocument, options)
}
export function useOkulSiparisleriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSiparisleriQuery, OkulSiparisleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSiparisleriQuery, OkulSiparisleriQueryVariables>(OkulSiparisleriDocument, options)
}
export type OkulSiparisleriQueryHookResult = ReturnType<typeof useOkulSiparisleriQuery>
export type OkulSiparisleriLazyQueryHookResult = ReturnType<typeof useOkulSiparisleriLazyQuery>
export type OkulSiparisleriQueryResult = Apollo.QueryResult<OkulSiparisleriQuery, OkulSiparisleriQueryVariables>
export const OkulSiparisDetayDocument = gql`
  query okulSiparisDetay($siparis_id: Int) {
    okulSiparisDetay(siparis_id: $siparis_id) {
      siparis_satirlari {
        siparis_id
        id
        adet
        urun
        uye
        sira
        ogrenci_ismi
        ogrenci_cinsiyet
        kimlik_no
        kalan_adet
        durum
        durum_aciklama
        birim_fiyat
      }
      siparis_bilgileri {
        GenelBilgiler {
          durum
          tarih
          bilgilendirme_maili_gonderildi
          iade_talebi
          iptal_tarihi
          order_id
          sepet
          tarih
          durum
          durum_aciklama
          trans_id
          user
          siparis_notu
        }
        OdemeBilgileri {
          toplam_tutar
          odeme_tipi
          odeme_tipi_aciklama
          havale_yapilacak_hesap
          kapida_odeme_hizmet_bedeli
          kargo_ucreti
          kargo_takip_no_listesi
          kredi_karti_pos
          kredi_karti_vade_secenegi
          vade_ucreti
        }
        TeslimatBilgileri {
          teslimat_adresi
          fatura_adresi
          kargo_firmasi
          kargo_tipi
          kargo_tipi_aciklama
        }
      }
      siparis_faturalari {
        fatura_kodu
        faturalanma_tarihi
        kargo_maili_gonderildi
        kargo_takip_no
        kargo_teslim_tarihi
        kargo_url
        kargoya_verilme_tarihi
      }
    }
  }
`

/**
 * __useOkulSiparisDetayQuery__
 *
 * To run a query within a React component, call `useOkulSiparisDetayQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSiparisDetayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSiparisDetayQuery({
 *   variables: {
 *      siparis_id: // value for 'siparis_id'
 *   },
 * });
 */
export function useOkulSiparisDetayQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSiparisDetayQuery, OkulSiparisDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSiparisDetayQuery, OkulSiparisDetayQueryVariables>(OkulSiparisDetayDocument, options)
}
export function useOkulSiparisDetayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSiparisDetayQuery, OkulSiparisDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSiparisDetayQuery, OkulSiparisDetayQueryVariables>(OkulSiparisDetayDocument, options)
}
export type OkulSiparisDetayQueryHookResult = ReturnType<typeof useOkulSiparisDetayQuery>
export type OkulSiparisDetayLazyQueryHookResult = ReturnType<typeof useOkulSiparisDetayLazyQuery>
export type OkulSiparisDetayQueryResult = Apollo.QueryResult<OkulSiparisDetayQuery, OkulSiparisDetayQueryVariables>
export const OkulSiparisSatiriDetayDocument = gql`
  query okulSiparisSatiriDetay($siparis_satiri_id: Int) {
    okulSiparisSatiriDetay(siparis_satiri_id: $siparis_satiri_id) {
      siparis_satiri {
        siparis_id
        id
        adet
        urun
        uye
        sira
        ogrenci_ismi
        ogrenci_cinsiyet
        kimlik_no
        kalan_adet
        durum
        durum_aciklama
        birim_fiyat
      }
    }
  }
`

/**
 * __useOkulSiparisSatiriDetayQuery__
 *
 * To run a query within a React component, call `useOkulSiparisSatiriDetayQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSiparisSatiriDetayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSiparisSatiriDetayQuery({
 *   variables: {
 *      siparis_satiri_id: // value for 'siparis_satiri_id'
 *   },
 * });
 */
export function useOkulSiparisSatiriDetayQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSiparisSatiriDetayQuery, OkulSiparisSatiriDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSiparisSatiriDetayQuery, OkulSiparisSatiriDetayQueryVariables>(
    OkulSiparisSatiriDetayDocument,
    options,
  )
}
export function useOkulSiparisSatiriDetayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSiparisSatiriDetayQuery, OkulSiparisSatiriDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSiparisSatiriDetayQuery, OkulSiparisSatiriDetayQueryVariables>(
    OkulSiparisSatiriDetayDocument,
    options,
  )
}
export type OkulSiparisSatiriDetayQueryHookResult = ReturnType<typeof useOkulSiparisSatiriDetayQuery>
export type OkulSiparisSatiriDetayLazyQueryHookResult = ReturnType<typeof useOkulSiparisSatiriDetayLazyQuery>
export type OkulSiparisSatiriDetayQueryResult = Apollo.QueryResult<
  OkulSiparisSatiriDetayQuery,
  OkulSiparisSatiriDetayQueryVariables
>
export const OkulSepetDetayDocument = gql`
  query okulSepetDetay($sepet_id: Int) {
    okulSepetDetay(sepet_id: $sepet_id) {
      sepet_bilgileri {
        vade_ucreti
        trans_id
        tarih
        order_id
        vade_ucreti
        degisim
        sinif_ismi
        banka_3d_onay_tarihi
        banka_odeme_tarihi
        kullanici
      }
      sepet_satirlari {
        sinif_ismi
        id
        sepet_id
        ogrenci_cinsiyet
        ogrenci_ismi
        urun
        adet
        sinif_id
        tc_kimlik_no
      }
    }
  }
`

/**
 * __useOkulSepetDetayQuery__
 *
 * To run a query within a React component, call `useOkulSepetDetayQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSepetDetayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSepetDetayQuery({
 *   variables: {
 *      sepet_id: // value for 'sepet_id'
 *   },
 * });
 */
export function useOkulSepetDetayQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSepetDetayQuery, OkulSepetDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSepetDetayQuery, OkulSepetDetayQueryVariables>(OkulSepetDetayDocument, options)
}
export function useOkulSepetDetayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSepetDetayQuery, OkulSepetDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSepetDetayQuery, OkulSepetDetayQueryVariables>(OkulSepetDetayDocument, options)
}
export type OkulSepetDetayQueryHookResult = ReturnType<typeof useOkulSepetDetayQuery>
export type OkulSepetDetayLazyQueryHookResult = ReturnType<typeof useOkulSepetDetayLazyQuery>
export type OkulSepetDetayQueryResult = Apollo.QueryResult<OkulSepetDetayQuery, OkulSepetDetayQueryVariables>
export const OkulSiparisSatirlariDocument = gql`
  query okulSiparisSatirlari(
    $sube_id: Int
    $bas_tarih: String
    $bit_tarih: String
    $siparis_durumu: String
    $odeme_tipi: String
    $kargo_firmasi: String
    $arama: String
    $kategori: Int
  ) {
    okulSiparisSatirlari(
      sube_id: $sube_id
      bas_tarih: $bas_tarih
      bit_tarih: $bit_tarih
      kargo_firmasi: $kargo_firmasi
      odeme_tipi: $odeme_tipi
      siparis_durumu: $siparis_durumu
      arama: $arama
      kategori: $kategori
    ) {
      kargo_firmalari {
        isim
        id
      }
      uyeKategorileri {
        isim
        id
      }
      odeme_tipleri {
        key
        value
      }
      siparis_durumlari {
        value
        key
      }
      toplam_siparis_satiri_sayisi
      siparis_satirlari {
        id
        adet
        urun
        birim_fiyat
        durum
        durum_aciklama
        kalan_adet
        kimlik_no
        ogrenci_cinsiyet
        barkod
        ogrenci_ismi
        siparis_id
        sira
        uye
        sinif_ismi
        email
        kdv_tutari
        kdv_haric_fiyat
        kdv_dahil
        banka
        banka_id
        odeme_tipi_aciklama
        odeme_tipi
        tarih
      }
    }
  }
`

/**
 * __useOkulSiparisSatirlariQuery__
 *
 * To run a query within a React component, call `useOkulSiparisSatirlariQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSiparisSatirlariQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSiparisSatirlariQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      bas_tarih: // value for 'bas_tarih'
 *      bit_tarih: // value for 'bit_tarih'
 *      siparis_durumu: // value for 'siparis_durumu'
 *      odeme_tipi: // value for 'odeme_tipi'
 *      kargo_firmasi: // value for 'kargo_firmasi'
 *      arama: // value for 'arama'
 *      kategori: // value for 'kategori'
 *   },
 * });
 */
export function useOkulSiparisSatirlariQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSiparisSatirlariQuery, OkulSiparisSatirlariQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSiparisSatirlariQuery, OkulSiparisSatirlariQueryVariables>(
    OkulSiparisSatirlariDocument,
    options,
  )
}
export function useOkulSiparisSatirlariLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSiparisSatirlariQuery, OkulSiparisSatirlariQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSiparisSatirlariQuery, OkulSiparisSatirlariQueryVariables>(
    OkulSiparisSatirlariDocument,
    options,
  )
}
export type OkulSiparisSatirlariQueryHookResult = ReturnType<typeof useOkulSiparisSatirlariQuery>
export type OkulSiparisSatirlariLazyQueryHookResult = ReturnType<typeof useOkulSiparisSatirlariLazyQuery>
export type OkulSiparisSatirlariQueryResult = Apollo.QueryResult<
  OkulSiparisSatirlariQuery,
  OkulSiparisSatirlariQueryVariables
>
export const OkulSepetleriDocument = gql`
  query okulSepetleri($sube_id: Int, $bas_tarih: String, $bit_tarih: String, $arama: String, $kategori_secimi: Int) {
    okulSepetleri(
      sube_id: $sube_id
      bas_tarih: $bas_tarih
      bit_tarih: $bit_tarih
      arama: $arama
      kategori_secimi: $kategori_secimi
    ) {
      toplamSepet
      sepetler {
        id
        tarih
        baslangic_tarih
        degisim
        okul
        sinif
        uye
      }
      uyeKategorileri {
        id
        isim
      }
    }
  }
`

/**
 * __useOkulSepetleriQuery__
 *
 * To run a query within a React component, call `useOkulSepetleriQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSepetleriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSepetleriQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      bas_tarih: // value for 'bas_tarih'
 *      bit_tarih: // value for 'bit_tarih'
 *      arama: // value for 'arama'
 *      kategori_secimi: // value for 'kategori_secimi'
 *   },
 * });
 */
export function useOkulSepetleriQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSepetleriQuery, OkulSepetleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSepetleriQuery, OkulSepetleriQueryVariables>(OkulSepetleriDocument, options)
}
export function useOkulSepetleriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSepetleriQuery, OkulSepetleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSepetleriQuery, OkulSepetleriQueryVariables>(OkulSepetleriDocument, options)
}
export type OkulSepetleriQueryHookResult = ReturnType<typeof useOkulSepetleriQuery>
export type OkulSepetleriLazyQueryHookResult = ReturnType<typeof useOkulSepetleriLazyQuery>
export type OkulSepetleriQueryResult = Apollo.QueryResult<OkulSepetleriQuery, OkulSepetleriQueryVariables>
export const OkulKampusleriDocument = gql`
  query okulKampusleri($sube_id: Int) {
    okulKampusleri(sube_id: $sube_id) {
      toplamKampus
      kampusler {
        id
        okul
        isim
        onay
      }
    }
  }
`

/**
 * __useOkulKampusleriQuery__
 *
 * To run a query within a React component, call `useOkulKampusleriQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulKampusleriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulKampusleriQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *   },
 * });
 */
export function useOkulKampusleriQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulKampusleriQuery, OkulKampusleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulKampusleriQuery, OkulKampusleriQueryVariables>(OkulKampusleriDocument, options)
}
export function useOkulKampusleriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulKampusleriQuery, OkulKampusleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulKampusleriQuery, OkulKampusleriQueryVariables>(OkulKampusleriDocument, options)
}
export type OkulKampusleriQueryHookResult = ReturnType<typeof useOkulKampusleriQuery>
export type OkulKampusleriLazyQueryHookResult = ReturnType<typeof useOkulKampusleriLazyQuery>
export type OkulKampusleriQueryResult = Apollo.QueryResult<OkulKampusleriQuery, OkulKampusleriQueryVariables>
export const OkulKampusYetkilileriDocument = gql`
  query okulKampusYetkilileri($sube_id: Int, $arama: String) {
    okulKampusYetkilileri(sube_id: $sube_id, arama: $arama) {
      yetkil_kampusler {
        uye
        id
        sube_isimler
      }
    }
  }
`

/**
 * __useOkulKampusYetkilileriQuery__
 *
 * To run a query within a React component, call `useOkulKampusYetkilileriQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulKampusYetkilileriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulKampusYetkilileriQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      arama: // value for 'arama'
 *   },
 * });
 */
export function useOkulKampusYetkilileriQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulKampusYetkilileriQuery, OkulKampusYetkilileriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulKampusYetkilileriQuery, OkulKampusYetkilileriQueryVariables>(
    OkulKampusYetkilileriDocument,
    options,
  )
}
export function useOkulKampusYetkilileriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulKampusYetkilileriQuery, OkulKampusYetkilileriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulKampusYetkilileriQuery, OkulKampusYetkilileriQueryVariables>(
    OkulKampusYetkilileriDocument,
    options,
  )
}
export type OkulKampusYetkilileriQueryHookResult = ReturnType<typeof useOkulKampusYetkilileriQuery>
export type OkulKampusYetkilileriLazyQueryHookResult = ReturnType<typeof useOkulKampusYetkilileriLazyQuery>
export type OkulKampusYetkilileriQueryResult = Apollo.QueryResult<
  OkulKampusYetkilileriQuery,
  OkulKampusYetkilileriQueryVariables
>
export const OkulSinifSubeleriDocument = gql`
  query okulSinifSubeleri($sube_id: Int, $arama: String) {
    okulSinifSubeleri(sube_id: $sube_id, arama: $arama) {
      sinif_subeleri {
        id
        isim
        kampus
        kampus_id
        ust_sinif_subesi
        ust_sinif_subesi_id
      }
    }
  }
`

/**
 * __useOkulSinifSubeleriQuery__
 *
 * To run a query within a React component, call `useOkulSinifSubeleriQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSinifSubeleriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSinifSubeleriQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      arama: // value for 'arama'
 *   },
 * });
 */
export function useOkulSinifSubeleriQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSinifSubeleriQuery, OkulSinifSubeleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSinifSubeleriQuery, OkulSinifSubeleriQueryVariables>(OkulSinifSubeleriDocument, options)
}
export function useOkulSinifSubeleriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSinifSubeleriQuery, OkulSinifSubeleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSinifSubeleriQuery, OkulSinifSubeleriQueryVariables>(
    OkulSinifSubeleriDocument,
    options,
  )
}
export type OkulSinifSubeleriQueryHookResult = ReturnType<typeof useOkulSinifSubeleriQuery>
export type OkulSinifSubeleriLazyQueryHookResult = ReturnType<typeof useOkulSinifSubeleriLazyQuery>
export type OkulSinifSubeleriQueryResult = Apollo.QueryResult<OkulSinifSubeleriQuery, OkulSinifSubeleriQueryVariables>
export const OkulSiniflariDocument = gql`
  query okulSiniflari($sube_id: Int, $arama: String, $sinif_sube_id: String, $kampus_id: Int) {
    okulSiniflari(sube_id: $sube_id, arama: $arama, sinif_sube_id: $sinif_sube_id, kampus_id: $kampus_id) {
      sinif_kategorileri {
        isim
        id
      }
      siniflar {
        id
        isim
        aktif
        mevcut
        kampus
        sinif_sube
        kampus_id
        kategori_id
      }
    }
  }
`

/**
 * __useOkulSiniflariQuery__
 *
 * To run a query within a React component, call `useOkulSiniflariQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSiniflariQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSiniflariQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      arama: // value for 'arama'
 *      sinif_sube_id: // value for 'sinif_sube_id'
 *      kampus_id: // value for 'kampus_id'
 *   },
 * });
 */
export function useOkulSiniflariQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSiniflariQuery, OkulSiniflariQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSiniflariQuery, OkulSiniflariQueryVariables>(OkulSiniflariDocument, options)
}
export function useOkulSiniflariLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSiniflariQuery, OkulSiniflariQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSiniflariQuery, OkulSiniflariQueryVariables>(OkulSiniflariDocument, options)
}
export type OkulSiniflariQueryHookResult = ReturnType<typeof useOkulSiniflariQuery>
export type OkulSiniflariLazyQueryHookResult = ReturnType<typeof useOkulSiniflariLazyQuery>
export type OkulSiniflariQueryResult = Apollo.QueryResult<OkulSiniflariQuery, OkulSiniflariQueryVariables>
export const OkulSiniflariOgretmenDocument = gql`
  query okulSiniflariOgretmen($sube_id: Int, $arama: String, $sinif_sube_id: String, $kampus_id: Int) {
    okulSiniflari(sube_id: $sube_id, arama: $arama, sinif_sube_id: $sinif_sube_id, kampus_id: $kampus_id) {
      siniflar {
        id
        isim
        aktif
        mevcut
        kampus
        sinif_sube
      }
    }
  }
`

/**
 * __useOkulSiniflariOgretmenQuery__
 *
 * To run a query within a React component, call `useOkulSiniflariOgretmenQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSiniflariOgretmenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSiniflariOgretmenQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      arama: // value for 'arama'
 *      sinif_sube_id: // value for 'sinif_sube_id'
 *      kampus_id: // value for 'kampus_id'
 *   },
 * });
 */
export function useOkulSiniflariOgretmenQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSiniflariOgretmenQuery, OkulSiniflariOgretmenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSiniflariOgretmenQuery, OkulSiniflariOgretmenQueryVariables>(
    OkulSiniflariOgretmenDocument,
    options,
  )
}
export function useOkulSiniflariOgretmenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSiniflariOgretmenQuery, OkulSiniflariOgretmenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSiniflariOgretmenQuery, OkulSiniflariOgretmenQueryVariables>(
    OkulSiniflariOgretmenDocument,
    options,
  )
}
export type OkulSiniflariOgretmenQueryHookResult = ReturnType<typeof useOkulSiniflariOgretmenQuery>
export type OkulSiniflariOgretmenLazyQueryHookResult = ReturnType<typeof useOkulSiniflariOgretmenLazyQuery>
export type OkulSiniflariOgretmenQueryResult = Apollo.QueryResult<
  OkulSiniflariOgretmenQuery,
  OkulSiniflariOgretmenQueryVariables
>
export const OkulSinifDersleriDocument = gql`
  query okulSinifDersleri($sube_id: Int, $arama: String, $sinif_id: String, $ogretmen_id: String, $ders_id: String) {
    okulSinifDersleri(
      sube_id: $sube_id
      arama: $arama
      sinif_id: $sinif_id
      ogretmen_id: $ogretmen_id
      ders_id: $ders_id
    ) {
      siniflar {
        isim
        id
      }
      dersler {
        id
        isim
      }
      ogretmenler {
        isim
        id
      }
      sinif_dersleri {
        id
        sinif
        ogretmen
        ders
        ogretmen_soyadi
        ogretmen_mail
        ogretmen_adi
        ogretmen_id
        sinif_id
        ders_id
      }
    }
  }
`

/**
 * __useOkulSinifDersleriQuery__
 *
 * To run a query within a React component, call `useOkulSinifDersleriQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSinifDersleriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSinifDersleriQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      arama: // value for 'arama'
 *      sinif_id: // value for 'sinif_id'
 *      ogretmen_id: // value for 'ogretmen_id'
 *      ders_id: // value for 'ders_id'
 *   },
 * });
 */
export function useOkulSinifDersleriQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSinifDersleriQuery, OkulSinifDersleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSinifDersleriQuery, OkulSinifDersleriQueryVariables>(OkulSinifDersleriDocument, options)
}
export function useOkulSinifDersleriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSinifDersleriQuery, OkulSinifDersleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSinifDersleriQuery, OkulSinifDersleriQueryVariables>(
    OkulSinifDersleriDocument,
    options,
  )
}
export type OkulSinifDersleriQueryHookResult = ReturnType<typeof useOkulSinifDersleriQuery>
export type OkulSinifDersleriLazyQueryHookResult = ReturnType<typeof useOkulSinifDersleriLazyQuery>
export type OkulSinifDersleriQueryResult = Apollo.QueryResult<OkulSinifDersleriQuery, OkulSinifDersleriQueryVariables>
export const OkulSinifUrunleriDocument = gql`
  query okulSinifUrunleri(
    $sube_id: Int
    $arama: String
    $sinif_sube_id: String
    $ders_ids: String
    $ogretmen_ids: String
    $sinif_ids: String
  ) {
    okulSinifUrunleri(
      sube_id: $sube_id
      arama: $arama
      sinif_sube_id: $sinif_sube_id
      ders_ids: $ders_ids
      ogretmen_ids: $ogretmen_ids
      sinif_ids: $sinif_ids
    ) {
      kampusler {
        id
        isim
      }
      dersler {
        id
        isim
      }
      ogretmenler {
        id
        isim
      }
      siniflar {
        id
        isim
      }
      sinif_urunleri {
        id
        sinifdersi_id
        ders
        sinif
        mevcut
        adet
        urun
        sinif_not
        barkod
        olusturma_tarihi
        ders_id
        sinif_id
        ogretmen_id
        ogretmen_mail
        ogretmen_adi
        ogretmen_soyadi
        urun_stok_id
        urun_id
      }
    }
  }
`

/**
 * __useOkulSinifUrunleriQuery__
 *
 * To run a query within a React component, call `useOkulSinifUrunleriQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulSinifUrunleriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulSinifUrunleriQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      arama: // value for 'arama'
 *      sinif_sube_id: // value for 'sinif_sube_id'
 *      ders_ids: // value for 'ders_ids'
 *      ogretmen_ids: // value for 'ogretmen_ids'
 *      sinif_ids: // value for 'sinif_ids'
 *   },
 * });
 */
export function useOkulSinifUrunleriQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulSinifUrunleriQuery, OkulSinifUrunleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulSinifUrunleriQuery, OkulSinifUrunleriQueryVariables>(OkulSinifUrunleriDocument, options)
}
export function useOkulSinifUrunleriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulSinifUrunleriQuery, OkulSinifUrunleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulSinifUrunleriQuery, OkulSinifUrunleriQueryVariables>(
    OkulSinifUrunleriDocument,
    options,
  )
}
export type OkulSinifUrunleriQueryHookResult = ReturnType<typeof useOkulSinifUrunleriQuery>
export type OkulSinifUrunleriLazyQueryHookResult = ReturnType<typeof useOkulSinifUrunleriLazyQuery>
export type OkulSinifUrunleriQueryResult = Apollo.QueryResult<OkulSinifUrunleriQuery, OkulSinifUrunleriQueryVariables>
export const OkulOgretmenleriDocument = gql`
  query okulOgretmenleri($sube_id: Int, $arama: String) {
    okulOgretmenleri(sube_id: $sube_id, arama: $arama) {
      ogretmenler {
        id
        ogretmen
        dersler
        siniflar
        sube
        okul
        cep_telefonu
        email
      }
    }
  }
`

/**
 * __useOkulOgretmenleriQuery__
 *
 * To run a query within a React component, call `useOkulOgretmenleriQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulOgretmenleriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulOgretmenleriQuery({
 *   variables: {
 *      sube_id: // value for 'sube_id'
 *      arama: // value for 'arama'
 *   },
 * });
 */
export function useOkulOgretmenleriQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulOgretmenleriQuery, OkulOgretmenleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulOgretmenleriQuery, OkulOgretmenleriQueryVariables>(OkulOgretmenleriDocument, options)
}
export function useOkulOgretmenleriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulOgretmenleriQuery, OkulOgretmenleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulOgretmenleriQuery, OkulOgretmenleriQueryVariables>(OkulOgretmenleriDocument, options)
}
export type OkulOgretmenleriQueryHookResult = ReturnType<typeof useOkulOgretmenleriQuery>
export type OkulOgretmenleriLazyQueryHookResult = ReturnType<typeof useOkulOgretmenleriLazyQuery>
export type OkulOgretmenleriQueryResult = Apollo.QueryResult<OkulOgretmenleriQuery, OkulOgretmenleriQueryVariables>
export const DersListesiOnayDurumuGuncelleDocument = gql`
  mutation dersListesiOnayDurumuGuncelle($input: DersOnayInput!) {
    dersListesiOnayDurumuGuncelle(input: $input) {
      message
      success
    }
  }
`
export type DersListesiOnayDurumuGuncelleMutationFn = Apollo.MutationFunction<
  DersListesiOnayDurumuGuncelleMutation,
  DersListesiOnayDurumuGuncelleMutationVariables
>

/**
 * __useDersListesiOnayDurumuGuncelleMutation__
 *
 * To run a mutation, you first call `useDersListesiOnayDurumuGuncelleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDersListesiOnayDurumuGuncelleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dersListesiOnayDurumuGuncelleMutation, { data, loading, error }] = useDersListesiOnayDurumuGuncelleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDersListesiOnayDurumuGuncelleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DersListesiOnayDurumuGuncelleMutation,
    DersListesiOnayDurumuGuncelleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DersListesiOnayDurumuGuncelleMutation, DersListesiOnayDurumuGuncelleMutationVariables>(
    DersListesiOnayDurumuGuncelleDocument,
    options,
  )
}
export type DersListesiOnayDurumuGuncelleMutationHookResult = ReturnType<
  typeof useDersListesiOnayDurumuGuncelleMutation
>
export type DersListesiOnayDurumuGuncelleMutationResult = Apollo.MutationResult<DersListesiOnayDurumuGuncelleMutation>
export type DersListesiOnayDurumuGuncelleMutationOptions = Apollo.BaseMutationOptions<
  DersListesiOnayDurumuGuncelleMutation,
  DersListesiOnayDurumuGuncelleMutationVariables
>
export const DerslerDocument = gql`
  query dersler {
    dersler {
      id
      isim
    }
  }
`

/**
 * __useDerslerQuery__
 *
 * To run a query within a React component, call `useDerslerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDerslerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDerslerQuery({
 *   variables: {
 *   },
 * });
 */
export function useDerslerQuery(baseOptions?: Apollo.QueryHookOptions<DerslerQuery, DerslerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DerslerQuery, DerslerQueryVariables>(DerslerDocument, options)
}
export function useDerslerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DerslerQuery, DerslerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DerslerQuery, DerslerQueryVariables>(DerslerDocument, options)
}
export type DerslerQueryHookResult = ReturnType<typeof useDerslerQuery>
export type DerslerLazyQueryHookResult = ReturnType<typeof useDerslerLazyQuery>
export type DerslerQueryResult = Apollo.QueryResult<DerslerQuery, DerslerQueryVariables>
export const OkulOgretmenDetayDocument = gql`
  query okulOgretmenDetay($ogretmen_id: Int) {
    okulOgretmenDetay(ogretmen_id: $ogretmen_id) {
      ogretmen_bilgileri {
        id
        isim
        soyisim
        email
        gsm
        kampus
        dersler
        siniflar
      }
    }
  }
`

/**
 * __useOkulOgretmenDetayQuery__
 *
 * To run a query within a React component, call `useOkulOgretmenDetayQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulOgretmenDetayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulOgretmenDetayQuery({
 *   variables: {
 *      ogretmen_id: // value for 'ogretmen_id'
 *   },
 * });
 */
export function useOkulOgretmenDetayQuery(
  baseOptions?: Apollo.QueryHookOptions<OkulOgretmenDetayQuery, OkulOgretmenDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulOgretmenDetayQuery, OkulOgretmenDetayQueryVariables>(OkulOgretmenDetayDocument, options)
}
export function useOkulOgretmenDetayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OkulOgretmenDetayQuery, OkulOgretmenDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulOgretmenDetayQuery, OkulOgretmenDetayQueryVariables>(
    OkulOgretmenDetayDocument,
    options,
  )
}
export type OkulOgretmenDetayQueryHookResult = ReturnType<typeof useOkulOgretmenDetayQuery>
export type OkulOgretmenDetayLazyQueryHookResult = ReturnType<typeof useOkulOgretmenDetayLazyQuery>
export type OkulOgretmenDetayQueryResult = Apollo.QueryResult<OkulOgretmenDetayQuery, OkulOgretmenDetayQueryVariables>
export const KampusDetayDocument = gql`
  query kampusDetay($id: Int) {
    kampusDetay(id: $id) {
      id
      okul_id
      isim
      okul_isim
    }
  }
`

/**
 * __useKampusDetayQuery__
 *
 * To run a query within a React component, call `useKampusDetayQuery` and pass it any options that fit your needs.
 * When your component renders, `useKampusDetayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKampusDetayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKampusDetayQuery(
  baseOptions?: Apollo.QueryHookOptions<KampusDetayQuery, KampusDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<KampusDetayQuery, KampusDetayQueryVariables>(KampusDetayDocument, options)
}
export function useKampusDetayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KampusDetayQuery, KampusDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<KampusDetayQuery, KampusDetayQueryVariables>(KampusDetayDocument, options)
}
export type KampusDetayQueryHookResult = ReturnType<typeof useKampusDetayQuery>
export type KampusDetayLazyQueryHookResult = ReturnType<typeof useKampusDetayLazyQuery>
export type KampusDetayQueryResult = Apollo.QueryResult<KampusDetayQuery, KampusDetayQueryVariables>
export const KampusYetkilisiDetayDocument = gql`
  query kampusYetkilisiDetay($id: Int) {
    kampusYetkilisiDetay(id: $id) {
      id
      isim
      ciro_yetkisi
      gsm
      email
      soyisim
      sifre
      sifre_onay
      kampus {
        id
        isim
      }
    }
  }
`

/**
 * __useKampusYetkilisiDetayQuery__
 *
 * To run a query within a React component, call `useKampusYetkilisiDetayQuery` and pass it any options that fit your needs.
 * When your component renders, `useKampusYetkilisiDetayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKampusYetkilisiDetayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKampusYetkilisiDetayQuery(
  baseOptions?: Apollo.QueryHookOptions<KampusYetkilisiDetayQuery, KampusYetkilisiDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<KampusYetkilisiDetayQuery, KampusYetkilisiDetayQueryVariables>(
    KampusYetkilisiDetayDocument,
    options,
  )
}
export function useKampusYetkilisiDetayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KampusYetkilisiDetayQuery, KampusYetkilisiDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<KampusYetkilisiDetayQuery, KampusYetkilisiDetayQueryVariables>(
    KampusYetkilisiDetayDocument,
    options,
  )
}
export type KampusYetkilisiDetayQueryHookResult = ReturnType<typeof useKampusYetkilisiDetayQuery>
export type KampusYetkilisiDetayLazyQueryHookResult = ReturnType<typeof useKampusYetkilisiDetayLazyQuery>
export type KampusYetkilisiDetayQueryResult = Apollo.QueryResult<
  KampusYetkilisiDetayQuery,
  KampusYetkilisiDetayQueryVariables
>
export const SinifSubeDetayDocument = gql`
  query sinifSubeDetay($id: Int) {
    sinifSubeDetay(id: $id) {
      id
      isim
      ust_kategori
      sube_id
      sube_isim
    }
  }
`

/**
 * __useSinifSubeDetayQuery__
 *
 * To run a query within a React component, call `useSinifSubeDetayQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinifSubeDetayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinifSubeDetayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSinifSubeDetayQuery(
  baseOptions?: Apollo.QueryHookOptions<SinifSubeDetayQuery, SinifSubeDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SinifSubeDetayQuery, SinifSubeDetayQueryVariables>(SinifSubeDetayDocument, options)
}
export function useSinifSubeDetayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SinifSubeDetayQuery, SinifSubeDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SinifSubeDetayQuery, SinifSubeDetayQueryVariables>(SinifSubeDetayDocument, options)
}
export type SinifSubeDetayQueryHookResult = ReturnType<typeof useSinifSubeDetayQuery>
export type SinifSubeDetayLazyQueryHookResult = ReturnType<typeof useSinifSubeDetayLazyQuery>
export type SinifSubeDetayQueryResult = Apollo.QueryResult<SinifSubeDetayQuery, SinifSubeDetayQueryVariables>
export const SinifDetayDocument = gql`
  query sinifDetay($id: Int) {
    sinifDetay(id: $id) {
      id
      isim
      sube_id
      sube_isim
      mevcut
      aktif
      sinifkategorisi_id
      sube_id
    }
  }
`

/**
 * __useSinifDetayQuery__
 *
 * To run a query within a React component, call `useSinifDetayQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinifDetayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinifDetayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSinifDetayQuery(baseOptions?: Apollo.QueryHookOptions<SinifDetayQuery, SinifDetayQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SinifDetayQuery, SinifDetayQueryVariables>(SinifDetayDocument, options)
}
export function useSinifDetayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SinifDetayQuery, SinifDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SinifDetayQuery, SinifDetayQueryVariables>(SinifDetayDocument, options)
}
export type SinifDetayQueryHookResult = ReturnType<typeof useSinifDetayQuery>
export type SinifDetayLazyQueryHookResult = ReturnType<typeof useSinifDetayLazyQuery>
export type SinifDetayQueryResult = Apollo.QueryResult<SinifDetayQuery, SinifDetayQueryVariables>
export const SinifDersiDetayDocument = gql`
  query sinifDersiDetay($id: Int) {
    sinifDersiDetay(id: $id) {
      id
      sinif_not
      sinif
      ogretmen
      ders
    }
  }
`

/**
 * __useSinifDersiDetayQuery__
 *
 * To run a query within a React component, call `useSinifDersiDetayQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinifDersiDetayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinifDersiDetayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSinifDersiDetayQuery(
  baseOptions?: Apollo.QueryHookOptions<SinifDersiDetayQuery, SinifDersiDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SinifDersiDetayQuery, SinifDersiDetayQueryVariables>(SinifDersiDetayDocument, options)
}
export function useSinifDersiDetayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SinifDersiDetayQuery, SinifDersiDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SinifDersiDetayQuery, SinifDersiDetayQueryVariables>(SinifDersiDetayDocument, options)
}
export type SinifDersiDetayQueryHookResult = ReturnType<typeof useSinifDersiDetayQuery>
export type SinifDersiDetayLazyQueryHookResult = ReturnType<typeof useSinifDersiDetayLazyQuery>
export type SinifDersiDetayQueryResult = Apollo.QueryResult<SinifDersiDetayQuery, SinifDersiDetayQueryVariables>
export const OgretmenEkleDocument = gql`
  mutation ogretmenEkle($input: KullaniciEkleInput!) {
    ogretmenEkle(input: $input) {
      success
      message
      sifre
      email
      isim
      okul_slug
      dersler
      sinifler
    }
  }
`
export type OgretmenEkleMutationFn = Apollo.MutationFunction<OgretmenEkleMutation, OgretmenEkleMutationVariables>

/**
 * __useOgretmenEkleMutation__
 *
 * To run a mutation, you first call `useOgretmenEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOgretmenEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ogretmenEkleMutation, { data, loading, error }] = useOgretmenEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOgretmenEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<OgretmenEkleMutation, OgretmenEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OgretmenEkleMutation, OgretmenEkleMutationVariables>(OgretmenEkleDocument, options)
}
export type OgretmenEkleMutationHookResult = ReturnType<typeof useOgretmenEkleMutation>
export type OgretmenEkleMutationResult = Apollo.MutationResult<OgretmenEkleMutation>
export type OgretmenEkleMutationOptions = Apollo.BaseMutationOptions<
  OgretmenEkleMutation,
  OgretmenEkleMutationVariables
>
export const KampusEkleDocument = gql`
  mutation kampusEkle($input: KampusEkleInput!) {
    kampusEkle(input: $input) {
      message
      success
    }
  }
`
export type KampusEkleMutationFn = Apollo.MutationFunction<KampusEkleMutation, KampusEkleMutationVariables>

/**
 * __useKampusEkleMutation__
 *
 * To run a mutation, you first call `useKampusEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKampusEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kampusEkleMutation, { data, loading, error }] = useKampusEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKampusEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<KampusEkleMutation, KampusEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<KampusEkleMutation, KampusEkleMutationVariables>(KampusEkleDocument, options)
}
export type KampusEkleMutationHookResult = ReturnType<typeof useKampusEkleMutation>
export type KampusEkleMutationResult = Apollo.MutationResult<KampusEkleMutation>
export type KampusEkleMutationOptions = Apollo.BaseMutationOptions<KampusEkleMutation, KampusEkleMutationVariables>
export const KampusSilDocument = gql`
  mutation kampusSil($id: [Int!]!) {
    kampusSil(id: $id) {
      success
      message
      yetkililer {
        yetkililer
        kampus
      }
    }
  }
`
export type KampusSilMutationFn = Apollo.MutationFunction<KampusSilMutation, KampusSilMutationVariables>

/**
 * __useKampusSilMutation__
 *
 * To run a mutation, you first call `useKampusSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKampusSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kampusSilMutation, { data, loading, error }] = useKampusSilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKampusSilMutation(
  baseOptions?: Apollo.MutationHookOptions<KampusSilMutation, KampusSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<KampusSilMutation, KampusSilMutationVariables>(KampusSilDocument, options)
}
export type KampusSilMutationHookResult = ReturnType<typeof useKampusSilMutation>
export type KampusSilMutationResult = Apollo.MutationResult<KampusSilMutation>
export type KampusSilMutationOptions = Apollo.BaseMutationOptions<KampusSilMutation, KampusSilMutationVariables>
export const KampusYetkilisiSilDocument = gql`
  mutation kampusYetkilisiSil($id: [Int!]!) {
    kampusYetkilisiSil(id: $id) {
      message
      success
    }
  }
`
export type KampusYetkilisiSilMutationFn = Apollo.MutationFunction<
  KampusYetkilisiSilMutation,
  KampusYetkilisiSilMutationVariables
>

/**
 * __useKampusYetkilisiSilMutation__
 *
 * To run a mutation, you first call `useKampusYetkilisiSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKampusYetkilisiSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kampusYetkilisiSilMutation, { data, loading, error }] = useKampusYetkilisiSilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKampusYetkilisiSilMutation(
  baseOptions?: Apollo.MutationHookOptions<KampusYetkilisiSilMutation, KampusYetkilisiSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<KampusYetkilisiSilMutation, KampusYetkilisiSilMutationVariables>(
    KampusYetkilisiSilDocument,
    options,
  )
}
export type KampusYetkilisiSilMutationHookResult = ReturnType<typeof useKampusYetkilisiSilMutation>
export type KampusYetkilisiSilMutationResult = Apollo.MutationResult<KampusYetkilisiSilMutation>
export type KampusYetkilisiSilMutationOptions = Apollo.BaseMutationOptions<
  KampusYetkilisiSilMutation,
  KampusYetkilisiSilMutationVariables
>
export const KampusYetkilisiEkleDocument = gql`
  mutation kampusYetkilisiEkle($input: KampusYetkiliEkleInput!) {
    kampusYetkilisiEkle(input: $input) {
      message
      success
      kampus_yetkilisi_id
    }
  }
`
export type KampusYetkilisiEkleMutationFn = Apollo.MutationFunction<
  KampusYetkilisiEkleMutation,
  KampusYetkilisiEkleMutationVariables
>

/**
 * __useKampusYetkilisiEkleMutation__
 *
 * To run a mutation, you first call `useKampusYetkilisiEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKampusYetkilisiEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kampusYetkilisiEkleMutation, { data, loading, error }] = useKampusYetkilisiEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKampusYetkilisiEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<KampusYetkilisiEkleMutation, KampusYetkilisiEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<KampusYetkilisiEkleMutation, KampusYetkilisiEkleMutationVariables>(
    KampusYetkilisiEkleDocument,
    options,
  )
}
export type KampusYetkilisiEkleMutationHookResult = ReturnType<typeof useKampusYetkilisiEkleMutation>
export type KampusYetkilisiEkleMutationResult = Apollo.MutationResult<KampusYetkilisiEkleMutation>
export type KampusYetkilisiEkleMutationOptions = Apollo.BaseMutationOptions<
  KampusYetkilisiEkleMutation,
  KampusYetkilisiEkleMutationVariables
>
export const SinifSubeTopluEkleDocument = gql`
  mutation SinifSubeTopluEkle($input: [SinifSubeCreateInput!]!) {
    sinifSubeTopluEkle(input: $input) {
      success
      message
      updatedCount
      createdCount
      errors
    }
  }
`
export type SinifSubeTopluEkleMutationFn = Apollo.MutationFunction<
  SinifSubeTopluEkleMutation,
  SinifSubeTopluEkleMutationVariables
>

/**
 * __useSinifSubeTopluEkleMutation__
 *
 * To run a mutation, you first call `useSinifSubeTopluEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifSubeTopluEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifSubeTopluEkleMutation, { data, loading, error }] = useSinifSubeTopluEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifSubeTopluEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifSubeTopluEkleMutation, SinifSubeTopluEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifSubeTopluEkleMutation, SinifSubeTopluEkleMutationVariables>(
    SinifSubeTopluEkleDocument,
    options,
  )
}
export type SinifSubeTopluEkleMutationHookResult = ReturnType<typeof useSinifSubeTopluEkleMutation>
export type SinifSubeTopluEkleMutationResult = Apollo.MutationResult<SinifSubeTopluEkleMutation>
export type SinifSubeTopluEkleMutationOptions = Apollo.BaseMutationOptions<
  SinifSubeTopluEkleMutation,
  SinifSubeTopluEkleMutationVariables
>
export const SinifSubeTopluGuncelleDocument = gql`
  mutation SinifSubeTopluGuncelle($input: [SinifSubeUpdateInput!]!) {
    sinifSubeTopluGuncelle(input: $input) {
      success
      message
      updatedCount
      createdCount
      errors
    }
  }
`
export type SinifSubeTopluGuncelleMutationFn = Apollo.MutationFunction<
  SinifSubeTopluGuncelleMutation,
  SinifSubeTopluGuncelleMutationVariables
>

/**
 * __useSinifSubeTopluGuncelleMutation__
 *
 * To run a mutation, you first call `useSinifSubeTopluGuncelleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifSubeTopluGuncelleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifSubeTopluGuncelleMutation, { data, loading, error }] = useSinifSubeTopluGuncelleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifSubeTopluGuncelleMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifSubeTopluGuncelleMutation, SinifSubeTopluGuncelleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifSubeTopluGuncelleMutation, SinifSubeTopluGuncelleMutationVariables>(
    SinifSubeTopluGuncelleDocument,
    options,
  )
}
export type SinifSubeTopluGuncelleMutationHookResult = ReturnType<typeof useSinifSubeTopluGuncelleMutation>
export type SinifSubeTopluGuncelleMutationResult = Apollo.MutationResult<SinifSubeTopluGuncelleMutation>
export type SinifSubeTopluGuncelleMutationOptions = Apollo.BaseMutationOptions<
  SinifSubeTopluGuncelleMutation,
  SinifSubeTopluGuncelleMutationVariables
>
export const SinifTopluEkleDocument = gql`
  mutation sinifTopluEkle($input: [SinifCreateInput!]!) {
    sinifTopluEkle(input: $input) {
      success
      message
      updatedCount
      createdCount
      errors
    }
  }
`
export type SinifTopluEkleMutationFn = Apollo.MutationFunction<SinifTopluEkleMutation, SinifTopluEkleMutationVariables>

/**
 * __useSinifTopluEkleMutation__
 *
 * To run a mutation, you first call `useSinifTopluEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifTopluEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifTopluEkleMutation, { data, loading, error }] = useSinifTopluEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifTopluEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifTopluEkleMutation, SinifTopluEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifTopluEkleMutation, SinifTopluEkleMutationVariables>(SinifTopluEkleDocument, options)
}
export type SinifTopluEkleMutationHookResult = ReturnType<typeof useSinifTopluEkleMutation>
export type SinifTopluEkleMutationResult = Apollo.MutationResult<SinifTopluEkleMutation>
export type SinifTopluEkleMutationOptions = Apollo.BaseMutationOptions<
  SinifTopluEkleMutation,
  SinifTopluEkleMutationVariables
>
export const SinifTopluGuncelleDocument = gql`
  mutation sinifTopluGuncelle($input: [SinifUpdateInput!]!) {
    sinifTopluGuncelle(input: $input) {
      success
      message
      updatedCount
      createdCount
      errors
    }
  }
`
export type SinifTopluGuncelleMutationFn = Apollo.MutationFunction<
  SinifTopluGuncelleMutation,
  SinifTopluGuncelleMutationVariables
>

/**
 * __useSinifTopluGuncelleMutation__
 *
 * To run a mutation, you first call `useSinifTopluGuncelleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifTopluGuncelleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifTopluGuncelleMutation, { data, loading, error }] = useSinifTopluGuncelleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifTopluGuncelleMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifTopluGuncelleMutation, SinifTopluGuncelleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifTopluGuncelleMutation, SinifTopluGuncelleMutationVariables>(
    SinifTopluGuncelleDocument,
    options,
  )
}
export type SinifTopluGuncelleMutationHookResult = ReturnType<typeof useSinifTopluGuncelleMutation>
export type SinifTopluGuncelleMutationResult = Apollo.MutationResult<SinifTopluGuncelleMutation>
export type SinifTopluGuncelleMutationOptions = Apollo.BaseMutationOptions<
  SinifTopluGuncelleMutation,
  SinifTopluGuncelleMutationVariables
>
export const SinifDersiTopluEkleDocument = gql`
  mutation sinifDersiTopluEkle($input: [sinifDersiEkleInput!]!) {
    sinifDersiTopluEkle(input: $input) {
      success
      message
      updatedCount
      createdCount
      errors
    }
  }
`
export type SinifDersiTopluEkleMutationFn = Apollo.MutationFunction<
  SinifDersiTopluEkleMutation,
  SinifDersiTopluEkleMutationVariables
>

/**
 * __useSinifDersiTopluEkleMutation__
 *
 * To run a mutation, you first call `useSinifDersiTopluEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifDersiTopluEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifDersiTopluEkleMutation, { data, loading, error }] = useSinifDersiTopluEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifDersiTopluEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifDersiTopluEkleMutation, SinifDersiTopluEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifDersiTopluEkleMutation, SinifDersiTopluEkleMutationVariables>(
    SinifDersiTopluEkleDocument,
    options,
  )
}
export type SinifDersiTopluEkleMutationHookResult = ReturnType<typeof useSinifDersiTopluEkleMutation>
export type SinifDersiTopluEkleMutationResult = Apollo.MutationResult<SinifDersiTopluEkleMutation>
export type SinifDersiTopluEkleMutationOptions = Apollo.BaseMutationOptions<
  SinifDersiTopluEkleMutation,
  SinifDersiTopluEkleMutationVariables
>
export const SinifListesiTopluEkleDocument = gql`
  mutation sinifListesiTopluEkle($input: [sinifListesiEkleInput!]!) {
    sinifListesiTopluEkle(input: $input) {
      success
      message
      updatedCount
      createdCount
      errors
    }
  }
`
export type SinifListesiTopluEkleMutationFn = Apollo.MutationFunction<
  SinifListesiTopluEkleMutation,
  SinifListesiTopluEkleMutationVariables
>

/**
 * __useSinifListesiTopluEkleMutation__
 *
 * To run a mutation, you first call `useSinifListesiTopluEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifListesiTopluEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifListesiTopluEkleMutation, { data, loading, error }] = useSinifListesiTopluEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifListesiTopluEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifListesiTopluEkleMutation, SinifListesiTopluEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifListesiTopluEkleMutation, SinifListesiTopluEkleMutationVariables>(
    SinifListesiTopluEkleDocument,
    options,
  )
}
export type SinifListesiTopluEkleMutationHookResult = ReturnType<typeof useSinifListesiTopluEkleMutation>
export type SinifListesiTopluEkleMutationResult = Apollo.MutationResult<SinifListesiTopluEkleMutation>
export type SinifListesiTopluEkleMutationOptions = Apollo.BaseMutationOptions<
  SinifListesiTopluEkleMutation,
  SinifListesiTopluEkleMutationVariables
>
export const SinifSubeSilDocument = gql`
  mutation sinifSubeSil($id: [Int!]!) {
    sinifSubeSil(id: $id) {
      message
      success
      silinemeyenler {
        id
        isim
        neden
      }
      silinenler {
        isim
        id
      }
    }
  }
`
export type SinifSubeSilMutationFn = Apollo.MutationFunction<SinifSubeSilMutation, SinifSubeSilMutationVariables>

/**
 * __useSinifSubeSilMutation__
 *
 * To run a mutation, you first call `useSinifSubeSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifSubeSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifSubeSilMutation, { data, loading, error }] = useSinifSubeSilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSinifSubeSilMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifSubeSilMutation, SinifSubeSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifSubeSilMutation, SinifSubeSilMutationVariables>(SinifSubeSilDocument, options)
}
export type SinifSubeSilMutationHookResult = ReturnType<typeof useSinifSubeSilMutation>
export type SinifSubeSilMutationResult = Apollo.MutationResult<SinifSubeSilMutation>
export type SinifSubeSilMutationOptions = Apollo.BaseMutationOptions<
  SinifSubeSilMutation,
  SinifSubeSilMutationVariables
>
export const SinifSilDocument = gql`
  mutation sinifSil($id: [Int!]!) {
    sinifSil(id: $id) {
      message
      success
      silinemeyenler {
        id
        isim
        neden
      }
      silinenler {
        isim
        id
      }
    }
  }
`
export type SinifSilMutationFn = Apollo.MutationFunction<SinifSilMutation, SinifSilMutationVariables>

/**
 * __useSinifSilMutation__
 *
 * To run a mutation, you first call `useSinifSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifSilMutation, { data, loading, error }] = useSinifSilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSinifSilMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifSilMutation, SinifSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifSilMutation, SinifSilMutationVariables>(SinifSilDocument, options)
}
export type SinifSilMutationHookResult = ReturnType<typeof useSinifSilMutation>
export type SinifSilMutationResult = Apollo.MutationResult<SinifSilMutation>
export type SinifSilMutationOptions = Apollo.BaseMutationOptions<SinifSilMutation, SinifSilMutationVariables>
export const SinifDersiSilDocument = gql`
  mutation sinifDersiSil($id: [Int!]!) {
    sinifDersiSil(id: $id) {
      message
      success
      silinemeyenler {
        id
        isim
        neden
      }
      silinenler {
        isim
        id
      }
    }
  }
`
export type SinifDersiSilMutationFn = Apollo.MutationFunction<SinifDersiSilMutation, SinifDersiSilMutationVariables>

/**
 * __useSinifDersiSilMutation__
 *
 * To run a mutation, you first call `useSinifDersiSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifDersiSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifDersiSilMutation, { data, loading, error }] = useSinifDersiSilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSinifDersiSilMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifDersiSilMutation, SinifDersiSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifDersiSilMutation, SinifDersiSilMutationVariables>(SinifDersiSilDocument, options)
}
export type SinifDersiSilMutationHookResult = ReturnType<typeof useSinifDersiSilMutation>
export type SinifDersiSilMutationResult = Apollo.MutationResult<SinifDersiSilMutation>
export type SinifDersiSilMutationOptions = Apollo.BaseMutationOptions<
  SinifDersiSilMutation,
  SinifDersiSilMutationVariables
>
export const SinifUrunuSilDocument = gql`
  mutation sinifUrunuSil($id: [Int!]!) {
    sinifUrunuSil(id: $id) {
      message
      success
      silinemeyenler {
        id
        isim
        neden
      }
      silinenler {
        isim
        id
      }
    }
  }
`
export type SinifUrunuSilMutationFn = Apollo.MutationFunction<SinifUrunuSilMutation, SinifUrunuSilMutationVariables>

/**
 * __useSinifUrunuSilMutation__
 *
 * To run a mutation, you first call `useSinifUrunuSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifUrunuSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifUrunuSilMutation, { data, loading, error }] = useSinifUrunuSilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSinifUrunuSilMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifUrunuSilMutation, SinifUrunuSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifUrunuSilMutation, SinifUrunuSilMutationVariables>(SinifUrunuSilDocument, options)
}
export type SinifUrunuSilMutationHookResult = ReturnType<typeof useSinifUrunuSilMutation>
export type SinifUrunuSilMutationResult = Apollo.MutationResult<SinifUrunuSilMutation>
export type SinifUrunuSilMutationOptions = Apollo.BaseMutationOptions<
  SinifUrunuSilMutation,
  SinifUrunuSilMutationVariables
>
export const SinifListesiSilDocument = gql`
  mutation sinifListesiSil($id: [Int!]!) {
    sinifListesiSil(id: $id) {
      message
      success
      silinemeyenler {
        id
        isim
        neden
      }
      silinenler {
        isim
        id
      }
    }
  }
`
export type SinifListesiSilMutationFn = Apollo.MutationFunction<
  SinifListesiSilMutation,
  SinifListesiSilMutationVariables
>

/**
 * __useSinifListesiSilMutation__
 *
 * To run a mutation, you first call `useSinifListesiSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifListesiSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifListesiSilMutation, { data, loading, error }] = useSinifListesiSilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSinifListesiSilMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifListesiSilMutation, SinifListesiSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifListesiSilMutation, SinifListesiSilMutationVariables>(SinifListesiSilDocument, options)
}
export type SinifListesiSilMutationHookResult = ReturnType<typeof useSinifListesiSilMutation>
export type SinifListesiSilMutationResult = Apollo.MutationResult<SinifListesiSilMutation>
export type SinifListesiSilMutationOptions = Apollo.BaseMutationOptions<
  SinifListesiSilMutation,
  SinifListesiSilMutationVariables
>
export const OgretmenSilDocument = gql`
  mutation ogretmenSil($id: [Int!]!) {
    ogretmenSil(id: $id) {
      message
      success
      silinemeyenler {
        id
        isim
        neden
        ilgili_kayitlar
      }
      silinenler {
        isim
        id
      }
    }
  }
`
export type OgretmenSilMutationFn = Apollo.MutationFunction<OgretmenSilMutation, OgretmenSilMutationVariables>

/**
 * __useOgretmenSilMutation__
 *
 * To run a mutation, you first call `useOgretmenSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOgretmenSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ogretmenSilMutation, { data, loading, error }] = useOgretmenSilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOgretmenSilMutation(
  baseOptions?: Apollo.MutationHookOptions<OgretmenSilMutation, OgretmenSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OgretmenSilMutation, OgretmenSilMutationVariables>(OgretmenSilDocument, options)
}
export type OgretmenSilMutationHookResult = ReturnType<typeof useOgretmenSilMutation>
export type OgretmenSilMutationResult = Apollo.MutationResult<OgretmenSilMutation>
export type OgretmenSilMutationOptions = Apollo.BaseMutationOptions<OgretmenSilMutation, OgretmenSilMutationVariables>
export const SepetSatiriSilDocument = gql`
  mutation sepetSatiriSil($id: Int!) {
    sepetSatiriSil(id: $id) {
      message
      success
    }
  }
`
export type SepetSatiriSilMutationFn = Apollo.MutationFunction<SepetSatiriSilMutation, SepetSatiriSilMutationVariables>

/**
 * __useSepetSatiriSilMutation__
 *
 * To run a mutation, you first call `useSepetSatiriSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSepetSatiriSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sepetSatiriSilMutation, { data, loading, error }] = useSepetSatiriSilMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSepetSatiriSilMutation(
  baseOptions?: Apollo.MutationHookOptions<SepetSatiriSilMutation, SepetSatiriSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SepetSatiriSilMutation, SepetSatiriSilMutationVariables>(SepetSatiriSilDocument, options)
}
export type SepetSatiriSilMutationHookResult = ReturnType<typeof useSepetSatiriSilMutation>
export type SepetSatiriSilMutationResult = Apollo.MutationResult<SepetSatiriSilMutation>
export type SepetSatiriSilMutationOptions = Apollo.BaseMutationOptions<
  SepetSatiriSilMutation,
  SepetSatiriSilMutationVariables
>
export const SinifSubeEkleDocument = gql`
  mutation sinifSubeEkle($input: sinifSubeEkleInput!) {
    sinifSubeEkle(input: $input) {
      message
      success
      id
    }
  }
`
export type SinifSubeEkleMutationFn = Apollo.MutationFunction<SinifSubeEkleMutation, SinifSubeEkleMutationVariables>

/**
 * __useSinifSubeEkleMutation__
 *
 * To run a mutation, you first call `useSinifSubeEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifSubeEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifSubeEkleMutation, { data, loading, error }] = useSinifSubeEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifSubeEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifSubeEkleMutation, SinifSubeEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifSubeEkleMutation, SinifSubeEkleMutationVariables>(SinifSubeEkleDocument, options)
}
export type SinifSubeEkleMutationHookResult = ReturnType<typeof useSinifSubeEkleMutation>
export type SinifSubeEkleMutationResult = Apollo.MutationResult<SinifSubeEkleMutation>
export type SinifSubeEkleMutationOptions = Apollo.BaseMutationOptions<
  SinifSubeEkleMutation,
  SinifSubeEkleMutationVariables
>
export const SinifEkleDocument = gql`
  mutation sinifEkle($input: sinifEkleInput!) {
    sinifEkle(input: $input) {
      message
      success
      id
    }
  }
`
export type SinifEkleMutationFn = Apollo.MutationFunction<SinifEkleMutation, SinifEkleMutationVariables>

/**
 * __useSinifEkleMutation__
 *
 * To run a mutation, you first call `useSinifEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifEkleMutation, { data, loading, error }] = useSinifEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifEkleMutation, SinifEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifEkleMutation, SinifEkleMutationVariables>(SinifEkleDocument, options)
}
export type SinifEkleMutationHookResult = ReturnType<typeof useSinifEkleMutation>
export type SinifEkleMutationResult = Apollo.MutationResult<SinifEkleMutation>
export type SinifEkleMutationOptions = Apollo.BaseMutationOptions<SinifEkleMutation, SinifEkleMutationVariables>
export const SinifDersiEkleDocument = gql`
  mutation sinifDersiEkle($input: sinifDersiEkleInput!) {
    sinifDersiEkle(input: $input) {
      message
      success
      id
    }
  }
`
export type SinifDersiEkleMutationFn = Apollo.MutationFunction<SinifDersiEkleMutation, SinifDersiEkleMutationVariables>

/**
 * __useSinifDersiEkleMutation__
 *
 * To run a mutation, you first call `useSinifDersiEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifDersiEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifDersiEkleMutation, { data, loading, error }] = useSinifDersiEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifDersiEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifDersiEkleMutation, SinifDersiEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifDersiEkleMutation, SinifDersiEkleMutationVariables>(SinifDersiEkleDocument, options)
}
export type SinifDersiEkleMutationHookResult = ReturnType<typeof useSinifDersiEkleMutation>
export type SinifDersiEkleMutationResult = Apollo.MutationResult<SinifDersiEkleMutation>
export type SinifDersiEkleMutationOptions = Apollo.BaseMutationOptions<
  SinifDersiEkleMutation,
  SinifDersiEkleMutationVariables
>
export const StartExportDocument = gql`
  mutation startExport($input: ExportParams!) {
    startExport(params: $input) {
      id
      resultUrl
      status
      createdAt
      updatedAt
    }
  }
`
export type StartExportMutationFn = Apollo.MutationFunction<StartExportMutation, StartExportMutationVariables>

/**
 * __useStartExportMutation__
 *
 * To run a mutation, you first call `useStartExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExportMutation, { data, loading, error }] = useStartExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartExportMutation(
  baseOptions?: Apollo.MutationHookOptions<StartExportMutation, StartExportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<StartExportMutation, StartExportMutationVariables>(StartExportDocument, options)
}
export type StartExportMutationHookResult = ReturnType<typeof useStartExportMutation>
export type StartExportMutationResult = Apollo.MutationResult<StartExportMutation>
export type StartExportMutationOptions = Apollo.BaseMutationOptions<StartExportMutation, StartExportMutationVariables>
export const LoginDocument = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      user_id
      token
      expire_at
      errorMessage
    }
  }
`
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options)
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>
export const RefreshTokenDocument = gql`
  mutation RefreshToken {
    refreshToken {
      user_id
      token
      expire_at
      errorMessage
    }
  }
`
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options)
}
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>
export const YeniUyeDocument = gql`
  mutation YeniUye($email: String!, $isim: String!, $soyisim: String!, $cep_telefonu: String, $sifre: String!) {
    yeniUye(input: { email: $email, isim: $isim, soyisim: $soyisim, cep_telefonu: $cep_telefonu, sifre: $sifre }) {
      user_id
      token
      expire_at
      errorMessage
    }
  }
`
export type YeniUyeMutationFn = Apollo.MutationFunction<YeniUyeMutation, YeniUyeMutationVariables>

/**
 * __useYeniUyeMutation__
 *
 * To run a mutation, you first call `useYeniUyeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useYeniUyeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [yeniUyeMutation, { data, loading, error }] = useYeniUyeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      isim: // value for 'isim'
 *      soyisim: // value for 'soyisim'
 *      cep_telefonu: // value for 'cep_telefonu'
 *      sifre: // value for 'sifre'
 *   },
 * });
 */
export function useYeniUyeMutation(
  baseOptions?: Apollo.MutationHookOptions<YeniUyeMutation, YeniUyeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<YeniUyeMutation, YeniUyeMutationVariables>(YeniUyeDocument, options)
}
export type YeniUyeMutationHookResult = ReturnType<typeof useYeniUyeMutation>
export type YeniUyeMutationResult = Apollo.MutationResult<YeniUyeMutation>
export type YeniUyeMutationOptions = Apollo.BaseMutationOptions<YeniUyeMutation, YeniUyeMutationVariables>
export const UyeMailGuncelleDocument = gql`
  mutation uyeMailGuncelle($email: String!) {
    uyeMailGuncelle(email: $email) {
      success
      message
    }
  }
`
export type UyeMailGuncelleMutationFn = Apollo.MutationFunction<
  UyeMailGuncelleMutation,
  UyeMailGuncelleMutationVariables
>

/**
 * __useUyeMailGuncelleMutation__
 *
 * To run a mutation, you first call `useUyeMailGuncelleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUyeMailGuncelleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uyeMailGuncelleMutation, { data, loading, error }] = useUyeMailGuncelleMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUyeMailGuncelleMutation(
  baseOptions?: Apollo.MutationHookOptions<UyeMailGuncelleMutation, UyeMailGuncelleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UyeMailGuncelleMutation, UyeMailGuncelleMutationVariables>(UyeMailGuncelleDocument, options)
}
export type UyeMailGuncelleMutationHookResult = ReturnType<typeof useUyeMailGuncelleMutation>
export type UyeMailGuncelleMutationResult = Apollo.MutationResult<UyeMailGuncelleMutation>
export type UyeMailGuncelleMutationOptions = Apollo.BaseMutationOptions<
  UyeMailGuncelleMutation,
  UyeMailGuncelleMutationVariables
>
export const SepetPaketDuzenleDocument = gql`
  mutation SepetPaketDuzenle($okulSlug: String!, $sinifId: Int!, $urunler: [SepetUrunuInput]) {
    sepetPaketDuzenleTest(okul_slug: $okulSlug, sinif_id: $sinifId, urunler: $urunler) {
      id
      okul_slug
      sinif {
        id
        isim
        kampus_adi
        kapali_uyarisi
        aktif
        ders_kirilimi
        indirim
      }
      urunler {
        id
        urun {
          id
          isim
          kategori {
            id
            isim
            resim
            ust_kategori_id
          }
          marka {
            id
            isim
          }
          yazar
          resim
          sinif_seviyesi
          kdv_yuzde
          kisa_aciklama
          kitap_kaplama
          bilgiler {
            isim
            deger
            tip
          }
          grup {
            id
            isim
            resimler
          }
          aciklamalar
          aktif
          kargodan_muaf
          resimler
        }
        sinif_id
        adet
        indirimsiz_birim_fiyat
        indirimli_birim_fiyat
        indirimsiz_fiyat
        indirimli_fiyat
        indirim
        readonly
      }
      ogretmen_indirimi_uygulandi
      ogretmen_indirimi_tutari
    }
  }
`
export type SepetPaketDuzenleMutationFn = Apollo.MutationFunction<
  SepetPaketDuzenleMutation,
  SepetPaketDuzenleMutationVariables
>

/**
 * __useSepetPaketDuzenleMutation__
 *
 * To run a mutation, you first call `useSepetPaketDuzenleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSepetPaketDuzenleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sepetPaketDuzenleMutation, { data, loading, error }] = useSepetPaketDuzenleMutation({
 *   variables: {
 *      okulSlug: // value for 'okulSlug'
 *      sinifId: // value for 'sinifId'
 *      urunler: // value for 'urunler'
 *   },
 * });
 */
export function useSepetPaketDuzenleMutation(
  baseOptions?: Apollo.MutationHookOptions<SepetPaketDuzenleMutation, SepetPaketDuzenleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SepetPaketDuzenleMutation, SepetPaketDuzenleMutationVariables>(
    SepetPaketDuzenleDocument,
    options,
  )
}
export type SepetPaketDuzenleMutationHookResult = ReturnType<typeof useSepetPaketDuzenleMutation>
export type SepetPaketDuzenleMutationResult = Apollo.MutationResult<SepetPaketDuzenleMutation>
export type SepetPaketDuzenleMutationOptions = Apollo.BaseMutationOptions<
  SepetPaketDuzenleMutation,
  SepetPaketDuzenleMutationVariables
>
export const SepetUrunSilDocument = gql`
  mutation SepetUrunSil($okulSlug: String!, $urunId: Int!) {
    sepetUrunSilTest(okul_slug: $okulSlug, urun_id: $urunId) {
      id
      okul_slug
      sinif {
        id
        isim
        kampus_adi
        kapali_uyarisi
        aktif
        ders_kirilimi
        indirim
      }
      urunler {
        id
        urun {
          id
          isim
          kategori {
            id
            isim
            resim
            ust_kategori_id
          }
          marka {
            id
            isim
          }
          yazar
          resim
          sinif_seviyesi
          kdv_yuzde
          kisa_aciklama
          kitap_kaplama
          bilgiler {
            isim
            deger
            tip
          }
          grup {
            id
            isim
            resimler
          }
          aciklamalar
          aktif
          kargodan_muaf
          resimler
        }
        sinif_id
        adet
        indirimsiz_birim_fiyat
        indirimli_birim_fiyat
        indirimsiz_fiyat
        indirimli_fiyat
        indirim
        readonly
      }
      ogretmen_indirimi_uygulandi
      ogretmen_indirimi_tutari
    }
  }
`
export type SepetUrunSilMutationFn = Apollo.MutationFunction<SepetUrunSilMutation, SepetUrunSilMutationVariables>

/**
 * __useSepetUrunSilMutation__
 *
 * To run a mutation, you first call `useSepetUrunSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSepetUrunSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sepetUrunSilMutation, { data, loading, error }] = useSepetUrunSilMutation({
 *   variables: {
 *      okulSlug: // value for 'okulSlug'
 *      urunId: // value for 'urunId'
 *   },
 * });
 */
export function useSepetUrunSilMutation(
  baseOptions?: Apollo.MutationHookOptions<SepetUrunSilMutation, SepetUrunSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SepetUrunSilMutation, SepetUrunSilMutationVariables>(SepetUrunSilDocument, options)
}
export type SepetUrunSilMutationHookResult = ReturnType<typeof useSepetUrunSilMutation>
export type SepetUrunSilMutationResult = Apollo.MutationResult<SepetUrunSilMutation>
export type SepetUrunSilMutationOptions = Apollo.BaseMutationOptions<
  SepetUrunSilMutation,
  SepetUrunSilMutationVariables
>
export const SepetUrunDuzenleDocument = gql`
  mutation SepetUrunDuzenle($okulSlug: String!, $urun: SepetUrunuInput) {
    sepetUrunDuzenleTest(okul_slug: $okulSlug, urun: $urun) {
      id
      okul_slug
      sinif {
        id
        isim
        kampus_adi
        kapali_uyarisi
        aktif
        ders_kirilimi
        indirim
      }
      urunler {
        id
        urun {
          id
          isim
          kategori {
            id
            isim
            resim
            ust_kategori_id
          }
          marka {
            id
            isim
          }
          yazar
          resim
          sinif_seviyesi
          kdv_yuzde
          kisa_aciklama
          kitap_kaplama
          bilgiler {
            isim
            deger
            tip
          }
          grup {
            id
            isim
            resimler
          }
          aciklamalar
          aktif
          kargodan_muaf
          resimler
        }
        sinif_id
        adet
        indirimsiz_birim_fiyat
        indirimli_birim_fiyat
        indirimsiz_fiyat
        indirimli_fiyat
        indirim
        readonly
      }
      ogretmen_indirimi_uygulandi
      ogretmen_indirimi_tutari
    }
  }
`
export type SepetUrunDuzenleMutationFn = Apollo.MutationFunction<
  SepetUrunDuzenleMutation,
  SepetUrunDuzenleMutationVariables
>

/**
 * __useSepetUrunDuzenleMutation__
 *
 * To run a mutation, you first call `useSepetUrunDuzenleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSepetUrunDuzenleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sepetUrunDuzenleMutation, { data, loading, error }] = useSepetUrunDuzenleMutation({
 *   variables: {
 *      okulSlug: // value for 'okulSlug'
 *      urun: // value for 'urun'
 *   },
 * });
 */
export function useSepetUrunDuzenleMutation(
  baseOptions?: Apollo.MutationHookOptions<SepetUrunDuzenleMutation, SepetUrunDuzenleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SepetUrunDuzenleMutation, SepetUrunDuzenleMutationVariables>(
    SepetUrunDuzenleDocument,
    options,
  )
}
export type SepetUrunDuzenleMutationHookResult = ReturnType<typeof useSepetUrunDuzenleMutation>
export type SepetUrunDuzenleMutationResult = Apollo.MutationResult<SepetUrunDuzenleMutation>
export type SepetUrunDuzenleMutationOptions = Apollo.BaseMutationOptions<
  SepetUrunDuzenleMutation,
  SepetUrunDuzenleMutationVariables
>
export const SepetiBosaltDocument = gql`
  mutation SepetiBosalt($okulSlug: String!) {
    sepetiBosaltTest(okul_slug: $okulSlug) {
      id
      okul_slug
      sinif {
        id
        isim
        kampus_adi
        kapali_uyarisi
        aktif
        ders_kirilimi
        indirim
      }
      urunler {
        id
        urun {
          id
          isim
          kategori {
            id
            isim
            resim
            ust_kategori_id
          }
          marka {
            id
            isim
          }
          yazar
          resim
          sinif_seviyesi
          kdv_yuzde
          kisa_aciklama
          kitap_kaplama
          bilgiler {
            isim
            deger
            tip
          }
          grup {
            id
            isim
            resimler
          }
          aciklamalar
          aktif
          kargodan_muaf
          resimler
        }
        sinif_id
        adet
        indirimsiz_birim_fiyat
        indirimli_birim_fiyat
        indirimsiz_fiyat
        indirimli_fiyat
        indirim
        readonly
      }
      ogretmen_indirimi_uygulandi
      ogretmen_indirimi_tutari
    }
  }
`
export type SepetiBosaltMutationFn = Apollo.MutationFunction<SepetiBosaltMutation, SepetiBosaltMutationVariables>

/**
 * __useSepetiBosaltMutation__
 *
 * To run a mutation, you first call `useSepetiBosaltMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSepetiBosaltMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sepetiBosaltMutation, { data, loading, error }] = useSepetiBosaltMutation({
 *   variables: {
 *      okulSlug: // value for 'okulSlug'
 *   },
 * });
 */
export function useSepetiBosaltMutation(
  baseOptions?: Apollo.MutationHookOptions<SepetiBosaltMutation, SepetiBosaltMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SepetiBosaltMutation, SepetiBosaltMutationVariables>(SepetiBosaltDocument, options)
}
export type SepetiBosaltMutationHookResult = ReturnType<typeof useSepetiBosaltMutation>
export type SepetiBosaltMutationResult = Apollo.MutationResult<SepetiBosaltMutation>
export type SepetiBosaltMutationOptions = Apollo.BaseMutationOptions<
  SepetiBosaltMutation,
  SepetiBosaltMutationVariables
>
export const SepetPaketSilDocument = gql`
  mutation SepetPaketSil($okulSlug: String!, $sinifId: Int!) {
    sepetPaketSilTest(okul_slug: $okulSlug, sinif_id: $sinifId) {
      id
      okul_slug
      sinif {
        id
        isim
        kampus_adi
        kapali_uyarisi
        aktif
        ders_kirilimi
        indirim
      }
      urunler {
        id
        urun {
          id
          isim
          kategori {
            id
            isim
            resim
            ust_kategori_id
          }
          marka {
            id
            isim
          }
          yazar
          resim
          sinif_seviyesi
          kdv_yuzde
          kisa_aciklama
          kitap_kaplama
          bilgiler {
            isim
            deger
            tip
          }
          grup {
            id
            isim
            resimler
          }
          aciklamalar
          aktif
          kargodan_muaf
          resimler
        }
        sinif_id
        adet
        indirimsiz_birim_fiyat
        indirimli_birim_fiyat
        indirimsiz_fiyat
        indirimli_fiyat
        indirim
        readonly
      }
      ogretmen_indirimi_uygulandi
      ogretmen_indirimi_tutari
    }
  }
`
export type SepetPaketSilMutationFn = Apollo.MutationFunction<SepetPaketSilMutation, SepetPaketSilMutationVariables>

/**
 * __useSepetPaketSilMutation__
 *
 * To run a mutation, you first call `useSepetPaketSilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSepetPaketSilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sepetPaketSilMutation, { data, loading, error }] = useSepetPaketSilMutation({
 *   variables: {
 *      okulSlug: // value for 'okulSlug'
 *      sinifId: // value for 'sinifId'
 *   },
 * });
 */
export function useSepetPaketSilMutation(
  baseOptions?: Apollo.MutationHookOptions<SepetPaketSilMutation, SepetPaketSilMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SepetPaketSilMutation, SepetPaketSilMutationVariables>(SepetPaketSilDocument, options)
}
export type SepetPaketSilMutationHookResult = ReturnType<typeof useSepetPaketSilMutation>
export type SepetPaketSilMutationResult = Apollo.MutationResult<SepetPaketSilMutation>
export type SepetPaketSilMutationOptions = Apollo.BaseMutationOptions<
  SepetPaketSilMutation,
  SepetPaketSilMutationVariables
>
export const SepetDocument = gql`
  query Sepet($slug: String!) {
    sepetTest(okul_slug: $slug) {
      id
      ogretmen_indirimi_uygulandi
      ogretmen_indirimi_tutari
      okul_slug
      sinif {
        aktif
        ders_kirilimi
        id
        indirim
        kampus_adi
        isim
        kapali_uyarisi
      }
      urunler {
        adet
        stok
        max_adet
        indirim
        id
        indirimli_birim_fiyat
        indirimli_fiyat
        indirimsiz_birim_fiyat
        indirimsiz_fiyat
        readonly
        sinif_id
        ogrenci_ismi
        urun {
          aciklamalar
          aktif
          bilgiler {
            deger
            isim
            tip
          }
          grup {
            id
            isim
            resimler
          }
          id
          isim
          kargodan_muaf
          dinamik_koli
          okul_indirimi
          kategori {
            id
            isim
            resim
            ust_kategori_id
          }
          resim
          marka {
            id
            isim
          }
          kdv_yuzde
          kisa_aciklama
          kitap_kaplama
          resimler
          sinif_seviyesi
          yazar
        }
      }
    }
  }
`

/**
 * __useSepetQuery__
 *
 * To run a query within a React component, call `useSepetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSepetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSepetQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSepetQuery(baseOptions: Apollo.QueryHookOptions<SepetQuery, SepetQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SepetQuery, SepetQueryVariables>(SepetDocument, options)
}
export function useSepetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SepetQuery, SepetQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SepetQuery, SepetQueryVariables>(SepetDocument, options)
}
export type SepetQueryHookResult = ReturnType<typeof useSepetQuery>
export type SepetLazyQueryHookResult = ReturnType<typeof useSepetLazyQuery>
export type SepetQueryResult = Apollo.QueryResult<SepetQuery, SepetQueryVariables>
export const SepetePaketEkleDocument = gql`
  mutation SepetePaketEkle($okul_slug: String!, $sinif_id: Int!, $urunler: [SepetUrunuInput]) {
    sepetPaketEkleTest(okul_slug: $okul_slug, sinif_id: $sinif_id, urunler: $urunler) {
      id
    }
  }
`
export type SepetePaketEkleMutationFn = Apollo.MutationFunction<
  SepetePaketEkleMutation,
  SepetePaketEkleMutationVariables
>

/**
 * __useSepetePaketEkleMutation__
 *
 * To run a mutation, you first call `useSepetePaketEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSepetePaketEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sepetePaketEkleMutation, { data, loading, error }] = useSepetePaketEkleMutation({
 *   variables: {
 *      okul_slug: // value for 'okul_slug'
 *      sinif_id: // value for 'sinif_id'
 *      urunler: // value for 'urunler'
 *   },
 * });
 */
export function useSepetePaketEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<SepetePaketEkleMutation, SepetePaketEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SepetePaketEkleMutation, SepetePaketEkleMutationVariables>(SepetePaketEkleDocument, options)
}
export type SepetePaketEkleMutationHookResult = ReturnType<typeof useSepetePaketEkleMutation>
export type SepetePaketEkleMutationResult = Apollo.MutationResult<SepetePaketEkleMutation>
export type SepetePaketEkleMutationOptions = Apollo.BaseMutationOptions<
  SepetePaketEkleMutation,
  SepetePaketEkleMutationVariables
>
export const SinifUrunleriDocument = gql`
  query SinifUrunleri($slug: String!, $sinif_id: Int!) {
    okul(slug: $slug) {
      active
      capraz_urun_satis_popupi_varmi
      indirim
      indirimli_fiyat_gosterimi
      id
      isim
      kapida_odeme_tutari
      kapida_odeme_varmi
      kargo_tutar_kosulu
      kargo_tutari
      ogrenci_girisi_varmi
      tab_gosterim
      tekstil_toplu_satis
      logo
      uyari
      sinif(sinif_id: $sinif_id) {
        aktif
        uye_indirim_var
        duyuru_popup
        id
        indirim
        isim
        kampus_adi
        kapali_uyarisi
        ders_kirilimi
        kategori_id
        liste_resmi
        sifre_varmi
        paket_resmi
        sepet_icinde_degistirme_varmi
        sinif_seviyesi
        sira
        urunler_secili_gelsin
        uyari
        sinif_urunleri_test {
          adet
          ders {
            id
            isim
            renk
            ders_sira
          }
          indirimli_birim_fiyat
          indirimsiz_birim_fiyat
          min_adet
          max_adet
          stok
          position
          sinif_id
          sinif_liste_notu
          urun {
            aciklamalar
            aktif
            dinamik_koli
            dinamik_koli_siparis_aktarma
            urun_kademeleri
            okul_indirimi
            sira
            bilgiler {
              deger
              isim
              tip
            }
            grup {
              id
              isim
              resimler
              sira
            }
            isim
            id
            kargodan_muaf
            kategori {
              id
              isim
              resim
              ust_kategori_id
            }
            kdv_yuzde
            kisa_aciklama
            kitap_kaplama
            marka {
              id
              isim
            }
            resim
            resimler
            sinif_seviyesi
            yazar
          }
          urun_id
          zorunluluk_grubu
        }
        sinif_urunleri_test {
          adet
          ders {
            id
            isim
            renk
            ders_sira
          }
          indirimli_birim_fiyat
          indirimsiz_birim_fiyat
          min_adet
          stok
          position
          sinif_id
          sinif_liste_notu
          urun {
            aciklamalar
            aktif
            dinamik_koli_siparis_aktarma
            urun_kademeleri
            okul_indirimi
            sira
            bilgiler {
              deger
              isim
              tip
            }
            grup {
              id
              isim
              resimler
              sira
            }
            isim
            id
            kargodan_muaf
            kategori {
              id
              isim
              resim
              ust_kategori_id
            }
            kdv_yuzde
            kisa_aciklama
            kitap_kaplama
            marka {
              id
              isim
            }
            resim
            resimler
            sinif_seviyesi
            yazar
          }
          urun_id
          zorunluluk_grubu
        }
      }
    }
  }
`

/**
 * __useSinifUrunleriQuery__
 *
 * To run a query within a React component, call `useSinifUrunleriQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinifUrunleriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinifUrunleriQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      sinif_id: // value for 'sinif_id'
 *   },
 * });
 */
export function useSinifUrunleriQuery(
  baseOptions: Apollo.QueryHookOptions<SinifUrunleriQuery, SinifUrunleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SinifUrunleriQuery, SinifUrunleriQueryVariables>(SinifUrunleriDocument, options)
}
export function useSinifUrunleriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SinifUrunleriQuery, SinifUrunleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SinifUrunleriQuery, SinifUrunleriQueryVariables>(SinifUrunleriDocument, options)
}
export type SinifUrunleriQueryHookResult = ReturnType<typeof useSinifUrunleriQuery>
export type SinifUrunleriLazyQueryHookResult = ReturnType<typeof useSinifUrunleriLazyQuery>
export type SinifUrunleriQueryResult = Apollo.QueryResult<SinifUrunleriQuery, SinifUrunleriQueryVariables>
export const SinifUrunleriTestDocument = gql`
  query SinifUrunleriTest($slug: String!, $sinif_id: Int!) {
    okul(slug: $slug) {
      active
      capraz_urun_satis_popupi_varmi
      indirim
      indirimli_fiyat_gosterimi
      id
      isim
      kapida_odeme_tutari
      kapida_odeme_varmi
      kargo_tutar_kosulu
      kargo_tutari
      ogrenci_girisi_varmi
      tab_gosterim
      tekstil_toplu_satis
      logo
      uyari
      sinif(sinif_id: $sinif_id) {
        aktif
        uye_indirim_var
        duyuru_popup
        id
        indirim
        isim
        kampus_adi
        kapali_uyarisi
        ders_kirilimi
        kategori_id
        liste_resmi
        sifre_varmi
        paket_resmi
        sepet_icinde_degistirme_varmi
        sinif_seviyesi
        sira
        urunler_secili_gelsin
        uyari
        sinif_urunleri_test {
          adet
          ders {
            id
            isim
            renk
            ders_sira
          }
          position
          indirimli_birim_fiyat
          indirimsiz_birim_fiyat
          min_adet
          max_adet
          stok
          satin_alindi_mi
          satin_alinan_adet
          sinif_id
          sinif_liste_notu
          urun {
            aciklamalar
            aktif
            dinamik_koli_siparis_aktarma
            urun_kademeleri
            okul_indirimi
            sira
            bilgiler {
              deger
              isim
              tip
            }
            grup {
              id
              isim
              resimler
              sira
            }
            isim
            id
            kargodan_muaf
            kategori {
              id
              isim
              resim
              ust_kategori_id
            }
            kdv_yuzde
            kisa_aciklama
            kitap_kaplama
            marka {
              id
              isim
            }
            resim
            resimler
            sinif_seviyesi
            yazar
          }
          urun_id
          zorunluluk_grubu
        }
      }
    }
  }
`

/**
 * __useSinifUrunleriTestQuery__
 *
 * To run a query within a React component, call `useSinifUrunleriTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinifUrunleriTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinifUrunleriTestQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      sinif_id: // value for 'sinif_id'
 *   },
 * });
 */
export function useSinifUrunleriTestQuery(
  baseOptions: Apollo.QueryHookOptions<SinifUrunleriTestQuery, SinifUrunleriTestQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SinifUrunleriTestQuery, SinifUrunleriTestQueryVariables>(SinifUrunleriTestDocument, options)
}
export function useSinifUrunleriTestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SinifUrunleriTestQuery, SinifUrunleriTestQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SinifUrunleriTestQuery, SinifUrunleriTestQueryVariables>(
    SinifUrunleriTestDocument,
    options,
  )
}
export type SinifUrunleriTestQueryHookResult = ReturnType<typeof useSinifUrunleriTestQuery>
export type SinifUrunleriTestLazyQueryHookResult = ReturnType<typeof useSinifUrunleriTestLazyQuery>
export type SinifUrunleriTestQueryResult = Apollo.QueryResult<SinifUrunleriTestQuery, SinifUrunleriTestQueryVariables>
export const SepetUrunEkleDocument = gql`
  mutation SepetUrunEkle($okulSlug: String!, $urun: SepetUrunuInput) {
    sepetUrunEkle(okul_slug: $okulSlug, urun: $urun)
  }
`
export type SepetUrunEkleMutationFn = Apollo.MutationFunction<SepetUrunEkleMutation, SepetUrunEkleMutationVariables>

/**
 * __useSepetUrunEkleMutation__
 *
 * To run a mutation, you first call `useSepetUrunEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSepetUrunEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sepetUrunEkleMutation, { data, loading, error }] = useSepetUrunEkleMutation({
 *   variables: {
 *      okulSlug: // value for 'okulSlug'
 *      urun: // value for 'urun'
 *   },
 * });
 */
export function useSepetUrunEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<SepetUrunEkleMutation, SepetUrunEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SepetUrunEkleMutation, SepetUrunEkleMutationVariables>(SepetUrunEkleDocument, options)
}
export type SepetUrunEkleMutationHookResult = ReturnType<typeof useSepetUrunEkleMutation>
export type SepetUrunEkleMutationResult = Apollo.MutationResult<SepetUrunEkleMutation>
export type SepetUrunEkleMutationOptions = Apollo.BaseMutationOptions<
  SepetUrunEkleMutation,
  SepetUrunEkleMutationVariables
>
export const GetCategoriesDocument = gql`
  query GetCategories($ust_kategori_id: Int!) {
    urunKategorileri(ust_kategori_id: $ust_kategori_id) {
      id
      isim
      resim
      ust_kategori_id
    }
  }
`

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      ust_kategori_id: // value for 'ust_kategori_id'
 *   },
 * });
 */
export function useGetCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options)
}
export function useGetCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options)
}
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>
export const KategoriveMarkalarDocument = gql`
  query KategoriveMarkalar($kategoriId: Int!) {
    urunKategorisi(id: $kategoriId) {
      kategori {
        id
        isim
        resim
        ust_kategori_id
      }
      markalar {
        id
        isim
      }
    }
  }
`

/**
 * __useKategoriveMarkalarQuery__
 *
 * To run a query within a React component, call `useKategoriveMarkalarQuery` and pass it any options that fit your needs.
 * When your component renders, `useKategoriveMarkalarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKategoriveMarkalarQuery({
 *   variables: {
 *      kategoriId: // value for 'kategoriId'
 *   },
 * });
 */
export function useKategoriveMarkalarQuery(
  baseOptions: Apollo.QueryHookOptions<KategoriveMarkalarQuery, KategoriveMarkalarQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<KategoriveMarkalarQuery, KategoriveMarkalarQueryVariables>(KategoriveMarkalarDocument, options)
}
export function useKategoriveMarkalarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KategoriveMarkalarQuery, KategoriveMarkalarQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<KategoriveMarkalarQuery, KategoriveMarkalarQueryVariables>(
    KategoriveMarkalarDocument,
    options,
  )
}
export type KategoriveMarkalarQueryHookResult = ReturnType<typeof useKategoriveMarkalarQuery>
export type KategoriveMarkalarLazyQueryHookResult = ReturnType<typeof useKategoriveMarkalarLazyQuery>
export type KategoriveMarkalarQueryResult = Apollo.QueryResult<
  KategoriveMarkalarQuery,
  KategoriveMarkalarQueryVariables
>
export const CarprazUrunlerDocument = gql`
  query CarprazUrunler($slug: String!, $filtre: CaprazUrunFiltre = {}) {
    okul(slug: $slug) {
      urunler(filtre: $filtre) {
        urun_sayisi
        capraz_urunler {
          indirimli_birim_fiyat
          indirimsiz_birim_fiyat
          urun {
            aciklamalar
            aktif
            id
            isim
            kargodan_muaf
            kdv_yuzde
            kisa_aciklama
            kitap_kaplama
            marka {
              id
              isim
            }
            resim
            resimler
            sinif_seviyesi
            yazar
            kategori {
              id
              isim
              resim
              ust_kategori_id
            }
          }
        }
      }
    }
  }
`

/**
 * __useCarprazUrunlerQuery__
 *
 * To run a query within a React component, call `useCarprazUrunlerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarprazUrunlerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarprazUrunlerQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      filtre: // value for 'filtre'
 *   },
 * });
 */
export function useCarprazUrunlerQuery(
  baseOptions: Apollo.QueryHookOptions<CarprazUrunlerQuery, CarprazUrunlerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CarprazUrunlerQuery, CarprazUrunlerQueryVariables>(CarprazUrunlerDocument, options)
}
export function useCarprazUrunlerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CarprazUrunlerQuery, CarprazUrunlerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CarprazUrunlerQuery, CarprazUrunlerQueryVariables>(CarprazUrunlerDocument, options)
}
export type CarprazUrunlerQueryHookResult = ReturnType<typeof useCarprazUrunlerQuery>
export type CarprazUrunlerLazyQueryHookResult = ReturnType<typeof useCarprazUrunlerLazyQuery>
export type CarprazUrunlerQueryResult = Apollo.QueryResult<CarprazUrunlerQuery, CarprazUrunlerQueryVariables>
export const SinifSecimSifreDocument = gql`
  mutation SinifSecimSifre($okul_id: Int!, $password: String!, $sinif_id: Int!) {
    sinifSecimSifre(okul_id: $okul_id, password: $password, sinif_id: $sinif_id) {
      statusCode
      message
    }
  }
`
export type SinifSecimSifreMutationFn = Apollo.MutationFunction<
  SinifSecimSifreMutation,
  SinifSecimSifreMutationVariables
>

/**
 * __useSinifSecimSifreMutation__
 *
 * To run a mutation, you first call `useSinifSecimSifreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifSecimSifreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifSecimSifreMutation, { data, loading, error }] = useSinifSecimSifreMutation({
 *   variables: {
 *      okul_id: // value for 'okul_id'
 *      password: // value for 'password'
 *      sinif_id: // value for 'sinif_id'
 *   },
 * });
 */
export function useSinifSecimSifreMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifSecimSifreMutation, SinifSecimSifreMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifSecimSifreMutation, SinifSecimSifreMutationVariables>(SinifSecimSifreDocument, options)
}
export type SinifSecimSifreMutationHookResult = ReturnType<typeof useSinifSecimSifreMutation>
export type SinifSecimSifreMutationResult = Apollo.MutationResult<SinifSecimSifreMutation>
export type SinifSecimSifreMutationOptions = Apollo.BaseMutationOptions<
  SinifSecimSifreMutation,
  SinifSecimSifreMutationVariables
>
export const SinifaUrunEkleDocument = gql`
  mutation sinifaUrunEkle($input: SinifaUrunEkleInput!) {
    sinifaUrunEkle(input: $input) {
      success
      message
      urun_id
      adet
      dersler
    }
  }
`
export type SinifaUrunEkleMutationFn = Apollo.MutationFunction<SinifaUrunEkleMutation, SinifaUrunEkleMutationVariables>

/**
 * __useSinifaUrunEkleMutation__
 *
 * To run a mutation, you first call `useSinifaUrunEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifaUrunEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifaUrunEkleMutation, { data, loading, error }] = useSinifaUrunEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifaUrunEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifaUrunEkleMutation, SinifaUrunEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifaUrunEkleMutation, SinifaUrunEkleMutationVariables>(SinifaUrunEkleDocument, options)
}
export type SinifaUrunEkleMutationHookResult = ReturnType<typeof useSinifaUrunEkleMutation>
export type SinifaUrunEkleMutationResult = Apollo.MutationResult<SinifaUrunEkleMutation>
export type SinifaUrunEkleMutationOptions = Apollo.BaseMutationOptions<
  SinifaUrunEkleMutation,
  SinifaUrunEkleMutationVariables
>
export const FavoriEkleDocument = gql`
  mutation favoriEkle($input: FavoriEkleInput!) {
    favoriEkle(input: $input) {
      message
      success
    }
  }
`
export type FavoriEkleMutationFn = Apollo.MutationFunction<FavoriEkleMutation, FavoriEkleMutationVariables>

/**
 * __useFavoriEkleMutation__
 *
 * To run a mutation, you first call `useFavoriEkleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavoriEkleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favoriEkleMutation, { data, loading, error }] = useFavoriEkleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFavoriEkleMutation(
  baseOptions?: Apollo.MutationHookOptions<FavoriEkleMutation, FavoriEkleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<FavoriEkleMutation, FavoriEkleMutationVariables>(FavoriEkleDocument, options)
}
export type FavoriEkleMutationHookResult = ReturnType<typeof useFavoriEkleMutation>
export type FavoriEkleMutationResult = Apollo.MutationResult<FavoriEkleMutation>
export type FavoriEkleMutationOptions = Apollo.BaseMutationOptions<FavoriEkleMutation, FavoriEkleMutationVariables>
export const SinifDersUrunuNotGuncellemeDocument = gql`
  mutation sinifDersUrunuNotGuncelleme($input: SinifDersUrunuNotGuncellemeInput!) {
    sinifDersUrunuNotGuncelleme(input: $input) {
      message
      success
    }
  }
`
export type SinifDersUrunuNotGuncellemeMutationFn = Apollo.MutationFunction<
  SinifDersUrunuNotGuncellemeMutation,
  SinifDersUrunuNotGuncellemeMutationVariables
>

/**
 * __useSinifDersUrunuNotGuncellemeMutation__
 *
 * To run a mutation, you first call `useSinifDersUrunuNotGuncellemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifDersUrunuNotGuncellemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifDersUrunuNotGuncellemeMutation, { data, loading, error }] = useSinifDersUrunuNotGuncellemeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifDersUrunuNotGuncellemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SinifDersUrunuNotGuncellemeMutation,
    SinifDersUrunuNotGuncellemeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifDersUrunuNotGuncellemeMutation, SinifDersUrunuNotGuncellemeMutationVariables>(
    SinifDersUrunuNotGuncellemeDocument,
    options,
  )
}
export type SinifDersUrunuNotGuncellemeMutationHookResult = ReturnType<typeof useSinifDersUrunuNotGuncellemeMutation>
export type SinifDersUrunuNotGuncellemeMutationResult = Apollo.MutationResult<SinifDersUrunuNotGuncellemeMutation>
export type SinifDersUrunuNotGuncellemeMutationOptions = Apollo.BaseMutationOptions<
  SinifDersUrunuNotGuncellemeMutation,
  SinifDersUrunuNotGuncellemeMutationVariables
>
export const SinifDersUrunuAdetGuncellemeDocument = gql`
  mutation sinifDersUrunuAdetGuncelleme($input: SinifDersUrunuAdetGuncellemeInput!) {
    sinifDersUrunuAdetGuncelleme(input: $input) {
      message
      success
    }
  }
`
export type SinifDersUrunuAdetGuncellemeMutationFn = Apollo.MutationFunction<
  SinifDersUrunuAdetGuncellemeMutation,
  SinifDersUrunuAdetGuncellemeMutationVariables
>

/**
 * __useSinifDersUrunuAdetGuncellemeMutation__
 *
 * To run a mutation, you first call `useSinifDersUrunuAdetGuncellemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifDersUrunuAdetGuncellemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifDersUrunuAdetGuncellemeMutation, { data, loading, error }] = useSinifDersUrunuAdetGuncellemeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifDersUrunuAdetGuncellemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SinifDersUrunuAdetGuncellemeMutation,
    SinifDersUrunuAdetGuncellemeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifDersUrunuAdetGuncellemeMutation, SinifDersUrunuAdetGuncellemeMutationVariables>(
    SinifDersUrunuAdetGuncellemeDocument,
    options,
  )
}
export type SinifDersUrunuAdetGuncellemeMutationHookResult = ReturnType<typeof useSinifDersUrunuAdetGuncellemeMutation>
export type SinifDersUrunuAdetGuncellemeMutationResult = Apollo.MutationResult<SinifDersUrunuAdetGuncellemeMutation>
export type SinifDersUrunuAdetGuncellemeMutationOptions = Apollo.BaseMutationOptions<
  SinifDersUrunuAdetGuncellemeMutation,
  SinifDersUrunuAdetGuncellemeMutationVariables
>
export const SinifDersUrunuSilmeDocument = gql`
  mutation sinifDersUrunuSilme($input: SinifDersUrunuSilmeInput!) {
    sinifDersUrunuSilme(input: $input) {
      message
      success
    }
  }
`
export type SinifDersUrunuSilmeMutationFn = Apollo.MutationFunction<
  SinifDersUrunuSilmeMutation,
  SinifDersUrunuSilmeMutationVariables
>

/**
 * __useSinifDersUrunuSilmeMutation__
 *
 * To run a mutation, you first call `useSinifDersUrunuSilmeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSinifDersUrunuSilmeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sinifDersUrunuSilmeMutation, { data, loading, error }] = useSinifDersUrunuSilmeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSinifDersUrunuSilmeMutation(
  baseOptions?: Apollo.MutationHookOptions<SinifDersUrunuSilmeMutation, SinifDersUrunuSilmeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SinifDersUrunuSilmeMutation, SinifDersUrunuSilmeMutationVariables>(
    SinifDersUrunuSilmeDocument,
    options,
  )
}
export type SinifDersUrunuSilmeMutationHookResult = ReturnType<typeof useSinifDersUrunuSilmeMutation>
export type SinifDersUrunuSilmeMutationResult = Apollo.MutationResult<SinifDersUrunuSilmeMutation>
export type SinifDersUrunuSilmeMutationOptions = Apollo.BaseMutationOptions<
  SinifDersUrunuSilmeMutation,
  SinifDersUrunuSilmeMutationVariables
>
export const DersListesiniOnayaGonderDocument = gql`
  mutation dersListesiniOnayaGonder($input: DersOnaylaInput!) {
    dersListesiniOnayaGonder(input: $input) {
      message
      success
    }
  }
`
export type DersListesiniOnayaGonderMutationFn = Apollo.MutationFunction<
  DersListesiniOnayaGonderMutation,
  DersListesiniOnayaGonderMutationVariables
>

/**
 * __useDersListesiniOnayaGonderMutation__
 *
 * To run a mutation, you first call `useDersListesiniOnayaGonderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDersListesiniOnayaGonderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dersListesiniOnayaGonderMutation, { data, loading, error }] = useDersListesiniOnayaGonderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDersListesiniOnayaGonderMutation(
  baseOptions?: Apollo.MutationHookOptions<DersListesiniOnayaGonderMutation, DersListesiniOnayaGonderMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DersListesiniOnayaGonderMutation, DersListesiniOnayaGonderMutationVariables>(
    DersListesiniOnayaGonderDocument,
    options,
  )
}
export type DersListesiniOnayaGonderMutationHookResult = ReturnType<typeof useDersListesiniOnayaGonderMutation>
export type DersListesiniOnayaGonderMutationResult = Apollo.MutationResult<DersListesiniOnayaGonderMutation>
export type DersListesiniOnayaGonderMutationOptions = Apollo.BaseMutationOptions<
  DersListesiniOnayaGonderMutation,
  DersListesiniOnayaGonderMutationVariables
>
export const OkulDocument = gql`
  query Okul($slug: String!) {
    okul(slug: $slug) {
      id
      slug
      isim
      logo
      email
      banner
      uyari
      genel_uyari
      indirim
      yabanci_dil_indirimi_varmi
      renk1
      renk2
      odeme_varmi
      ogrenci_girisi_varmi
      okul_acilis_tarih
      kargo_tutar_kosulu
      kargo_tutari
      kapida_odeme_varmi
      kapida_odeme_tutari
      stok_bitince_satisa_kapat
      capraz_urun_satisi_varmi
      capraz_urun_satis_popupi_varmi
      indirimli_fiyat_gosterimi
      active
      bannerlari_goster
      alan_resimlerini_goster
      cari_ad
      okul_adres
      urunler_secili_gelsin
      okul_kategorileri
      tekstil_toplu_satis
      kiyafet_varmi
      kitap_varmi
      sezon
      yetkili_ad
      yetkili_soyad
      yetkili_numara
      okul_satis_sozlezmesi
      okul_kisisel_verilerin_korunmasi_kanunu
      okul_musteri_aydinlatma_metni
      okul_musteri_onay_aydinlatma_metni
      okul_tedarikci_aydinlatma_metni
      okul_cagri_merkezi_ses_kaydi_aydinlatma_metni
      okul_gizlilik_ve_cerez_politikasi
      okul_kvkk_basvuru_formu
      bannerlar {
        id
        resim
        resim_mobil
        link
        sira
      }
      alan_resimleri {
        id
        resim
        resim_mobil
        link
        alan
      }
    }
  }
`

/**
 * __useOkulQuery__
 *
 * To run a query within a React component, call `useOkulQuery` and pass it any options that fit your needs.
 * When your component renders, `useOkulQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOkulQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useOkulQuery(baseOptions: Apollo.QueryHookOptions<OkulQuery, OkulQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OkulQuery, OkulQueryVariables>(OkulDocument, options)
}
export function useOkulLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OkulQuery, OkulQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OkulQuery, OkulQueryVariables>(OkulDocument, options)
}
export type OkulQueryHookResult = ReturnType<typeof useOkulQuery>
export type OkulLazyQueryHookResult = ReturnType<typeof useOkulLazyQuery>
export type OkulQueryResult = Apollo.QueryResult<OkulQuery, OkulQueryVariables>
export const SinifListesiVeKategorileriDocument = gql`
  query SinifListesiVeKategorileri($slug: String!, $ust_kategori_id: Int) {
    okul(slug: $slug) {
      sinif_secim_liste(ust_kategori_id: $ust_kategori_id) {
        sinif_id
        kategori_id
        isim
        sifre_var
      }
    }
  }
`

/**
 * __useSinifListesiVeKategorileriQuery__
 *
 * To run a query within a React component, call `useSinifListesiVeKategorileriQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinifListesiVeKategorileriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinifListesiVeKategorileriQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      ust_kategori_id: // value for 'ust_kategori_id'
 *   },
 * });
 */
export function useSinifListesiVeKategorileriQuery(
  baseOptions: Apollo.QueryHookOptions<SinifListesiVeKategorileriQuery, SinifListesiVeKategorileriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SinifListesiVeKategorileriQuery, SinifListesiVeKategorileriQueryVariables>(
    SinifListesiVeKategorileriDocument,
    options,
  )
}
export function useSinifListesiVeKategorileriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SinifListesiVeKategorileriQuery, SinifListesiVeKategorileriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SinifListesiVeKategorileriQuery, SinifListesiVeKategorileriQueryVariables>(
    SinifListesiVeKategorileriDocument,
    options,
  )
}
export type SinifListesiVeKategorileriQueryHookResult = ReturnType<typeof useSinifListesiVeKategorileriQuery>
export type SinifListesiVeKategorileriLazyQueryHookResult = ReturnType<typeof useSinifListesiVeKategorileriLazyQuery>
export type SinifListesiVeKategorileriQueryResult = Apollo.QueryResult<
  SinifListesiVeKategorileriQuery,
  SinifListesiVeKategorileriQueryVariables
>
export const UyeBildirimMailleriDocument = gql`
  query uyeBildirimMailleri($email: String!) {
    uyeBildirimMailleri(email: $email) {
      tarih
      aciklama
    }
  }
`

/**
 * __useUyeBildirimMailleriQuery__
 *
 * To run a query within a React component, call `useUyeBildirimMailleriQuery` and pass it any options that fit your needs.
 * When your component renders, `useUyeBildirimMailleriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUyeBildirimMailleriQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUyeBildirimMailleriQuery(
  baseOptions: Apollo.QueryHookOptions<UyeBildirimMailleriQuery, UyeBildirimMailleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UyeBildirimMailleriQuery, UyeBildirimMailleriQueryVariables>(
    UyeBildirimMailleriDocument,
    options,
  )
}
export function useUyeBildirimMailleriLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UyeBildirimMailleriQuery, UyeBildirimMailleriQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UyeBildirimMailleriQuery, UyeBildirimMailleriQueryVariables>(
    UyeBildirimMailleriDocument,
    options,
  )
}
export type UyeBildirimMailleriQueryHookResult = ReturnType<typeof useUyeBildirimMailleriQuery>
export type UyeBildirimMailleriLazyQueryHookResult = ReturnType<typeof useUyeBildirimMailleriLazyQuery>
export type UyeBildirimMailleriQueryResult = Apollo.QueryResult<
  UyeBildirimMailleriQuery,
  UyeBildirimMailleriQueryVariables
>
export const IadeTalebiOlusturDocument = gql`
  mutation IadeTalebiOlustur($okul_slug: String!, $siparis_id: Int!, $satirlar: [IadeSatiriInput]) {
    iadeTalebiOlustur(okul_slug: $okul_slug, siparis_id: $siparis_id, satirlar: $satirlar) {
      kargo_takip_no
    }
  }
`
export type IadeTalebiOlusturMutationFn = Apollo.MutationFunction<
  IadeTalebiOlusturMutation,
  IadeTalebiOlusturMutationVariables
>

/**
 * __useIadeTalebiOlusturMutation__
 *
 * To run a mutation, you first call `useIadeTalebiOlusturMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIadeTalebiOlusturMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [iadeTalebiOlusturMutation, { data, loading, error }] = useIadeTalebiOlusturMutation({
 *   variables: {
 *      okul_slug: // value for 'okul_slug'
 *      siparis_id: // value for 'siparis_id'
 *      satirlar: // value for 'satirlar'
 *   },
 * });
 */
export function useIadeTalebiOlusturMutation(
  baseOptions?: Apollo.MutationHookOptions<IadeTalebiOlusturMutation, IadeTalebiOlusturMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IadeTalebiOlusturMutation, IadeTalebiOlusturMutationVariables>(
    IadeTalebiOlusturDocument,
    options,
  )
}
export type IadeTalebiOlusturMutationHookResult = ReturnType<typeof useIadeTalebiOlusturMutation>
export type IadeTalebiOlusturMutationResult = Apollo.MutationResult<IadeTalebiOlusturMutation>
export type IadeTalebiOlusturMutationOptions = Apollo.BaseMutationOptions<
  IadeTalebiOlusturMutation,
  IadeTalebiOlusturMutationVariables
>
export const SiparislerimDocument = gql`
  query Siparislerim($page: Int) {
    siparislerim(page: $page) {
      id
      tarih
      toplam_tutar
      durum
    }
  }
`

/**
 * __useSiparislerimQuery__
 *
 * To run a query within a React component, call `useSiparislerimQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiparislerimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiparislerimQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSiparislerimQuery(
  baseOptions?: Apollo.QueryHookOptions<SiparislerimQuery, SiparislerimQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SiparislerimQuery, SiparislerimQueryVariables>(SiparislerimDocument, options)
}
export function useSiparislerimLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SiparislerimQuery, SiparislerimQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SiparislerimQuery, SiparislerimQueryVariables>(SiparislerimDocument, options)
}
export type SiparislerimQueryHookResult = ReturnType<typeof useSiparislerimQuery>
export type SiparislerimLazyQueryHookResult = ReturnType<typeof useSiparislerimLazyQuery>
export type SiparislerimQueryResult = Apollo.QueryResult<SiparislerimQuery, SiparislerimQueryVariables>
export const SiparisDetayDocument = gql`
  query siparisDetay($siparis_id: Int!) {
    siparisDetay(siparis_id: $siparis_id) {
      id
      sinif_id
      tarih
      toplam_tutar
      kargo_ucreti
      durum
      satirlar {
        adet
        birim_fiyat
        durum
        id
        kalan_adet
        kargo_takip_no
        min_adet
        urun {
          id
          isim
          kisa_aciklama
          aciklamalar
          kdv_yuzde
          sinif_seviyesi
          aktif
          yazar
          resim
          kargodan_muaf
          kitap_kaplama
          grup {
            isim
            id
            resimler
          }
          marka {
            id
            isim
          }
          kategori {
            id
            isim
            resim
            ust_kategori_id
          }
          resimler
          bilgiler {
            deger
            isim
            tip
          }
        }
      }
      faturalar {
        id
        durum
        belge_kodu
        gonderi_tarihi
        kargo_takip_no
        kargo_teslim_tarihi
        kargoya_verilme_tarihi
        satirlar {
          urun_id
          urun_adet
          urun_birim_fiyat
          urun_ismi
        }
      }
      satin_alinmayan_urunler {
        urun_id
        urun_ismi
        urun_birim_fiyat
        urun_adet
        ders_ismi
        resim
        resimler
      }
      kredi_karti_pos
      kredi_karti_vade_secenegi
      odeme_tipi
      teslimat_adresi {
        isim
        adres
        ilce
        il
        posta_kodu
        gsm
        tel
      }
      fatura_adresi {
        isim
        adres
        ilce
        il
        posta_kodu
        gsm
        tel
        firma
        vergi_dairesi
        vergi_no
      }
    }
  }
`

/**
 * __useSiparisDetayQuery__
 *
 * To run a query within a React component, call `useSiparisDetayQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiparisDetayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiparisDetayQuery({
 *   variables: {
 *      siparis_id: // value for 'siparis_id'
 *   },
 * });
 */
export function useSiparisDetayQuery(
  baseOptions: Apollo.QueryHookOptions<SiparisDetayQuery, SiparisDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SiparisDetayQuery, SiparisDetayQueryVariables>(SiparisDetayDocument, options)
}
export function useSiparisDetayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SiparisDetayQuery, SiparisDetayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SiparisDetayQuery, SiparisDetayQueryVariables>(SiparisDetayDocument, options)
}
export type SiparisDetayQueryHookResult = ReturnType<typeof useSiparisDetayQuery>
export type SiparisDetayLazyQueryHookResult = ReturnType<typeof useSiparisDetayLazyQuery>
export type SiparisDetayQueryResult = Apollo.QueryResult<SiparisDetayQuery, SiparisDetayQueryVariables>
